export const RENDER_EXTENSION_BASE_HEADER = `
<!DOCTYPE html>
<html
    lang="en"
    dir="ltr"
    class="no-js mac chrome desktop page--no-banner page--logo-main page--smaller-post-purchase-header page--post-purchase card-fields"
>
    <head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, height=device-height, minimum-scale=1.0, user-scalable=0"
        />
        <meta name="referrer" content="origin" />
        <title>Post-purchase - Marlowe&#39;s Roastery - Checkout</title>
        <meta data-browser="chrome" data-browser-major="91" />
        <meta data-body-font-family="Roboto" data-body-font-type="google" />
        <!-- <link
			href="https://cdn.shopify.com/shopifycloud/checkout-web/assets/post-purchase.latest.en.2d0c3fc798f6119b756b.css"
			crossorigin="anonymous"
			rel="stylesheet"
		/> -->
        <style>
            @-webkit-keyframes slide-from-bottom {
                0% {
                    -webkit-transform: translateY(100%);
                    transform: translateY(100%);
                }

                100% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }
            }

            @keyframes slide-from-bottom {
                0% {
                    -webkit-transform: translateY(100%);
                    transform: translateY(100%);
                }

                100% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }
            }

            @-webkit-keyframes slide-from-top {
                0% {
                    -webkit-transform: translateY(-100%);
                    transform: translateY(-100%);
                }

                100% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }
            }

            @keyframes slide-from-top {
                0% {
                    -webkit-transform: translateY(-100%);
                    transform: translateY(-100%);
                }

                100% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }
            }

            @-webkit-keyframes slide-to-bottom {
                0% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }

                100% {
                    -webkit-transform: translateY(100%);
                    transform: translateY(100%);
                }
            }

            @keyframes slide-to-bottom {
                0% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }

                100% {
                    -webkit-transform: translateY(100%);
                    transform: translateY(100%);
                }
            }

            @-webkit-keyframes slide-to-top {
                0% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }

                100% {
                    -webkit-transform: translateY(-100%);
                    transform: translateY(-100%);
                }
            }

            @keyframes slide-to-top {
                0% {
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                }

                100% {
                    -webkit-transform: translateY(-100%);
                    transform: translateY(-100%);
                }
            }

            html,
            body {
                margin: 0;
                width: 100%;
                height: 100%;
            }

            html {
                font-family: sans-serif;
                -ms-text-size-adjust: 100%;
                -webkit-text-size-adjust: 100%;
            }

            body {
                overflow-x: hidden;
            }

            iframe {
                margin: 0;
                padding: 0;
                border: 0;
            }

            b,
            strong {
                font-weight: 500;
            }

            small {
                font-size: 0.875em;
            }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                font-weight: normal;
                margin: 0;
                line-height: 1em;
            }

            p {
                margin: 0;
            }

            sub,
            sup {
                font-size: 0.75em;
                line-height: 0;
                position: relative;
                vertical-align: baseline;
            }

            sup {
                top: -0.5em;
            }

            sub {
                bottom: -0.25em;
            }

            ul,
            ol {
                margin: 0;
                padding: 0;
                list-style-type: none;
            }

            img {
                border: 0;
                max-width: 100%;
            }

            figure {
                margin: 0;
            }

            hr {
                -webkit-box-sizing: content-box;
                box-sizing: content-box;
                height: 0;
            }

            form {
                margin: 0;
            }

            button,
            input,
            optgroup,
            select,
            textarea {
                color: inherit;
                font: inherit;
                margin: 0;
                padding: 0;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                -webkit-font-smoothing: inherit;
                border: none;
                background: transparent;
                line-height: normal;
            }

            button {
                overflow: visible;
            }

            button,
            select {
                text-transform: none;
            }

            button,
            input[type="button"],
            input[type="reset"],
            input[type="submit"] {
                -webkit-appearance: button;
                -moz-appearance: button;
                appearance: button;
                cursor: pointer;
            }

            button:-moz-focusring,
            input[type="button"]:-moz-focusring,
            input[type="reset"]:-moz-focusring,
            input[type="submit"]:-moz-focusring {
                outline: 1px dotted;
            }

            button[disabled],
            input[disabled] {
                cursor: default;
            }

            button::-moz-focus-inner,
            input::-moz-focus-inner {
                border: 0;
                padding: 0;
            }

            input[type="checkbox"],
            input[type="radio"] {
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding: 0;
            }

            input[type="number"]::-webkit-inner-spin-button,
            input[type="number"]::-webkit-outer-spin-button {
                height: auto;
            }

            input[type="search"] {
                -webkit-box-sizing: content-box;
                box-sizing: content-box;
            }

            input[type="search"]::-webkit-search-cancel-button,
            input[type="search"]::-webkit-search-decoration {
                -webkit-appearance: none;
                appearance: none;
            }

            [dir="rtl"] input[id="checkout_email_or_phone"],
            [dir="rtl"]
                input[id^="checkout_shipping_rates_shopify-Local_20Delivery"] {
                unicode-bidi: -moz-plaintext;
                unicode-bidi: plaintext;
                text-align: end;
            }

            fieldset {
                margin: 0;
                padding: 0;
                border: 0;
            }

            legend {
                border: 0;
                padding: 0;
            }

            textarea {
                overflow: auto;
            }

            select::-ms-expand {
                display: none;
            }

            optgroup {
                font-weight: bold;
            }

            option {
                background-color: #fff;
                color: #000;
            }

            table {
                border-collapse: collapse;
                border-spacing: 0;
                font-size: 1em;
            }

            td,
            th {
                padding: 0;
                font-weight: normal;
            }

            .text-container > * + * {
                margin-top: 0.5714285714em;
            }

            .text-container * + .heading-1,
            .text-container * + .heading-2,
            .text-container * + .heading-3 {
                margin-top: 1.4285714286em;
            }

            a,
            .link {
                text-decoration: none;
                color: #1878b9;
                -webkit-transition: color 0.2s ease-in-out;
                transition: color 0.2s ease-in-out;
            }

            a:hover,
            .link:hover {
                color: #146499;
            }

            .link--muted {
                color: inherit;
                text-decoration: underline;
            }

            h1,
            .heading-1 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",
                    "Helvetica Neue", sans-serif;
                font-size: 1.7142857143em;
                line-height: 1.3em;
            }

            @media (min-width: 750px) {
                h1,
                .heading-1 {
                    font-size: 2em;
                }
            }

            h2,
            .heading-2 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",
                    "Helvetica Neue", sans-serif;
                font-size: 1.2857142857em;
                line-height: 1.3em;
            }

            .main h2,
            .main .heading-2 {
                color: #333333;
            }

            .sidebar h2,
            .sidebar .heading-2 {
                color: #333333;
            }

            .content-box h2,
            .content-box .heading-2 {
                color: #333333;
            }

            .default-background h2,
            .default-background .heading-2 {
                color: #333333;
            }

            h3,
            .heading-3 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans",
                    "Helvetica Neue", sans-serif;
                font-size: 1em;
                font-weight: 500;
                line-height: 1.3em;
            }

            .main h3,
            .main .heading-3 {
                color: #333333;
            }

            .sidebar h3,
            .sidebar .heading-3 {
                color: #333333;
            }

            .content-box h3,
            .content-box .heading-3 {
                color: #333333;
            }

            .default-background h3,
            .default-background .heading-3 {
                color: #333333;
            }

            p {
                line-height: 1.5em;
            }

            .emphasis {
                font-weight: 500;
            }

            .main .emphasis {
                color: #333333;
            }

            .sidebar .emphasis {
                color: #333333;
            }

            .content-box .emphasis {
                color: #333333;
            }

            .default-background .emphasis {
                color: #333333;
            }

            .main .small-text .emphasis {
                color: #545454;
            }

            .sidebar .small-text .emphasis {
                color: #545454;
            }

            .content-box .small-text .emphasis {
                color: #545454;
            }

            .default-background .small-text .emphasis {
                color: #545454;
            }

            .small-text {
                font-size: 0.8571428571em;
            }

            .main .small-text {
                color: #737373;
            }

            .sidebar .small-text {
                color: #737373;
            }

            .content-box .small-text {
                color: #737373;
            }

            .default-background .small-text {
                color: #737373;
            }

            .address {
                font-style: normal;
                line-height: 1.5em;
            }

            .address--tight {
                line-height: inherit;
            }

            .pickup-instructions {
                width: 200px;
                white-space: initial;
            }

            @media (max-width: 749px) {
                .hide-on-mobile {
                    display: none;
                }
            }

            @media (min-width: 750px) {
                .show-on-mobile {
                    display: none;
                }
            }

            table {
                width: 100%;
            }

            td,
            th {
                padding-left: 1em;
            }

            td:first-child,
            th:first-child {
                padding-left: 0;
                text-align: left;
            }

            td:last-child,
            th:last-child {
                text-align: right;
            }

            .product-table th,
            .product-table td {
                padding-top: 0;
                padding-bottom: 0;
            }

            .product-table__header th {
                white-space: nowrap;
                font-weight: 500;
                color: #333333;
            }

            .product-table--loose th,
            .product-table--loose td {
                padding-top: 1.1428571429em;
                padding-bottom: 1.1428571429em;
            }

            .product-table--extra-loose th,
            .product-table--extra-loose td {
                padding-top: 1.7142857143em;
                padding-bottom: 1.7142857143em;
            }

            .product-table--bordered td,
            .product-table--bordered th {
                border-bottom: 1px solid #e6e6e6;
            }

            .product-table--bordered tr:last-child td {
                border-bottom: 0;
            }

            .btn {
                cursor: pointer;
                display: inline-block;
                background-color: #1878b9;
                background-clip: border-box;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                border: 1px transparent solid;
                border-radius: 5px;
                color: white;
                font-weight: 500;
                padding: 1.4em 1.7em;
                text-align: center;
                position: relative;
                -webkit-transition: background-color 0.2s ease-in-out,
                    color 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
                transition: background-color 0.2s ease-in-out,
                    color 0.2s ease-in-out, -webkit-box-shadow 0.2s ease-in-out;
                transition: background-color 0.2s ease-in-out,
                    color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
                transition: background-color 0.2s ease-in-out,
                    color 0.2s ease-in-out, box-shadow 0.2s ease-in-out,
                    -webkit-box-shadow 0.2s ease-in-out;
            }

            .btn:hover {
                background-color: #125b8c;
                color: white;
            }

            .btn:active {
                outline: none;
            }

            @media (max-width: 749px) {
                .btn {
                    width: 100%;
                    padding-top: 1.75em;
                    padding-bottom: 1.75em;
                }
            }

            .btn--size-small {
                padding: 0.9285714286em;
            }

            .btn--subdued {
                background-color: transparent;
                border-color: rgba(179, 179, 179, 0.5);
                color: #1878b9;
                font-weight: normal;
            }

            .btn--subdued:hover {
                background-color: rgba(24, 120, 185, 0.06);
                color: #146499;
            }

            .btn--subdued:focus,
            .btn--subdued:active {
                border-color: #125b8c;
                -webkit-box-shadow: 0 0 0 1px #125b8c inset;
                box-shadow: 0 0 0 1px #125b8c inset;
            }

            .btn--loading {
                pointer-events: none;
                cursor: default;
            }

            .btn--loading .btn__content,
            .btn--loading .btn__icon {
                opacity: 0;
            }

            .btn--loading .btn__spinner {
                -webkit-animation: rotate 0.5s linear infinite;
                animation: rotate 0.5s linear infinite;
                opacity: 1;
            }

            .js .main .btn--disabled {
                cursor: default;
                background: #cccccc;
                -webkit-box-shadow: none;
                box-shadow: none;
            }

            .js .sidebar .btn--disabled {
                cursor: default;
                background: #cccccc;
                -webkit-box-shadow: none;
                box-shadow: none;
            }

            .js .content-box .btn--disabled {
                cursor: default;
                background: #cccccc;
                -webkit-box-shadow: none;
                box-shadow: none;
            }

            .js .default-background .btn--disabled {
                cursor: default;
                background: #cccccc;
                -webkit-box-shadow: none;
                box-shadow: none;
            }

            .btn__content {
                position: relative;
                -webkit-transition: opacity 0.3s ease-in-out;
                transition: opacity 0.3s ease-in-out;
            }

            .btn__content--subtitle {
                font-size: 0.8571428571em;
                color: #737373;
            }

            .button-group__button--active .btn__content--subtitle {
                color: #1878b9;
            }

            .btn__icon {
                margin-top: -0.2857142857em;
                margin-bottom: -0.0714285714em;
            }

            .btn__spinner {
                position: absolute;
                top: 50%;
                left: 50%;
                margin-top: -10px;
                margin-left: -10px;
                -webkit-transition: opacity 0.3s ease-in-out;
                transition: opacity 0.3s ease-in-out;
                opacity: 0;
            }

            .hidden {
                display: none !important;
            }

            .visually-hidden {
                border: 0;
                clip: rect(0, 0, 0, 0);
                clip: rect(0 0 0 0);
                width: 2px;
                height: 2px;
                margin: -2px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
            }

            @media (max-width: 749px) {
                .visually-hidden-on-mobile {
                    border: 0;
                    clip: rect(0, 0, 0, 0);
                    clip: rect(0 0 0 0);
                    width: 2px;
                    height: 2px;
                    margin: -2px;
                    overflow: hidden;
                    padding: 0;
                    position: absolute;
                    white-space: nowrap;
                }
            }

            @media (min-width: 1000px) {
                .visually-hidden-on-desktop {
                    border: 0;
                    clip: rect(0, 0, 0, 0);
                    clip: rect(0 0 0 0);
                    width: 2px;
                    height: 2px;
                    margin: -2px;
                    overflow: hidden;
                    padding: 0;
                    position: absolute;
                    white-space: nowrap;
                }
            }

            .visible-on-focus {
                border: 0;
                clip: rect(0, 0, 0, 0);
                clip: rect(0 0 0 0);
                width: 2px;
                height: 2px;
                margin: -2px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
            }

            .visible-on-focus:focus {
                clip: auto;
                height: auto;
                margin: 0;
                overflow: visible;
                position: static;
                width: auto;
                white-space: inherit;
            }

            .no-js .shown-if-js {
                display: none;
            }

            .js .hidden-if-js {
                display: none;
            }

            .js .visually-hidden-if-js {
                border: 0;
                clip: rect(0, 0, 0, 0);
                clip: rect(0 0 0 0);
                width: 2px;
                height: 2px;
                margin: -2px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
            }

            @media (max-width: 749px) {
                .hidden-on-mobile {
                    display: none;
                }
            }

            @media (min-width: 750px) {
                .shown-on-mobile {
                    display: none;
                }
            }

            .no-margin {
                margin: 0 !important;
            }

            @media (min-width: 750px) and (max-width: 999px) {
                .hidden-on-tablet {
                    display: none;
                }
            }

            @media (max-width: 749px) and (min-width: 1000px) {
                .shown-on-tablet {
                    display: none;
                }
            }

            @media (min-width: 1000px) {
                .hidden-on-desktop {
                    display: none;
                }
            }

            @media (max-width: 999px) {
                .shown-on-desktop {
                    display: none;
                }
            }

            @media (min-width: 750px) {
                .sms-marketing-fieldset {
                    padding-left: 1.75em;
                }
            }

            .sms-marketing-disclaimer {
                margin-top: 0;
            }

            .tooltip {
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                position: absolute;
                bottom: 80%;
                right: -0.3333333333em;
                width: 180px;
                margin: 0 0 5px 0;
                padding: 0.75em 1em;
                border-radius: 4px;
                white-space: normal;
                font-size: 0.8571428571em;
                font-style: normal;
                text-align: center;
                color: #fff;
                display: block;
                z-index: 200;
                -webkit-transition: all 0.3s cubic-bezier(0.3, 0, 0, 1);
                transition: all 0.3s cubic-bezier(0.3, 0, 0, 1);
                -webkit-transform: rotateX(20deg) scale(0.8);
                transform: rotateX(20deg) scale(0.8);
                -webkit-transform-origin: 90% 120%;
                transform-origin: 90% 120%;
                -webkit-backface-visibility: hidden;
                background-color: rgba(51, 51, 51, 0.9);
                visibility: hidden;
                opacity: 0;
            }

            .tooltip:after {
                content: "";
                position: absolute;
                top: 100%;
                right: 18px;
                width: 0;
                border: 6px solid transparent;
                border-top-color: rgba(51, 51, 51, 0.9);
            }

            @media (min-width: 750px) {
                .tooltip {
                    -webkit-transform-origin: center 120%;
                    transform-origin: center 120%;
                    right: 50%;
                    margin-right: -90px;
                }

                .tooltip:after {
                    right: 50%;
                    margin-right: -6px;
                }
            }

            .has-tooltip {
                cursor: pointer;
            }

            .tooltip-container {
                position: relative;
                height: 100%;
                width: 100%;
            }

            .tooltip-container .tooltip-control {
                position: absolute;
                height: 100%;
                width: 100%;
            }

            .tooltip-container.show-tooltip .tooltip,
            .tooltip-container:hover .tooltip,
            .tooltip-container:focus .tooltip,
            .has-tooltip.show-tooltip .tooltip,
            .has-tooltip:hover .tooltip,
            .has-tooltip:focus .tooltip {
                -webkit-transform: rotateX(0deg) scale(1);
                transform: rotateX(0deg) scale(1);
                pointer-events: auto;
                visibility: visible;
                opacity: 1;
            }

            .tooltip--right-align {
                right: -130px;
                bottom: 108%;
            }

            .tooltip--right-align:after {
                right: 130px;
            }

            @media (min-width: 750px) {
                .tooltip--right-align {
                    -webkit-transform-origin: center 120%;
                    transform-origin: center 120%;
                    right: 50%;
                    margin-right: -90px;
                }

                .tooltip--right-align:after {
                    right: 50%;
                    margin-right: -6px;
                }
            }

            .tooltip--vertical-align {
                margin-top: -3px;
            }

            @media (max-width: 999px) {
                .order-summary--transition,
                .order-summary--is-collapsed {
                    overflow: hidden;
                }
            }

            @media (max-width: 999px) {
                .js .order-summary--is-collapsed {
                    height: 0;
                    visibility: hidden;
                }
            }

            .order-summary--transition {
                -webkit-transition: all 0.3s cubic-bezier(0.3, 0, 0, 1);
                transition: all 0.3s cubic-bezier(0.3, 0, 0, 1);
            }

            .order-summary__section {
                padding-top: 1.5em;
                padding-bottom: 1.5em;
            }

            .order-summary__section ~ .order-summary__section {
                border-top: 1px solid rgba(179, 179, 179, 0.34);
            }

            @media (min-width: 1000px) {
                .order-summary__section {
                    -webkit-box-flex: 0;
                    -webkit-flex: 0 0 auto;
                    -ms-flex: 0 0 auto;
                    flex: 0 0 auto;
                }

                .order-summary__section:first-child {
                    padding-top: 0;
                }
            }

            @media (min-width: 1000px) {
                .order-summary__sections {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -webkit-flex-direction: column;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    height: calc(100vh - 8em);
                    width: 100%;
                }

                .no-js .order-summary__sections,
                .no-anyflexbox .order-summary__sections {
                    height: auto;
                }

                .order-summary__section--product-list {
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-flex: 0;
                    -webkit-flex: 0 1 auto;
                    -ms-flex: 0 1 auto;
                    flex: 0 1 auto;
                    min-height: 7em;
                    overflow: hidden;
                    padding: 0;
                    position: relative;
                }

                .order-summary__section--product-list
                    + .order-summary__section {
                    border: 0;
                }

                .order-summary__section--product-list::before,
                .order-summary__section--product-list::after {
                    content: "";
                    display: block;
                    height: 1px;
                    left: 0;
                    position: absolute;
                    -webkit-transition: background-color 0.3s
                        cubic-bezier(0.3, 0, 0, 1);
                    transition: background-color 0.3s cubic-bezier(0.3, 0, 0, 1);
                    width: 100%;
                    z-index: 4;
                }

                .order-summary__section--product-list::before {
                    background-color: transparent;
                    top: 0;
                }

                .order-summary__section--product-list::after {
                    background-color: rgba(179, 179, 179, 0.34);
                    bottom: 0;
                }

                .order-summary__section--product-list .product-table {
                    margin-top: 0.75em;
                    margin-bottom: 1.5em;
                    position: relative;
                    z-index: 1;
                }

                .order-summary__section--has-scroll::before {
                    background-color: rgba(179, 179, 179, 0.34);
                }

                .order-summary__section__content {
                    min-width: 100%;
                    overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                }

                .no-js .order-summary__section__content,
                .no-touchevents .order-summary__section__content {
                    overflow: hidden;
                }

                .no-js .order-summary__section__content:hover,
                .no-js .order-summary__section__content:focus,
                .no-touchevents .order-summary__section__content:hover,
                .no-touchevents .order-summary__section__content:focus {
                    overflow-y: auto;
                }
            }

            .order-summary__scroll-indicator {
                background-color: rgba(51, 51, 51, 0.85);
                border-radius: 2em;
                bottom: 1.5em;
                color: #fff;
                font-size: 0.8571428571em;
                left: 50%;
                opacity: 0;
                padding: 0.6em 1.2em;
                position: absolute;
                -webkit-transform: translateX(-50%) translateY(100%)
                    rotateZ(360deg);
                transform: translateX(-50%) translateY(100%) rotateZ(360deg);
                -webkit-transition: all 0.3s cubic-bezier(0.3, 0, 0, 1);
                transition: all 0.3s cubic-bezier(0.3, 0, 0, 1);
                white-space: nowrap;
                z-index: 2;
            }

            .order-summary__section--is-scrollable
                .order-summary__scroll-indicator {
                opacity: 1;
                -webkit-transform: translateX(-50%) translateY(0)
                    rotateZ(360deg);
                transform: translateX(-50%) translateY(0) rotateZ(360deg);
            }

            .order-summary__section--has-scroll
                .order-summary__scroll-indicator {
                -webkit-transform: translateX(-50%) translateY(-100%)
                    rotateZ(360deg);
                transform: translateX(-50%) translateY(-100%) rotateZ(360deg);
            }

            .order-summary__scroll-indicator .icon-svg {
                margin-left: 0.2142857143em;
                margin-top: -0.2142857143em;
            }

            .order-summary__emphasis {
                font-weight: 500;
            }

            .sidebar .order-summary__emphasis {
                color: #333333;
            }

            .content-box .order-summary__emphasis {
                color: #333333;
            }

            .order-summary__small-text {
                font-size: 0.8571428571em;
            }

            .sidebar .order-summary__small-text {
                color: #737373;
            }

            .content-box .order-summary__small-text {
                color: #737373;
            }

            .total-line th,
            .total-line td {
                padding-top: 0.75em;
            }

            .total-line:first-child th,
            .total-line:first-child td {
                padding-top: 0;
            }

            .content-box .total-line__name {
                color: #737373;
            }

            .total-line__name .reduction-code {
                margin-left: 0.5714285714em;
            }

            .total-line__name--top-aligned {
                vertical-align: top;
            }

            .total-line__price {
                padding-left: 1.5em;
                text-align: right;
                white-space: nowrap;
            }

            .total-line--shipping-policy-link {
                padding-top: 0.25em;
            }

            .total-line__duties-container {
                position: relative;
                display: inline;
            }

            .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                th,
            .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                td,
            .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                th,
            .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                td {
                padding-top: 3em;
                position: relative;
            }

            .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                th::before,
            .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                td::before,
            .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                th::before,
            .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                td::before {
                content: "";
                position: absolute;
                top: 1.5em;
                left: 0;
                width: 100%;
                height: 1px;
            }

            .sidebar
                .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                th::before,
            .sidebar
                .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                td::before,
            .sidebar
                .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                th::before,
            .sidebar
                .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                td::before {
                background-color: rgba(179, 179, 179, 0.34);
            }

            .content-box
                .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                th::before,
            .content-box
                .total-line-table__tbody
                + .total-line-table__tbody
                .total-line:first-child
                td::before,
            .content-box
                .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                th::before,
            .content-box
                .total-line-table__tbody
                + .total-line-table__footer
                .total-line:first-child
                td::before {
                background-color: rgba(179, 179, 179, 0.34);
            }

            .payment-due-label__total {
                font-size: 1.1428571429em;
            }

            .sidebar .payment-due-label__total {
                color: #333333;
            }

            .content-box .payment-due-label__total {
                color: #333333;
            }

            .payment-due-label__taxes {
                display: block;
            }

            .sidebar .payment-due-label__taxes {
                color: #737373;
            }

            .content-box .payment-due-label__taxes {
                color: #737373;
            }

            .payment-due__price {
                font-size: 1.7142857143em;
                font-weight: 500;
                letter-spacing: -0.04em;
                line-height: 1em;
            }

            .sidebar .payment-due__price {
                color: #333333;
            }

            .content-box .payment-due__price {
                color: #333333;
            }

            .payment-due__currency {
                font-size: 0.8571428571em;
                vertical-align: 0.2em;
                margin-right: 0.5em;
            }

            .sidebar .payment-due__currency {
                color: #737373;
            }

            .content-box .payment-due__currency {
                color: #737373;
            }

            .total-line--shipping-details,
            .total-line--recurring-total,
            .total-line--recurring-total-details {
                color: #737373;
            }

            .shipping_details__controls {
                outline: none;
            }

            .recurring_total__controls {
                cursor: pointer;
            }

            .shipping_details__controls.expand svg,
            .recurring_total__controls.expand .recurring_total__chevron-icon {
                -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
            }

            .shipping_details__controls.collapse svg,
            .recurring_total__controls.collapse .recurring_total__chevron-icon {
                -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
            }

            .recurring-total-label {
                white-space: nowrap;
                vertical-align: top;
            }

            .recurring-total-label-content {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
            }

            .recurring-total-product-name,
            .recurring-total-detail {
                white-space: normal;
                vertical-align: top;
            }

            .recurring-total-tooltip-wrapper {
                display: block;
                width: 1.4285714286rem;
            }

            .recurring-total-tooltip-wrapper .tooltip {
                right: inherit;
                left: -3.3333333333em;
                -webkit-transform-origin: 15% 90%;
                transform-origin: 15% 90%;
                margin-bottom: 1.1428571429rem;
            }

            .recurring-total-tooltip-wrapper .tooltip:after {
                left: 2.8571428571rem;
            }

            @media (min-width: 750px) {
                .recurring-total-tooltip-wrapper .tooltip {
                    -webkit-transform-origin: center 120%;
                    transform-origin: center 120%;
                    right: 50%;
                    margin-right: -90px;
                    left: inherit;
                }

                .recurring-total-tooltip-wrapper .tooltip:after {
                    right: 50%;
                    margin-right: -6px;
                }

                .recurring-total-tooltip-wrapper .tooltip:after {
                    left: inherit;
                }
            }

            .product td {
                padding-top: 1em;
            }

            .product:first-child td {
                padding-top: 0;
            }

            .product-thumbnail {
                width: 4.6em;
                height: 4.6em;
                border-radius: 8px;
                background: #fff;
                position: relative;
            }

            .product-thumbnail::after {
                content: "";
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                border-radius: 8px;
                border: 1px rgba(0, 0, 0, 0.1) solid;
                z-index: 2;
            }

            .product-thumbnail--small {
                width: 3em;
                height: 3em;
                border-radius: 6px;
            }

            .product-thumbnail--small::after {
                border-radius: 6px;
            }

            .product-thumbnail--small .product-thumbnail__wrapper {
                border-radius: 6px;
            }

            .product-thumbnail__wrapper {
                width: 100%;
                height: 100%;
                position: relative;
                overflow: hidden;
                border-radius: 8px;
                z-index: 1;
            }

            .product-thumbnail__image {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }

            .product-thumbnail__quantity {
                font-size: 0.8571428571em;
                font-weight: 500;
                line-height: 1.75em;
                white-space: nowrap;
                text-align: center;
                border-radius: 1.75em;
                background-color: rgba(114, 114, 114, 0.9);
                color: #fff;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                min-width: 1.75em;
                height: 1.75em;
                padding: 0 0.5833333333em;
                position: absolute;
                right: -0.75em;
                top: -0.75em;
                z-index: 3;
            }

            .product__price {
                white-space: nowrap;
            }

            .product__description__name,
            .product__description__variant,
            .product__description__property {
                display: block;
            }

            .product__description {
                text-align: left;
                width: 100%;
            }

            .product__description .reduction-code {
                margin-top: 0.2857142857em;
            }

            .product__description .reduction-code__text {
                color: #737373;
            }

            .product__description__name {
                width: 1em;
                min-width: 100%;
            }

            .product__status {
                position: relative;
                white-space: nowrap;
            }

            .product__status--sold-out {
                color: #e22120;
            }

            .product__status__icon {
                vertical-align: -0.15em;
            }

            .product__clear-btn {
                position: absolute;
                right: -2.5em;
                top: 50%;
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }

            @media (max-width: 749px) {
                .product__clear-btn {
                    display: none;
                }
            }

            html {
                background-color: rgba(0, 0, 0, 0.5);
                font-size: 14px;
                -webkit-transition: background-color 0.5s
                    cubic-bezier(0.2, 0.9, 0.3, 1);
                transition: background-color 0.5s cubic-bezier(0.2, 0.9, 0.3, 1);
                will-change: background-color;
            }

            .html--invisible {
                background-color: rgba(0, 0, 0, 0);
            }

            .dialog {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                position: fixed;
                bottom: 0;
                left: 0;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding: 1.1428571429rem;
                max-height: calc(100vh);
                width: 100%;
                background-color: #fff;
                color: #545454;
                -webkit-animation: slide-from-bottom 0.5s
                    cubic-bezier(0.2, 0.9, 0.3, 1) forwards;
                animation: slide-from-bottom 0.5s cubic-bezier(0.2, 0.9, 0.3, 1)
                    forwards;
                will-change: transform;
            }

            @media (min-height: 319px) {
                .dialog {
                    max-height: calc(100vh - 10%);
                }
            }

            @media (min-width: 750px) {
                .dialog {
                    bottom: initial;
                    left: 50%;
                    top: 1.7142857143rem;
                    border-radius: 8px;
                    margin-left: -16.4285714286rem;
                    padding: 1.7142857143rem;
                    max-height: calc(100vh - (1.7142857143rem * 2));
                    max-width: 32.8571428571rem;
                    -webkit-animation: slide-from-top 0.5s
                        cubic-bezier(0.2, 0.9, 0.3, 1) forwards;
                    animation: slide-from-top 0.5s
                        cubic-bezier(0.2, 0.9, 0.3, 1) forwards;
                }
            }

            .dialog::after {
                content: "";
                height: 100%;
                width: 100%;
                position: absolute;
                left: 0;
                top: 0;
                z-index: -1;
                -webkit-box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.36);
                box-shadow: 0 20px 50px 0 rgba(0, 0, 0, 0.36);
                border-radius: 8px;
            }

            .dialog--invisible {
                -webkit-animation: slide-to-bottom 0.5s
                    cubic-bezier(0.2, 0.9, 0.3, 1) forwards;
                animation: slide-to-bottom 0.5s cubic-bezier(0.2, 0.9, 0.3, 1)
                    forwards;
            }

            .dialog--invisible::after {
                -webkit-box-shadow: none;
                box-shadow: none;
            }

            @media (min-width: 750px) {
                .dialog--invisible {
                    -webkit-animation: slide-to-top 0.5s
                        cubic-bezier(0.2, 0.9, 0.3, 1) forwards;
                    animation: slide-to-top 0.5s cubic-bezier(0.2, 0.9, 0.3, 1)
                        forwards;
                    top: -1.7142857143rem;
                }
            }

            .dialog__icon {
                padding: 0.5714285714rem 0;
            }

            @media (min-width: 750px) {
                .dialog__icon {
                    padding-top: 0;
                }
            }

            .dialog__icon__svg {
                display: block;
                height: 40px;
                width: 40px;
                margin: 0 auto;
            }

            .dialog__title {
                color: #333;
                font-size: 1.2857142857rem;
                font-weight: normal;
                line-height: 1.5;
                text-align: center;
                margin-bottom: 0.5714285714rem;
            }

            .dialog__error-description {
                margin-bottom: 1.1428571429rem;
                text-align: center;
            }

            .dialog__error-list-container {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                margin-bottom: 1.7142857143rem;
                overflow: hidden;
                position: relative;
            }

            .dialog__error-list-container::before,
            .dialog__error-list-container::after {
                background-color: transparent;
                content: "";
                display: block;
                left: 0;
                position: absolute;
                -webkit-transition: background-color 0.5s
                    cubic-bezier(0.2, 0.9, 0.3, 1);
                transition: background-color 0.5s cubic-bezier(0.2, 0.9, 0.3, 1);
                width: 100%;
                height: 1px;
                z-index: 4;
            }

            .dialog__error-list-container::before {
                top: 0;
            }

            .dialog__error-list-container::after {
                bottom: 0;
            }

            .dialog__error-list-container--scroll-bottom::after {
                background-color: rgba(175, 175, 175, 0.34);
            }

            .dialog__error-list-container--scroll-vertical::before,
            .dialog__error-list-container--scroll-vertical::after {
                background-color: rgba(175, 175, 175, 0.34);
            }

            .dialog__error-list-scrollable {
                overflow-x: hidden;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
            }

            .product-table {
                margin: 0.7142857143rem 0rem;
            }

            .dialog__error-list {
                margin: 0 auto;
            }

            .dialog__error-list__item {
                line-height: 1.5;
                margin-bottom: 0.5714285714rem;
                padding: 0 1.1428571429rem;
            }

            .dialog__error-list__item::before {
                content: "";
                border-color: transparent transparent transparent #e22120;
                border-style: solid;
                border-width: 3px 0 3px 5px;
                height: 0;
                width: 0;
                margin: 0.5rem 0rem 0rem -1rem;
                float: left;
            }

            .dialog__error-list__item:last-child {
                margin-bottom: 0;
            }

            .dialog__footer {
                text-align: center;
            }
        </style>
        <style>
            @-webkit-keyframes fade-in {
                0% {
                    opacity: 0;
                    visibility: hidden;
                }

                100% {
                    opacity: 1;
                    visibility: visible;
                }
            }

            @keyframes fade-in {
                0% {
                    opacity: 0;
                    visibility: hidden;
                }

                100% {
                    opacity: 1;
                    visibility: visible;
                }
            }

            @-webkit-keyframes fade-out {
                0% {
                    opacity: 1;
                    visibility: visible;
                }

                100% {
                    opacity: 0;
                    visibility: hidden;
                }
            }

            @keyframes fade-out {
                0% {
                    opacity: 1;
                    visibility: visible;
                }

                100% {
                    opacity: 0;
                    visibility: hidden;
                }
            }

            @-webkit-keyframes rotate {
                0% {
                    -webkit-transform: rotate(0);
                    transform: rotate(0);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                }
            }

            @keyframes rotate {
                0% {
                    -webkit-transform: rotate(0);
                    transform: rotate(0);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                    transform: rotate(360deg);
                }
            }

            @-webkit-keyframes draw-stroke {
                100% {
                    stroke-dashoffset: 0;
                }
            }

            @keyframes draw-stroke {
                100% {
                    stroke-dashoffset: 0;
                }
            }

            @-webkit-keyframes checkmark-fill {
                100% {
                    -webkit-box-shadow: inset 0px 0px 0px 30px #1878b9;
                    box-shadow: inset 0px 0px 0px 30px #1878b9;
                }
            }

            @keyframes checkmark-fill {
                100% {
                    -webkit-box-shadow: inset 0px 0px 0px 30px #1878b9;
                    box-shadow: inset 0px 0px 0px 30px #1878b9;
                }
            }

            @-webkit-keyframes scale-up-bounce {
                0% {
                    opacity: 0;
                    -webkit-transform: scale(0.5);
                    transform: scale(0.5);
                }

                40% {
                    -webkit-transform: scale(1.1);
                    transform: scale(1.1);
                }

                100% {
                    opacity: 1;
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @keyframes scale-up-bounce {
                0% {
                    opacity: 0;
                    -webkit-transform: scale(0.5);
                    transform: scale(0.5);
                }

                40% {
                    -webkit-transform: scale(1.1);
                    transform: scale(1.1);
                }

                100% {
                    opacity: 1;
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @-webkit-keyframes scale-up-bounce-spring {
                0% {
                    opacity: 0;
                    -webkit-transform: scale(0.5);
                    transform: scale(0.5);
                }

                20% {
                    -webkit-transform: scale(1.15);
                    transform: scale(1.15);
                }

                50% {
                    opacity: 1;
                    -webkit-transform: scale(0.95);
                    transform: scale(0.95);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @keyframes scale-up-bounce-spring {
                0% {
                    opacity: 0;
                    -webkit-transform: scale(0.5);
                    transform: scale(0.5);
                }

                20% {
                    -webkit-transform: scale(1.15);
                    transform: scale(1.15);
                }

                50% {
                    opacity: 1;
                    -webkit-transform: scale(0.95);
                    transform: scale(0.95);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @-webkit-keyframes scale-down-bounce {
                0% {
                    opacity: 1;
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }

                20% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                100% {
                    opacity: 0;
                    -webkit-transform: scale(0.5);
                    transform: scale(0.5);
                }
            }

            @keyframes scale-down-bounce {
                0% {
                    opacity: 1;
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }

                20% {
                    -webkit-transform: scale(1.05);
                    transform: scale(1.05);
                }

                100% {
                    opacity: 0;
                    -webkit-transform: scale(0.5);
                    transform: scale(0.5);
                }
            }

            @-webkit-keyframes scale-up {
                0% {
                    -webkit-transform: scale(0);
                    transform: scale(0);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @keyframes scale-up {
                0% {
                    -webkit-transform: scale(0);
                    transform: scale(0);
                }

                100% {
                    -webkit-transform: scale(1);
                    transform: scale(1);
                }
            }

            @-webkit-keyframes pulse {
                0% {
                    -webkit-box-shadow: 0 0 0 0 rgba(24, 120, 185, 0.5);
                    box-shadow: 0 0 0 0 rgba(24, 120, 185, 0.5);
                }

                50% {
                    -webkit-box-shadow: 0 0 0 15px rgba(24, 120, 185, 0);
                    box-shadow: 0 0 0 15px rgba(24, 120, 185, 0);
                }
            }

            @keyframes pulse {
                0% {
                    -webkit-box-shadow: 0 0 0 0 rgba(24, 120, 185, 0.5);
                    box-shadow: 0 0 0 0 rgba(24, 120, 185, 0.5);
                }

                50% {
                    -webkit-box-shadow: 0 0 0 15px rgba(24, 120, 185, 0);
                    box-shadow: 0 0 0 15px rgba(24, 120, 185, 0);
                }
            }

            @-webkit-keyframes wobble {
                0%,
                100% {
                    -webkit-transform: rotate(10deg);
                    transform: rotate(10deg);
                }

                50% {
                    -webkit-transform: rotate(-10deg);
                    transform: rotate(-10deg);
                }
            }

            @keyframes wobble {
                0%,
                100% {
                    -webkit-transform: rotate(10deg);
                    transform: rotate(10deg);
                }

                50% {
                    -webkit-transform: rotate(-10deg);
                    transform: rotate(-10deg);
                }
            }

            @-webkit-keyframes modal-open {
                0% {
                    opacity: 0;
                    -webkit-transform: translateY(20%);
                    transform: translateY(20%);
                }

                100% {
                    opacity: 1;
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                    visibility: visible;
                }
            }

            @keyframes modal-open {
                0% {
                    opacity: 0;
                    -webkit-transform: translateY(20%);
                    transform: translateY(20%);
                }

                100% {
                    opacity: 1;
                    -webkit-transform: translateY(0);
                    transform: translateY(0);
                    visibility: visible;
                }
            }

            @-webkit-keyframes modal-close {
                0% {
                    opacity: 1;
                    visibility: visible;
                }

                100% {
                    opacity: 0;
                    -webkit-transform: translateY(20%);
                    transform: translateY(20%);
                }
            }

            @keyframes modal-close {
                0% {
                    opacity: 1;
                    visibility: visible;
                }

                100% {
                    opacity: 0;
                    -webkit-transform: translateY(20%);
                    transform: translateY(20%);
                }
            }

            @media (max-width: 999px) {
                .quirks-fix--ios-instagram {
                    height: auto;
                    min-height: 100%;
                    padding-bottom: 250px;
                }
            }

            html,
            body {
                margin: 0;
                width: 100%;
                height: 100%;
            }

            html {
                font-family: sans-serif;
                -ms-text-size-adjust: 100%;
                -webkit-text-size-adjust: 100%;
            }

            body {
                overflow-x: hidden;
            }

            iframe {
                margin: 0;
                padding: 0;
                border: 0;
            }

            b,
            strong {
                font-weight: 500;
            }

            small {
                font-size: 0.875em;
            }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6 {
                font-weight: normal;
                margin: 0;
                line-height: 1em;
            }

            p {
                margin: 0;
            }

            sub,
            sup {
                font-size: 0.75em;
                line-height: 0;
                position: relative;
                vertical-align: baseline;
            }

            sup {
                top: -0.5em;
            }

            sub {
                bottom: -0.25em;
            }

            ul,
            ol {
                margin: 0;
                padding: 0;
                list-style-type: none;
            }

            img {
                border: 0;
                max-width: 100%;
            }

            figure {
                margin: 0;
            }

            hr {
                -webkit-box-sizing: content-box;
                box-sizing: content-box;
                height: 0;
            }

            form {
                margin: 0;
            }

            button,
            input,
            optgroup,
            select,
            textarea {
                color: inherit;
                font: inherit;
                margin: 0;
                padding: 0;
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                -webkit-font-smoothing: inherit;
                border: none;
                background: transparent;
                line-height: normal;
            }

            button {
                overflow: visible;
            }

            button,
            select {
                text-transform: none;
            }

            button,
            input[type="button"],
            input[type="reset"],
            input[type="submit"] {
                -webkit-appearance: button;
                -moz-appearance: button;
                appearance: button;
                cursor: pointer;
            }

            button:-moz-focusring,
            input[type="button"]:-moz-focusring,
            input[type="reset"]:-moz-focusring,
            input[type="submit"]:-moz-focusring {
                outline: 1px dotted;
            }

            button[disabled],
            input[disabled] {
                cursor: default;
            }

            button::-moz-focus-inner,
            input::-moz-focus-inner {
                border: 0;
                padding: 0;
            }

            input[type="checkbox"],
            input[type="radio"] {
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding: 0;
            }

            input[type="number"]::-webkit-inner-spin-button,
            input[type="number"]::-webkit-outer-spin-button {
                height: auto;
            }

            input[type="search"] {
                -webkit-box-sizing: content-box;
                box-sizing: content-box;
            }

            input[type="search"]::-webkit-search-cancel-button,
            input[type="search"]::-webkit-search-decoration {
                -webkit-appearance: none;
                appearance: none;
            }

            [dir="rtl"] input[id="checkout_email_or_phone"],
            [dir="rtl"]
                input[id^="checkout_shipping_rates_shopify-Local_20Delivery"] {
                unicode-bidi: -moz-plaintext;
                unicode-bidi: plaintext;
                text-align: end;
            }

            fieldset {
                margin: 0;
                padding: 0;
                border: 0;
            }

            legend {
                border: 0;
                padding: 0;
            }

            textarea {
                overflow: auto;
            }

            select::-ms-expand {
                display: none;
            }

            optgroup {
                font-weight: bold;
            }

            option {
                background-color: #fff;
                color: #000;
            }

            table {
                border-collapse: collapse;
                border-spacing: 0;
                font-size: 1em;
            }

            td,
            th {
                padding: 0;
                font-weight: normal;
            }

            .banner {
                padding: 1.5em 0;
                background: transparent;
                background-size: cover;
                display: none;
            }

            .page--logo-sidebar .banner {
                background: transparent;
            }

            @media (max-width: 999px) {
                .banner {
                    display: block;
                }
            }

            .page--banner .banner {
                display: block;
            }

            @media (min-width: 1000px) {
                .page--banner .banner {
                    padding-top: 6em;
                    padding-bottom: 2em;
                }
            }

            .skip-to-content {
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                background-color: white;
                text-align: center;
                border: 0;
                clip: rect(1px, 1px, 1px, 1px);
                clip: rect(1px 1px 1px 1px);
                width: 1px;
                height: 1px;
                position: absolute;
                overflow: hidden;
                margin: -1px;
            }

            .skip-to-content:focus {
                margin: 0;
                padding: 1em;
                clip: auto;
                width: 100%;
                height: auto;
                overflow: visible;
            }

            .hidden {
                display: none !important;
            }

            .visually-hidden {
                border: 0;
                clip: rect(0, 0, 0, 0);
                clip: rect(0 0 0 0);
                width: 2px;
                height: 2px;
                margin: -2px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
            }

            @media (max-width: 749px) {
                .visually-hidden-on-mobile {
                    border: 0;
                    clip: rect(0, 0, 0, 0);
                    clip: rect(0 0 0 0);
                    width: 2px;
                    height: 2px;
                    margin: -2px;
                    overflow: hidden;
                    padding: 0;
                    position: absolute;
                    white-space: nowrap;
                }
            }

            @media (min-width: 1000px) {
                .visually-hidden-on-desktop {
                    border: 0;
                    clip: rect(0, 0, 0, 0);
                    clip: rect(0 0 0 0);
                    width: 2px;
                    height: 2px;
                    margin: -2px;
                    overflow: hidden;
                    padding: 0;
                    position: absolute;
                    white-space: nowrap;
                }
            }

            .visible-on-focus {
                border: 0;
                clip: rect(0, 0, 0, 0);
                clip: rect(0 0 0 0);
                width: 2px;
                height: 2px;
                margin: -2px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
            }

            .visible-on-focus:focus {
                clip: auto;
                height: auto;
                margin: 0;
                overflow: visible;
                position: static;
                width: auto;
                white-space: inherit;
            }

            .no-js .shown-if-js {
                display: none;
            }

            .js .hidden-if-js {
                display: none;
            }

            .js .visually-hidden-if-js {
                border: 0;
                clip: rect(0, 0, 0, 0);
                clip: rect(0 0 0 0);
                width: 2px;
                height: 2px;
                margin: -2px;
                overflow: hidden;
                padding: 0;
                position: absolute;
                white-space: nowrap;
            }

            @media (max-width: 749px) {
                .hidden-on-mobile {
                    display: none;
                }
            }

            @media (min-width: 750px) {
                .shown-on-mobile {
                    display: none;
                }
            }

            .no-margin {
                margin: 0 !important;
            }

            @media (min-width: 750px) and (max-width: 999px) {
                .hidden-on-tablet {
                    display: none;
                }
            }

            @media (max-width: 749px) and (min-width: 1000px) {
                .shown-on-tablet {
                    display: none;
                }
            }

            @media (min-width: 1000px) {
                .hidden-on-desktop {
                    display: none;
                }
            }

            @media (max-width: 999px) {
                .shown-on-desktop {
                    display: none;
                }
            }

            @media (min-width: 750px) {
                .sms-marketing-fieldset {
                    padding-left: 1.75em;
                }
            }

            .sms-marketing-disclaimer {
                margin-top: 0;
            }

            body {
                font-size: 14px;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                line-height: 1.3em;
                overflow-wrap: break-word;
                word-wrap: break-word;
                word-break: break-word;
                -webkit-font-smoothing: subpixel-antialiased;
            }

            @media (max-width: 749px) {
                .main {
                    padding-top: 1.5em;
                }

                .main__content {
                    padding-bottom: 1.5em;
                }
            }

            @media (min-width: 750px) {
                .main {
                    padding-top: 1.5em;
                }

                .main__content {
                    padding-bottom: 4em;
                }
            }

            @media (max-width: 999px) {
                .breadcrumb {
                    padding-bottom: 1.5em;
                }
            }

            @media (min-width: 1000px) {
                .page--no-banner .main,
                .page--no-banner .sidebar {
                    padding-top: 4em;
                }

                .page--banner .main,
                .page--banner .sidebar {
                    padding-top: 2em;
                }

                .main__header {
                    padding-bottom: 2em;
                }

                .sidebar__logo {
                    margin-bottom: 2em;
                }

                .page--logo-main .breadcrumb {
                    margin-top: 1em;
                }
            }

            .has-modal body {
                overflow: hidden;
            }

            .modal-backdrop {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.6);
                z-index: 1000;
                visibility: hidden;
                opacity: 0;
                -webkit-backdrop-filter: blur(6px);
                backdrop-filter: blur(6px);
            }

            .js .modal-backdrop {
                -webkit-transition: opacity 0.5s ease-in-out,
                    visibility 0.5s ease-in-out,
                    background-color 0.5s ease-in-out;
                transition: opacity 0.5s ease-in-out,
                    visibility 0.5s ease-in-out,
                    background-color 0.5s ease-in-out;
            }

            .modal-backdrop.modal-backdrop--centered-content {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
            }

            .modal-backdrop.modal-backdrop--is-closing.modal-backdrop--fade-out-white {
                background-color: rgba(255, 255, 255, 0.8);
            }

            .modal-backdrop--is-visible {
                visibility: visible;
                overflow: auto;
                -webkit-overflow-scrolling: touch;
                opacity: 1;
            }

            .modal {
                background: #fff;
                -webkit-box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
                box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
                color: #545454;
                min-height: auto;
                visibility: hidden;
            }

            @media (min-width: 750px) {
                .modal {
                    border-radius: 8px;
                    margin: 4em auto 5%;
                    max-width: 60em;
                    min-height: initial;
                    width: 90%;
                }
            }

            .modal.modal--centered {
                -webkit-align-self: center;
                -ms-flex-item-align: center;
                align-self: center;
            }

            .modal-backdrop--is-visible .modal {
                -webkit-animation: modal-open 0.5s
                    cubic-bezier(0.2, 0.9, 0.3, 1);
                animation: modal-open 0.5s cubic-bezier(0.2, 0.9, 0.3, 1);
                -webkit-animation-fill-mode: forwards;
                animation-fill-mode: forwards;
                -webkit-animation-delay: 0.2s;
                animation-delay: 0.2s;
            }

            .no-cssanimations .modal-backdrop--is-visible .modal {
                visibility: visible;
            }

            .modal-backdrop--is-closing .modal {
                -webkit-animation: modal-close 0.25s ease-in-out;
                animation: modal-close 0.25s ease-in-out;
                -webkit-animation-fill-mode: forwards;
                animation-fill-mode: forwards;
            }

            .modal__header {
                padding: 1.5em;
            }

            @media (min-width: 750px) {
                .modal__header {
                    padding: 1.5em 2.5em;
                }
            }

            .modal__header {
                border-bottom: 1px solid #e6e6e6;
                zoom: 1;
            }

            .modal__header:after,
            .modal__header:before {
                content: "";
                display: table;
            }

            .modal__header:after {
                clear: both;
            }

            .display-table .modal__header {
                display: table;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                width: 100%;
            }

            .modal__header__title {
                color: #333333;
            }

            .display-table .modal__header__title {
                display: table-cell;
                width: 100%;
            }

            .display-table .modal__header__title:only-child {
                display: block;
            }

            .no-js .modal__header__title,
            .no-display-table .modal__header__title {
                float: left;
            }

            .modal__content {
                padding: 1.5em;
            }

            @media (min-width: 750px) {
                .modal__content {
                    padding: 2.5em;
                }

                .modal__content p {
                    font-size: 1.1428571429em;
                }
            }

            .modal__iframe {
                width: 100%;
            }

            .modal__loading-icon {
                display: block;
                margin: 1em auto;
            }

            .modal__close {
                position: relative;
                -webkit-transition: color 0.3s cubic-bezier(0.3, 0, 0, 1);
                transition: color 0.3s cubic-bezier(0.3, 0, 0, 1);
                vertical-align: middle;
                padding-left: 0.75em;
                white-space: nowrap;
            }

            .display-table .modal__close {
                display: table-cell;
            }

            .no-js .modal__close,
            .no-display-table .modal__close {
                float: right;
            }

            .modal__close-button {
                color: #737373;
            }

            .modal__close-button:hover {
                color: #545454;
            }

            .checkout-zero .text-container > * + * {
                margin-top: 0.5714285714em;
            }

            .checkout-zero .text-container * + .heading-1,
            .checkout-zero .text-container * + .heading-2,
            .checkout-zero .text-container * + .heading-3 {
                margin-top: 1.4285714286em;
            }

            .checkout-zero a,
            .checkout-zero .link {
                text-decoration: none;
                color: #1878b9;
                -webkit-transition: color 0.2s ease-in-out;
                transition: color 0.2s ease-in-out;
            }

            .checkout-zero a:hover,
            .checkout-zero .link:hover {
                color: #146499;
            }

            .checkout-zero .link--muted {
                color: inherit;
                text-decoration: underline;
            }

            .checkout-zero h1,
            .checkout-zero .heading-1 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                font-size: 1.7142857143em;
                line-height: 1.3em;
            }

            @media (min-width: 750px) {
                .checkout-zero h1,
                .checkout-zero .heading-1 {
                    font-size: 2em;
                }
            }

            .checkout-zero h2,
            .checkout-zero .heading-2 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                font-size: 1.2857142857em;
                line-height: 1.3em;
            }

            .main .checkout-zero h2,
            .main .checkout-zero .heading-2 {
                color: #333333;
            }

            .sidebar .checkout-zero h2,
            .sidebar .checkout-zero .heading-2 {
                color: #323232;
            }

            .content-box .checkout-zero h2,
            .content-box .checkout-zero .heading-2 {
                color: #333333;
            }

            .default-background .checkout-zero h2,
            .default-background .checkout-zero .heading-2 {
                color: #333333;
            }

            .checkout-zero h3,
            .checkout-zero .heading-3 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                font-size: 1em;
                font-weight: 500;
                line-height: 1.3em;
            }

            .main .checkout-zero h3,
            .main .checkout-zero .heading-3 {
                color: #333333;
            }

            .sidebar .checkout-zero h3,
            .sidebar .checkout-zero .heading-3 {
                color: #323232;
            }

            .content-box .checkout-zero h3,
            .content-box .checkout-zero .heading-3 {
                color: #333333;
            }

            .default-background .checkout-zero h3,
            .default-background .checkout-zero .heading-3 {
                color: #333333;
            }

            .checkout-zero p {
                line-height: 1.5em;
            }

            .checkout-zero .emphasis {
                font-weight: 500;
            }

            .main .checkout-zero .emphasis {
                color: #333333;
            }

            .sidebar .checkout-zero .emphasis {
                color: #323232;
            }

            .content-box .checkout-zero .emphasis {
                color: #333333;
            }

            .default-background .checkout-zero .emphasis {
                color: #333333;
            }

            .main .small-text .checkout-zero .emphasis {
                color: #545454;
            }

            .sidebar .small-text .checkout-zero .emphasis {
                color: #535353;
            }

            .content-box .small-text .checkout-zero .emphasis {
                color: #545454;
            }

            .default-background .small-text .checkout-zero .emphasis {
                color: #545454;
            }

            .checkout-zero .small-text {
                font-size: 0.8571428571em;
            }

            .main .checkout-zero .small-text {
                color: #737373;
            }

            .sidebar .checkout-zero .small-text {
                color: #717171;
            }

            .content-box .checkout-zero .small-text {
                color: #737373;
            }

            .default-background .checkout-zero .small-text {
                color: #737373;
            }

            .checkout-zero .address {
                font-style: normal;
                line-height: 1.5em;
            }

            .checkout-zero .address--tight {
                line-height: inherit;
            }

            .checkout-zero .pickup-instructions {
                width: 200px;
                white-space: initial;
            }

            @media (max-width: 749px) {
                .checkout-zero .hide-on-mobile {
                    display: none;
                }
            }

            @media (min-width: 750px) {
                .checkout-zero .show-on-mobile {
                    display: none;
                }
            }

            .checkout-zero .icon-svg {
                display: inline-block;
                vertical-align: middle;
                fill: currentColor;
            }

            .checkout-zero .icon-symbols {
                display: none;
            }

            .checkout-zero .icon-svg--block {
                display: block;
            }

            .checkout-zero .icon-svg--color-accent {
                color: #1878b9;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-black {
                color: #000;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-blue {
                color: #1990c6;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-gray {
                color: #9b9b9b;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-gray-dark {
                color: #595959;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-gray-light {
                color: #959595;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-red {
                color: #ce4549;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-white {
                color: #fff;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--color-yellow {
                color: #e7a321;
                fill: currentColor;
            }

            .main .checkout-zero .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .sidebar .checkout-zero .icon-svg--color-adaptive-lighter {
                color: #8f8f8f;
                fill: currentColor;
            }

            .content-box .checkout-zero .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .default-background
                .checkout-zero
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .btn .checkout-zero .icon-svg--color-adaptive-lighter {
                color: #e3a3a3;
                fill: currentColor;
            }

            .main .checkout-zero .field__icon .icon-svg--color-adaptive-lighter,
            .main
                .checkout-zero
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .sidebar
                .checkout-zero
                .field__icon
                .icon-svg--color-adaptive-lighter,
            .sidebar
                .checkout-zero
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .content-box
                .checkout-zero
                .field__icon
                .icon-svg--color-adaptive-lighter,
            .content-box
                .checkout-zero
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .default-background
                .checkout-zero
                .field__icon
                .icon-svg--color-adaptive-lighter,
            .default-background
                .checkout-zero
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .main .checkout-zero .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .sidebar .checkout-zero .icon-svg--color-adaptive-light {
                color: #717171;
                fill: currentColor;
            }

            .content-box .checkout-zero .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .default-background .checkout-zero .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .btn .checkout-zero .icon-svg--color-adaptive-light {
                color: #e3a3a3;
                fill: currentColor;
            }

            .main .checkout-zero .field__icon .icon-svg--color-adaptive-light,
            .main .checkout-zero .field__caret .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .sidebar
                .checkout-zero
                .field__icon
                .icon-svg--color-adaptive-light,
            .sidebar
                .checkout-zero
                .field__caret
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .content-box
                .checkout-zero
                .field__icon
                .icon-svg--color-adaptive-light,
            .content-box
                .checkout-zero
                .field__caret
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .default-background
                .checkout-zero
                .field__icon
                .icon-svg--color-adaptive-light,
            .default-background
                .checkout-zero
                .field__caret
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .checkout-zero .icon-svg--size-10 {
                width: 10px;
                height: 10px;
            }

            .checkout-zero .icon-svg--size-12 {
                width: 12px;
                height: 12px;
            }

            .checkout-zero .icon-svg--size-14 {
                width: 14px;
                height: 14px;
            }

            .checkout-zero .icon-svg--size-16 {
                width: 16px;
                height: 16px;
            }

            .checkout-zero .icon-svg--size-18 {
                width: 18px;
                height: 18px;
            }

            .checkout-zero .icon-svg--size-24 {
                width: 24px;
                height: 24px;
            }

            .checkout-zero .icon-svg--size-32 {
                width: 32px;
                height: 32px;
            }

            .checkout-zero .icon-svg--size-48 {
                width: 48px;
                height: 48px;
            }

            .checkout-zero .icon-svg--size-64 {
                width: 64px;
                height: 64px;
            }

            .checkout-zero .icon-svg--size-184 {
                width: 184px;
                height: 184px;
            }

            .checkout-zero .icon-svg--rotate-180 {
                -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
            }

            .checkout-zero .icon-svg--inline-before {
                margin-right: 0.2857142857em;
            }

            .checkout-zero .icon-svg--inline-after {
                margin-left: 0.2857142857em;
            }

            .checkout-zero .icon-svg--flip-horizontal {
                -webkit-transform: scaleX(-1);
                transform: scaleX(-1);
            }

            .checkout-zero .icon-svg--flip-vertical {
                -webkit-transform: scaleY(-1);
                transform: scaleY(-1);
            }

            .checkout-zero .icon {
                background-position: center center;
                background-repeat: no-repeat;
                display: inline-block;
            }

            .checkout-zero .icon-background--payment-gateways {
                fill: #d9d9d9;
            }

            .checkout-zero .icon-svg--spinner-button {
                width: 20px;
                height: 20px;
            }

            .checkout-zero .icon--free-tag {
                width: 94px;
                height: 46px;
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-small-c89fe2ddc93811e9a3cd1c616fd27fc66e90748260172d38f3332757dd124a10.png);
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-small-5439598929990a936b18a6bf65080248b85b7ae7eca0e37b8b365b6b5138db38.svg),
                    none;
            }

            @media (min-width: 750px) {
                .checkout-zero .icon--free-tag {
                    width: 152px;
                    height: 80px;
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-65a3840efd125a6ce3a6bf2da5ddbfc9d1597f96cdb0eec801b06fd85f464889.png);
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-c2dd504ac09e85e0958c656eb3b00e9bedc4fbaeaaa6031c81b045674cc6b7eb.svg),
                        none;
                }
            }

            .checkout-zero .icon--shopify-pay-primary {
                width: 55px;
                height: 16px;
            }

            .checkout-zero .icon--shopify-pay {
                width: 59px;
                height: 14px;
            }

            .checkout-zero .icon--shopify-pay--dark {
                fill: #000;
            }

            .checkout-zero .icon--shopify-pay--light {
                fill: #fff;
            }

            .checkout-zero .icon--gift-card {
                width: 16px;
                height: 16px;
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/gift-card-123e3d1e90a7cfb1eb75e986ee9ede169b5f402d5b76fb51961c0a44297996fd.png);
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/gift-card-a262d4faf79983ea2372d68228388158c727c7b71b918807c0d8c49eedc632b9.svg),
                    none;
            }

            .checkout-zero .icon--offsite {
                width: 102px;
                height: 52px;
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-small-4670fa5c6b06022d0eb3c0403efeeff014fec796291433ff5c2112efa510ee06.png);
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-small-0d8fd34431b27358e5c54a5ad660f76f8d628fad88320450d799287a8654982f.svg),
                    none;
            }

            @media (min-width: 750px) {
                .checkout-zero .icon--offsite {
                    width: 163px;
                    height: 81px;
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-f3d4a55eef203adc0d1d16841d8ff45acad31063a7d2f6bcf0167ef475e668d5.png);
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-908d79d8d532f6af67d7cc99244ede733729c29379c349ee015fbcea71fd8274.svg),
                        none;
                }
            }

            .checkout-zero .icon-svg--re-order {
                width: 20px;
                height: 16px;
            }

            .checkout-zero .icon-svg--spinner {
                -webkit-animation: fade-in 0.5s ease-in-out,
                    rotate 0.5s linear infinite;
                animation: fade-in 0.5s ease-in-out, rotate 0.5s linear infinite;
            }

            .checkout-zero .icon-svg--clickable {
                -webkit-transition: color 0.2s ease-in-out;
                transition: color 0.2s ease-in-out;
            }

            .checkout-zero .icon-svg--clickable:hover {
                color: #146499;
            }

            .checkout-zero .icon-svg--center {
                position: absolute;
                left: 50%;
                right: 50%;
                -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
            }

            .checkout-zero .logo {
                display: block;
                vertical-align: middle;
            }

            .checkout-zero .logo__text {
                color: #333333;
            }

            .checkout-zero .logo__image {
                display: inline-block;
            }

            .checkout-zero .logo--right {
                text-align: right;
            }

            .checkout-zero .logo--center {
                text-align: center;
            }

            .checkout-zero .logo__image--small {
                max-height: 2.1428571429em;
            }

            .checkout-zero .logo__image--medium {
                max-height: 2.8571428571em;
            }

            .checkout-zero .logo__image--large {
                max-height: 3.5714285714em;
            }

            @media (min-width: 1000px) {
                .checkout-zero .logo__image--small {
                    max-height: 2.8571428571em;
                }

                .checkout-zero .logo__image--medium {
                    max-height: 4.2857142857em;
                }

                .checkout-zero .logo__image--large {
                    max-height: 5.7142857143em;
                }
            }

            .checkout-zero .section--express-checkout-selection-group-test {
                display: table;
                width: 100%;
            }

            @media (min-width: 750px) {
                .checkout-zero
                    .section--express-checkout-selection-group-test
                    .section--contact-information {
                    display: table-header-group;
                }
            }

            @media (min-width: 750px) {
                .checkout-zero
                    .section--express-checkout-selection-group-test
                    .section--express-checkout-selection {
                    padding-top: 3em !important;
                    display: block;
                }
            }

            .checkout-zero .section--express-checkout-selection-group-control {
                display: table;
                width: 100%;
            }

            .checkout-zero
                .section--express-checkout-selection-group-control
                .section--contact-information {
                display: table-header-group;
            }

            .checkout-zero
                .section--express-checkout-selection-group-control
                .section--express-checkout-selection {
                padding-top: 3em !important;
            }

            .notice + .checkout-zero .step__sections {
                margin-top: 1.5em;
            }

            @media (min-width: 750px) {
                .notice + .checkout-zero .step__sections {
                    margin-top: 2.5em;
                }
            }

            .checkout-zero .step__sections + form {
                padding-top: 2em;
            }

            @media (min-width: 1000px) {
                .checkout-zero .step__sections + form {
                    padding-top: 0;
                }
            }

            .checkout-zero .section__delivery-option-group {
                padding-top: 3em;
            }

            .checkout-zero .section__delivery-option-group:first-child {
                padding-top: 0;
            }

            .checkout-zero .section {
                position: relative;
                padding-top: 2em;
            }

            @media (min-width: 750px) {
                .checkout-zero .section {
                    padding-top: 3em;
                }
            }

            .checkout-zero .section:first-child {
                padding-top: 0;
            }

            .checkout-zero .section--half-spacing-top,
            .checkout-zero .section--half-spacing-bottom + .section {
                padding-top: 1em;
            }

            @media (min-width: 750px) {
                .checkout-zero .section--half-spacing-top,
                .checkout-zero .section--half-spacing-bottom + .section {
                    padding-top: 1.5em;
                }
            }

            .checkout-zero .section__header {
                position: relative;
                margin-bottom: 1em;
            }

            @media (min-width: 750px) {
                .checkout-zero .section__header {
                    margin-bottom: 1.5em;
                }
            }

            .checkout-zero .section__title {
                color: #333333;
            }

            .checkout-zero .section__text {
                margin-top: 0.25em;
            }

            .checkout-zero .section__hanging-icon {
                margin-bottom: 1em;
            }

            @media (min-width: 750px) and (max-width: 999px) {
                .checkout-zero .section__hanging-icon {
                    position: absolute;
                    right: 100%;
                    top: -0.4em;
                    margin-right: 1.5em;
                }
            }

            @media (min-width: 1300px) {
                .checkout-zero .section__hanging-icon {
                    position: absolute;
                    right: 100%;
                    top: -0.4em;
                    margin-right: 1.5em;
                }
            }

            .checkout-zero .section__content {
                zoom: 1;
            }

            .checkout-zero .section__content:after,
            .checkout-zero .section__content:before {
                content: "";
                display: table;
            }

            .checkout-zero .section__content:after {
                clear: both;
            }

            .checkout-zero .section__content__text {
                margin-top: 0.75em;
            }

            .checkout-zero .section__content__policy {
                margin-top: 1em;
            }

            .checkout-zero .section__content__column {
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                margin-top: 2em;
            }

            .checkout-zero .section__content__column:first-of-type {
                margin-top: 0;
            }

            @media (min-width: 750px) {
                .checkout-zero .section__content__column {
                    margin-top: 0;
                    float: left;
                }
            }

            @media (min-width: 750px) {
                .checkout-zero .section__content__column--half {
                    padding: 0 0.75em;
                    width: 50%;
                }

                .checkout-zero .section__content__column--half:first-child {
                    padding-left: 0;
                }

                .checkout-zero .section__content__column--half:last-child {
                    padding-right: 0;
                }
            }

            @media (min-width: 750px) {
                .checkout-zero .section__content__column--thirds {
                    padding: 0 0.75em;
                    width: 33.3333333333%;
                }

                .checkout-zero .section__content__column--thirds:first-child {
                    padding-left: 0;
                }

                .checkout-zero .section__content__column--thirds:last-child {
                    padding-right: 0;
                }
            }

            .checkout-zero .section__footer {
                zoom: 1;
                margin-top: 1em;
            }

            .checkout-zero .section__footer:after,
            .checkout-zero .section__footer:before {
                content: "";
                display: table;
            }

            .checkout-zero .section__footer:after {
                clear: both;
            }

            @media (min-width: 750px) {
                .checkout-zero .section__footer {
                    margin-top: 1.5em;
                }
            }

            @media (min-width: 750px) and (max-width: 999px) {
                .checkout-zero .section--page-title {
                    margin-top: 1em;
                }
            }

            .checkout-zero
                .section--subscription-agreement
                .field--error
                input {
                border-color: #e22120;
                -webkit-box-shadow: 0 0 0 1px #e22120;
                box-shadow: 0 0 0 1px #e22120;
            }

            .checkout-zero .breadcrumb {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-flex-wrap: wrap;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
            }

            .checkout-zero .breadcrumb__item {
                display: inline;
                font-size: 0.8571428571em;
                color: #737373;
            }

            .anyflexbox .checkout-zero .breadcrumb__item {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
            }

            .checkout-zero .breadcrumb__item--current {
                font-weight: 500;
                color: #333333;
            }

            .checkout-zero .breadcrumb__chevron-icon {
                margin: 0 0.6428571429em;
            }

            .checkout-zero .breadcrumb--center {
                text-align: center;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -ms-flex-pack: center;
                justify-content: center;
            }

            .checkout-zero .main__footer {
                padding: 1em 0;
                border-top: 1px solid #e6e6e6;
            }

            .checkout-zero .copyright-text {
                font-size: 0.8571428571em;
                color: #737373;
            }

            .checkout-zero .copyright-text--left {
                text-align: left;
            }

            .checkout-zero .copyright-text--center {
                text-align: center;
            }

            .checkout-zero .copyright-text--right {
                text-align: right;
            }

            .checkout-zero .policy-list {
                zoom: 1;
                text-align: center;
            }

            .checkout-zero .policy-list:after,
            .checkout-zero .policy-list:before {
                content: "";
                display: table;
            }

            .checkout-zero .policy-list:after {
                clear: both;
            }

            .checkout-zero .policy-list__item {
                float: left;
                font-size: 0.8571428571em;
                margin-right: 1.5em;
                margin-bottom: 0.5em;
            }

            .checkout-zero .policy-list__item--left {
                float: left;
                margin-right: 1.5em;
            }

            .checkout-zero .policy-list__item--center {
                display: inline;
                float: none;
                margin-left: 0.75em;
                margin-right: 0.75em;
            }

            .checkout-zero .policy-list__item--right {
                float: right;
                margin-left: 1.5em;
                margin-right: 0;
            }

            .modal-backdrop .text-container > * + * {
                margin-top: 0.5714285714em;
            }

            .modal-backdrop .text-container * + .heading-1,
            .modal-backdrop .text-container * + .heading-2,
            .modal-backdrop .text-container * + .heading-3 {
                margin-top: 1.4285714286em;
            }

            .modal-backdrop a,
            .modal-backdrop .link {
                text-decoration: none;
                color: #1878b9;
                -webkit-transition: color 0.2s ease-in-out;
                transition: color 0.2s ease-in-out;
            }

            .modal-backdrop a:hover,
            .modal-backdrop .link:hover {
                color: #146499;
            }

            .modal-backdrop .link--muted {
                color: inherit;
                text-decoration: underline;
            }

            .modal-backdrop h1,
            .modal-backdrop .heading-1 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                font-size: 1.7142857143em;
                line-height: 1.3em;
            }

            @media (min-width: 750px) {
                .modal-backdrop h1,
                .modal-backdrop .heading-1 {
                    font-size: 2em;
                }
            }

            .modal-backdrop h2,
            .modal-backdrop .heading-2 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                font-size: 1.2857142857em;
                line-height: 1.3em;
            }

            .main .modal-backdrop h2,
            .main .modal-backdrop .heading-2 {
                color: #333333;
            }

            .sidebar .modal-backdrop h2,
            .sidebar .modal-backdrop .heading-2 {
                color: #323232;
            }

            .content-box .modal-backdrop h2,
            .content-box .modal-backdrop .heading-2 {
                color: #333333;
            }

            .default-background .modal-backdrop h2,
            .default-background .modal-backdrop .heading-2 {
                color: #333333;
            }

            .modal-backdrop h3,
            .modal-backdrop .heading-3 {
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                font-size: 1em;
                font-weight: 500;
                line-height: 1.3em;
            }

            .main .modal-backdrop h3,
            .main .modal-backdrop .heading-3 {
                color: #333333;
            }

            .sidebar .modal-backdrop h3,
            .sidebar .modal-backdrop .heading-3 {
                color: #323232;
            }

            .content-box .modal-backdrop h3,
            .content-box .modal-backdrop .heading-3 {
                color: #333333;
            }

            .default-background .modal-backdrop h3,
            .default-background .modal-backdrop .heading-3 {
                color: #333333;
            }

            .modal-backdrop p {
                line-height: 1.5em;
            }

            .modal-backdrop .emphasis {
                font-weight: 500;
            }

            .main .modal-backdrop .emphasis {
                color: #333333;
            }

            .sidebar .modal-backdrop .emphasis {
                color: #323232;
            }

            .content-box .modal-backdrop .emphasis {
                color: #333333;
            }

            .default-background .modal-backdrop .emphasis {
                color: #333333;
            }

            .main .small-text .modal-backdrop .emphasis {
                color: #545454;
            }

            .sidebar .small-text .modal-backdrop .emphasis {
                color: #535353;
            }

            .content-box .small-text .modal-backdrop .emphasis {
                color: #545454;
            }

            .default-background .small-text .modal-backdrop .emphasis {
                color: #545454;
            }

            .modal-backdrop .small-text {
                font-size: 0.8571428571em;
            }

            .main .modal-backdrop .small-text {
                color: #737373;
            }

            .sidebar .modal-backdrop .small-text {
                color: #717171;
            }

            .content-box .modal-backdrop .small-text {
                color: #737373;
            }

            .default-background .modal-backdrop .small-text {
                color: #737373;
            }

            .modal-backdrop .address {
                font-style: normal;
                line-height: 1.5em;
            }

            .modal-backdrop .address--tight {
                line-height: inherit;
            }

            .modal-backdrop .pickup-instructions {
                width: 200px;
                white-space: initial;
            }

            @media (max-width: 749px) {
                .modal-backdrop .hide-on-mobile {
                    display: none;
                }
            }

            @media (min-width: 750px) {
                .modal-backdrop .show-on-mobile {
                    display: none;
                }
            }

            .modal-backdrop .icon-svg {
                display: inline-block;
                vertical-align: middle;
                fill: currentColor;
            }

            .modal-backdrop .icon-symbols {
                display: none;
            }

            .modal-backdrop .icon-svg--block {
                display: block;
            }

            .modal-backdrop .icon-svg--color-accent {
                color: #1878b9;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-black {
                color: #000;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-blue {
                color: #1990c6;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-gray {
                color: #9b9b9b;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-gray-dark {
                color: #595959;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-gray-light {
                color: #959595;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-red {
                color: #ce4549;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-white {
                color: #fff;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--color-yellow {
                color: #e7a321;
                fill: currentColor;
            }

            .main .modal-backdrop .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .sidebar .modal-backdrop .icon-svg--color-adaptive-lighter {
                color: #8f8f8f;
                fill: currentColor;
            }

            .content-box .modal-backdrop .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .default-background
                .modal-backdrop
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .btn .modal-backdrop .icon-svg--color-adaptive-lighter {
                color: #e3a3a3;
                fill: currentColor;
            }

            .main
                .modal-backdrop
                .field__icon
                .icon-svg--color-adaptive-lighter,
            .main
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .sidebar
                .modal-backdrop
                .field__icon
                .icon-svg--color-adaptive-lighter,
            .sidebar
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .content-box
                .modal-backdrop
                .field__icon
                .icon-svg--color-adaptive-lighter,
            .content-box
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .default-background
                .modal-backdrop
                .field__icon
                .icon-svg--color-adaptive-lighter,
            .default-background
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-lighter {
                color: #919191;
                fill: currentColor;
            }

            .main .modal-backdrop .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .sidebar .modal-backdrop .icon-svg--color-adaptive-light {
                color: #717171;
                fill: currentColor;
            }

            .content-box .modal-backdrop .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .default-background
                .modal-backdrop
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .btn .modal-backdrop .icon-svg--color-adaptive-light {
                color: #e3a3a3;
                fill: currentColor;
            }

            .main .modal-backdrop .field__icon .icon-svg--color-adaptive-light,
            .main
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .sidebar
                .modal-backdrop
                .field__icon
                .icon-svg--color-adaptive-light,
            .sidebar
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .content-box
                .modal-backdrop
                .field__icon
                .icon-svg--color-adaptive-light,
            .content-box
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .default-background
                .modal-backdrop
                .field__icon
                .icon-svg--color-adaptive-light,
            .default-background
                .modal-backdrop
                .field__caret
                .icon-svg--color-adaptive-light {
                color: #737373;
                fill: currentColor;
            }

            .modal-backdrop .icon-svg--size-10 {
                width: 10px;
                height: 10px;
            }

            .modal-backdrop .icon-svg--size-12 {
                width: 12px;
                height: 12px;
            }

            .modal-backdrop .icon-svg--size-14 {
                width: 14px;
                height: 14px;
            }

            .modal-backdrop .icon-svg--size-16 {
                width: 16px;
                height: 16px;
            }

            .modal-backdrop .icon-svg--size-18 {
                width: 18px;
                height: 18px;
            }

            .modal-backdrop .icon-svg--size-24 {
                width: 24px;
                height: 24px;
            }

            .modal-backdrop .icon-svg--size-32 {
                width: 32px;
                height: 32px;
            }

            .modal-backdrop .icon-svg--size-48 {
                width: 48px;
                height: 48px;
            }

            .modal-backdrop .icon-svg--size-64 {
                width: 64px;
                height: 64px;
            }

            .modal-backdrop .icon-svg--size-184 {
                width: 184px;
                height: 184px;
            }

            .modal-backdrop .icon-svg--rotate-180 {
                -webkit-transform: rotate(180deg);
                transform: rotate(180deg);
            }

            .modal-backdrop .icon-svg--inline-before {
                margin-right: 0.2857142857em;
            }

            .modal-backdrop .icon-svg--inline-after {
                margin-left: 0.2857142857em;
            }

            .modal-backdrop .icon-svg--flip-horizontal {
                -webkit-transform: scaleX(-1);
                transform: scaleX(-1);
            }

            .modal-backdrop .icon-svg--flip-vertical {
                -webkit-transform: scaleY(-1);
                transform: scaleY(-1);
            }

            .modal-backdrop .icon {
                background-position: center center;
                background-repeat: no-repeat;
                display: inline-block;
            }

            .modal-backdrop .icon-background--payment-gateways {
                fill: #d9d9d9;
            }

            .modal-backdrop .icon-svg--spinner-button {
                width: 20px;
                height: 20px;
            }

            .modal-backdrop .icon--free-tag {
                width: 94px;
                height: 46px;
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-small-c89fe2ddc93811e9a3cd1c616fd27fc66e90748260172d38f3332757dd124a10.png);
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-small-5439598929990a936b18a6bf65080248b85b7ae7eca0e37b8b365b6b5138db38.svg),
                    none;
            }

            @media (min-width: 750px) {
                .modal-backdrop .icon--free-tag {
                    width: 152px;
                    height: 80px;
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-65a3840efd125a6ce3a6bf2da5ddbfc9d1597f96cdb0eec801b06fd85f464889.png);
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/free-tag-c2dd504ac09e85e0958c656eb3b00e9bedc4fbaeaaa6031c81b045674cc6b7eb.svg),
                        none;
                }
            }

            .modal-backdrop .icon--shopify-pay-primary {
                width: 55px;
                height: 16px;
            }

            .modal-backdrop .icon--shopify-pay {
                width: 59px;
                height: 14px;
            }

            .modal-backdrop .icon--shopify-pay--dark {
                fill: #000;
            }

            .modal-backdrop .icon--shopify-pay--light {
                fill: #fff;
            }

            .modal-backdrop .icon--gift-card {
                width: 16px;
                height: 16px;
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/gift-card-123e3d1e90a7cfb1eb75e986ee9ede169b5f402d5b76fb51961c0a44297996fd.png);
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/gift-card-a262d4faf79983ea2372d68228388158c727c7b71b918807c0d8c49eedc632b9.svg),
                    none;
            }

            .modal-backdrop .icon--offsite {
                width: 102px;
                height: 52px;
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-small-4670fa5c6b06022d0eb3c0403efeeff014fec796291433ff5c2112efa510ee06.png);
                background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-small-0d8fd34431b27358e5c54a5ad660f76f8d628fad88320450d799287a8654982f.svg),
                    none;
            }

            @media (min-width: 750px) {
                .modal-backdrop .icon--offsite {
                    width: 163px;
                    height: 81px;
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-f3d4a55eef203adc0d1d16841d8ff45acad31063a7d2f6bcf0167ef475e668d5.png);
                    background-image: url(//cdn.shopify.com/shopifycloud/shopify/assets/checkout/offsite-908d79d8d532f6af67d7cc99244ede733729c29379c349ee015fbcea71fd8274.svg),
                        none;
                }
            }

            .modal-backdrop .icon-svg--re-order {
                width: 20px;
                height: 16px;
            }

            .modal-backdrop .icon-svg--spinner {
                -webkit-animation: fade-in 0.5s ease-in-out,
                    rotate 0.5s linear infinite;
                animation: fade-in 0.5s ease-in-out, rotate 0.5s linear infinite;
            }

            .modal-backdrop .icon-svg--clickable {
                -webkit-transition: color 0.2s ease-in-out;
                transition: color 0.2s ease-in-out;
            }

            .modal-backdrop .icon-svg--clickable:hover {
                color: #146499;
            }

            .modal-backdrop .icon-svg--center {
                position: absolute;
                left: 50%;
                right: 50%;
                -webkit-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
            }

            .checkout-zero .os-header {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-flex-wrap: wrap;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -ms-flex-align: center;
                align-items: center;
                margin: 0;
            }

            .page--smaller-post-purchase-header .checkout-zero .os-header {
                -webkit-box-align: start;
                -webkit-align-items: flex-start;
                -ms-flex-align: start;
                align-items: flex-start;
            }

            .checkout-zero .os-header__heading {
                -webkit-box-flex: 1;
                -webkit-flex-grow: 1;
                -ms-flex-positive: 1;
                flex-grow: 1;
            }

            .checkout-zero .os-order-number {
                display: block;
                margin-bottom: 0.25em;
            }

            .page--smaller-post-purchase-header
                .checkout-zero
                .os-order-number {
                display: none;
            }

            .checkout-zero .os-header__title {
                font-size: 1.5714285714em;
                font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
                    Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
                    "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
                line-height: 1.3em;
                color: #333333;
            }

            .page--smaller-post-purchase-header
                .checkout-zero
                .os-header__title {
                font-size: 1.1428571429em;
            }

            .checkout-zero .os-header__hanging-icon {
                margin-right: 0.75em;
                stroke: #1878b9;
                fill: #ffffff;
                -webkit-transform: translateY(-16px);
                transform: translateY(-16px);
            }

            @media (min-width: 750px) and (max-width: 999px) {
                .checkout-zero .os-header__hanging-icon {
                    position: absolute;
                    right: 100%;
                    top: 0px;
                    margin-right: 1.5em;
                    -webkit-transform: initial;
                    transform: initial;
                }
            }

            @media (min-width: 1300px) {
                .checkout-zero .os-header__hanging-icon {
                    position: absolute;
                    right: 100%;
                    top: 0px;
                    margin-right: 1.5em;
                    -webkit-transform: initial;
                    transform: initial;
                }
            }

            .checkout-zero .os-header__hanging-icon--smaller {
                margin-right: 0.8571428571em;
                fill: #1878b9;
            }

            @media (min-width: 1000px) {
                .checkout-zero .os-header__hanging-icon--smaller {
                    position: absolute;
                    right: 100%;
                    top: 0px;
                }
            }

            .page--smaller-post-purchase-header
                .checkout-zero
                .logo__image--small,
            .page--smaller-post-purchase-header
                .checkout-zero
                .logo__image--medium,
            .page--smaller-post-purchase-header
                .checkout-zero
                .logo__image--large {
                max-height: 2.2857142857em;
            }

            .escape-hatch-action {
                cursor: pointer;
                line-height: 30px;
            }

            .escape-hatch {
                padding-bottom: 30px;
                border-bottom: 1px #e6e6e6 solid;
            }

            .page--smaller-post-purchase-header .escape-hatch {
                padding-bottom: 12px;
            }

            body {
                color: #545454;
                background-color: #ffffff;
            }

            .content {
                overflow: hidden;
            }

            .wrap {
                display: block;
                margin: 0 auto;
                max-width: 40em;
                zoom: 1;
            }

            .wrap:after,
            .wrap:before {
                content: "";
                display: table;
            }

            .wrap:after {
                clear: both;
            }

            @media (max-width: 999px) {
                .wrap {
                    width: 100%;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    padding: 0 1em;
                }
            }

            @media (min-width: 1000px) {
                .wrap {
                    padding: 0 5%;
                    width: 90%;
                    max-width: 78.5714285714em;
                }
            }

            .main .logo {
                display: none;
            }

            @media (min-width: 1000px) {
                .page--logo-main .main .logo {
                    display: block;
                }
            }

            .main__emphasis {
                font-weight: 500;
                color: #333333;
            }

            .main__small-text {
                font-size: 0.8571428571em;
                color: #737373;
            }

            .page--smaller-post-purchase-header .main {
                padding: 0;
            }

            @media (min-width: 1000px) {
                .page--smaller-post-purchase-header .main {
                    padding: 8px 0 12px 0;
                }
            }

            .page--smaller-post-purchase-header .banner {
                padding: 8px 0 12px 0;
            }

            .page--smaller-post-purchase-header .main .logo,
            .page--smaller-post-purchase-header .banner .logo {
                line-height: 0;
            }

            .anyflexbox body,
            .anyflexbox .content,
            .anyflexbox .content .wrap,
            .anyflexbox .main,
            .anyflexbox .post-purchase-main {
                display: -webkit-box;
                display: -webkit-flex;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-orient: vertical;
                -webkit-box-direction: normal;
                -webkit-flex-direction: column;
                -ms-flex-direction: column;
                flex-direction: column;
                -webkit-box-flex: 1;
                -webkit-flex: 1 0 auto;
                -ms-flex: 1 0 auto;
                flex: 1 0 auto;
            }

            .anyflexbox .content .wrap {
                -webkit-box-orient: vertical;
                -webkit-box-direction: reverse;
                -webkit-flex-direction: column-reverse;
                -ms-flex-direction: column-reverse;
                flex-direction: column-reverse;
            }

            .anyflexbox .main__content {
                -webkit-box-flex: 1;
                -webkit-flex: 1 0 auto;
                -ms-flex: 1 0 auto;
                flex: 1 0 auto;
            }

            .anyflexbox .banner {
                -webkit-flex-shrink: 0;
                -ms-flex-negative: 0;
                flex-shrink: 0;
            }

            @media (min-width: 1000px) {
                .anyflexbox .content .wrap {
                    -webkit-box-orient: horizontal;
                    -webkit-box-direction: normal;
                    -webkit-flex-direction: row;
                    -ms-flex-direction: row;
                    flex-direction: row;
                }
            }

            .iframe-3ds-shown {
                overflow: hidden;
            }

            .iframe-3ds {
                position: fixed;
                background: white;
                left: 0;
                top: 0;
                height: 100vh;
                width: 100vw;
                z-index: 99999;
            }

            @media (max-width: 749px) {
                .main {
                    padding-top: 1.5em;
                }

                .main__content {
                    padding-bottom: 1.5em;
                }
            }

            @media (min-width: 750px) {
                .main {
                    padding-top: 1.5em;
                }

                .main__content {
                    padding-bottom: 4em;
                }
            }

            @media (min-width: 1000px) {
                .main__header {
                    padding-bottom: 2em;
                }
            }
        </style>
        <style>
            :root {
                --pp-color--light-grey: #bababa;
                --pp-color--lightest-grey: #e6e6e6;
                --pp-color--white: #fff;
                --x-pp-color-canvas: #fff;
                --x-pp-color-canvas-subdued: #fafafa;
                --x-pp-color-canvas-text: #545454;
                --x-pp-color-canvas-text-subdued: #737373;
                --x-pp-color-canvas-text-emphasized: #333;
                --x-pp-color-canvas-border: #d9d9d9;
                --x-pp-color-canvas-border-emphasized: #949494;
                --x-pp-color-surface-primary: #fff;
                --x-pp-color-surface-primary-subdued: #fafafa;
                --x-pp-color-surface-primary-text: #545454;
                --x-pp-color-surface-primary-text-subdued: #737373;
                --x-pp-color-surface-primary-text-emphasized: #333;
                --x-pp-color-surface-primary-border: #d9d9d9;
                --x-pp-color-surface-primary-border-emphasized: #949494;
                --x-pp-color-surface-primary-disabled: #f8f8f8;
                --x-pp-color-surface-primary-accent: #1879b9;
                --x-pp-color-surface-secondary: #fafafa;
                --x-pp-color-surface-secondary-subdued: #f5f5f5;
                --x-pp-color-surface-secondary-text: #545454;
                --x-pp-color-surface-secondary-text-subdued: #737373;
                --x-pp-color-surface-secondary-text-emphasized: #333;
                --x-pp-color-surface-secondary-border: #d9d9d9;
                --x-pp-color-surface-secondary-border-emphasized: #949494;
                --x-pp-color-surface-secondary-disabled: #f3f3f3;
                --x-pp-color-surface-secondary-accent: #1879b9;
                --x-pp-color-surface-tertiary: #fff;
                --x-pp-color-surface-tertiary-subdued: #fafafa;
                --x-pp-color-surface-tertiary-text: #545454;
                --x-pp-color-surface-tertiary-text-subdued: #737373;
                --x-pp-color-surface-tertiary-text-emphasized: #333;
                --x-pp-color-surface-tertiary-border: #d9d9d9;
                --x-pp-color-surface-tertiary-border-emphasized: #949494;
                --x-pp-color-surface-tertiary-disabled: #f8f8f8;
                --x-pp-color-surface-tertiary-accent: #1879b9;
                --x-pp-color-primary-action: #1879b9;
                --x-pp-color-primary-action-hovered: #115e92;
                --x-pp-color-primary-action-pressed: #115e92;
                --x-pp-color-primary-action-text: #fff;
                --x-pp-color-primary-action-text-hovered: #fff;
                --x-pp-color-primary-action-text-pressed: #fff;
                --x-pp-color-secondary-action: #6b6b6b;
                --x-pp-color-secondary-action-hovered: #525252;
                --x-pp-color-secondary-action-pressed: #525252;
                --x-pp-color-secondary-action-text: #fff;
                --x-pp-color-secondary-action-text-hovered: #fff;
                --x-pp-color-secondary-action-text-pressed: #fff;
                --x-pp-color-tertiary-action: #ebebeb;
                --x-pp-color-tertiary-action-text: #333;
                --x-pp-color-tertiary-action-text-subdued: #666;
                --x-pp-color-interactive: transparent;
                --x-pp-color-interactive-hovered: transparent;
                --x-pp-color-interactive-pressed: transparent;
                --x-pp-color-interactive-text: #1879b9;
                --x-pp-color-interactive-text-hovered: #1f93e0;
                --x-pp-color-interactive-text-pressed: #1f93e0;
                --x-pp-color-interactive-icon: #fff;
                --x-pp-color-info: #f0f8ff;
                --x-pp-color-info-disabled: #e0f5ff;
                --x-pp-color-info-subdued: #e5f6ff;
                --x-pp-color-info-text: #545454;
                --x-pp-color-info-text-subdued: #737373;
                --x-pp-color-info-text-emphasized: #333;
                --x-pp-color-info-border: #d1e6f5;
                --x-pp-color-info-border-emphasized: #003542;
                --x-pp-color-info-accent: #1879b9;
                --x-pp-color-success: #e8f8eb;
                --x-pp-color-success-disabled: #d7f4dc;
                --x-pp-color-success-subdued: #dbf5e1;
                --x-pp-color-success-text: #545454;
                --x-pp-color-success-text-subdued: #737373;
                --x-pp-color-success-text-emphasized: #333;
                --x-pp-color-success-border: #d0ecd3;
                --x-pp-color-success-border-emphasized: #1c3121;
                --x-pp-color-success-accent: #0ca127;
                --x-pp-color-warning: #fff8e0;
                --x-pp-color-warning-disabled: #fff2bd;
                --x-pp-color-warning-subdued: #fff3c7;
                --x-pp-color-warning-text: #545454;
                --x-pp-color-warning-text-subdued: #737373;
                --x-pp-color-warning-text-emphasized: #333;
                --x-pp-color-warning-border: #f0e4bc;
                --x-pp-color-warning-border-emphasized: #1c3121;
                --x-pp-color-warning-accent: #b88700;
                --x-pp-color-critical: #ffebeb;
                --x-pp-color-critical-disabled: #ffe0e0;
                --x-pp-color-critical-subdued: #ffe5e5;
                --x-pp-color-critical-text: #545454;
                --x-pp-color-critical-text-subdued: #737373;
                --x-pp-color-critical-text-emphasized: #333;
                --x-pp-color-critical-border: #facccc;
                --x-pp-color-critical-border-emphasized: #5c0000;
                --x-pp-color-critical-accent: #e22222;
                --x-pp-typography-primary-fonts: -apple-system,
                    BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
                    sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
                    "Segoe UI Symbol", sans-serif;
                --x-pp-typography-secondary-fonts: -apple-system,
                    BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial,
                    sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
                    "Segoe UI Symbol", sans-serif;
                --x-pp-typography-primary-weight-base: 400;
                --x-pp-typography-primary-weight-bold: 500;
                --x-pp-typography-secondary-weight-base: 400;
                --x-pp-typography-secondary-weight-bold: 500;
                --x-pp-typography-size-xsmall: 0.9rem;
                --x-pp-typography-size-small: 1.2rem;
                --x-pp-typography-size-default: 1.4rem;
                --x-pp-typography-size-medium: 1.6rem;
                --x-pp-typography-size-large: 1.8rem;
                --x-pp-typography-size-xlarge: 2.4rem;
                --x-pp-typography-size-xxlarge: 2.8rem;
                --x-pp-spacing-tight4x: 0.5rem;
                --x-pp-spacing-tight3x: 0.6rem;
                --x-pp-spacing-tight2x: 0.7rem;
                --x-pp-spacing-tight1x: 0.9rem;
                --x-pp-spacing-tight: 1.1rem;
                --x-pp-spacing-base: 1.4rem;
                --x-pp-spacing-loose: 1.7rem;
                --x-pp-spacing-loose1x: 2.1rem;
                --x-pp-spacing-loose2x: 2.6rem;
                --x-pp-spacing-loose3x: 3.2rem;
                --x-pp-spacing-loose4x: 3.8rem;
                --x-pp-duration-none: 0;
                --x-pp-duration-fast: 100ms;
                --x-pp-duration-base: 200ms;
                --x-pp-duration-slow: 300ms;
                --x-pp-duration-slower: 400ms;
                --x-pp-duration-slowest: 500ms;
            }

            @media screen and (prefers-reduced-motion: reduce) {
                :root {
                    --x-pp-duration-fast: 0.001ms;
                    --x-pp-duration-base: 0.001ms;
                    --x-pp-duration-slow: 0.001ms;
                    --x-pp-duration-slower: 0.001ms;
                    --x-pp-duration-slowest: 0.001ms;
                }
            }

            :root {
                --x-pp-timing-base: ease-in-out;
                --x-pp-timing-ease-out: cubic-bezier(0.3, 0.5, 0.5, 1);
                --x-pp-timing-linear: linear;
                --x-pp-timing-spring: cubic-bezier(0.3, 0, 0, 1);
                --x-pp-border-full: 1px;
                --x-pp-border-block-end: 0 0 1px;
                --x-pp-border-none: 0;
                --x-pp-border-radius-none: 0;
                --x-pp-border-radius-tight: 0.14285714285714285em;
                --x-pp-border-radius-base: 0.35714285714285715em;
                --x-pp-border-radius-fully-rounded: 1.6428571428571428em;
                --x-pp-border-width-base: 1px;
                --x-pp-border-width-thick: 0.14285714285714285em;
                --x-pp-default-color-accent: #1879b9;
                --x-pp-default-color-border: #d9d9d9;
                --x-pp-default-color-border-emphasized: #949494;
                --x-pp-global-typography-letter-case: none;
                --x-pp-global-typography-line-size-default: 1.3;
                --x-pp-global-typography-line-size-large: 1.5;
                --x-pp-global-typography-kerning: normal;
                --x-pp-global-border-radius: var(--x-pp-border-radius-base);
                --x-pp-control-border-radius: var(--x-pp-border-radius-base);
                --x-pp-text-field-border-radius: var(--x-pp-border-radius-base);
                --x-pp-checkbox-border-radius: var(--x-pp-border-radius-base);
                --x-pp-option-list-border-radius: var(
                    --x-pp-border-radius-base
                );
                --x-pp-select-border-radius: var(--x-pp-border-radius-base);
                --x-pp-review-block-border-radius: var(
                    --x-pp-border-radius-base
                );
                --x-pp-tag-border-radius: var(--x-pp-border-radius-base);
                --x-pp-option-list-block-gap: 0;
                --x-pp-option-list-block-padding: var(--x-pp-spacing-loose);
                --x-pp-option-list-inline-padding: var(--x-pp-spacing-loose);
                --x-pp-money-lines-block-gap: var(--x-pp-spacing-tight);
                --x-pp-money-lines-separator-block-gap: var(
                    --x-pp-spacing-loose1x
                );
                --x-pp-money-lines-block-padding: 0;
                --x-pp-money-lines-inline-padding: 0;
                --x-pp-money-summary-block-padding: 0;
                --x-pp-money-summary-inline-padding: 0;
                --x-pp-buyer-journey-inline-gap: var(--x-pp-spacing-tight1x);
                --x-pp-primary-button-block-padding: var(
                    --x-pp-spacing-loose1x
                );
                --x-pp-primary-button-inline-padding: var(
                    --x-pp-spacing-loose2x
                );
                --x-pp-secondary-button-block-padding: var(
                    --x-pp-spacing-loose1x
                );
                --x-pp-secondary-button-inline-padding: var(
                    --x-pp-spacing-loose2x
                );
                --x-pp-tertiary-button-block-padding: var(
                    --x-pp-spacing-tight4x
                );
                --x-pp-tertiary-button-inline-padding: var(
                    --x-pp-spacing-tight3x
                );
                --x-pp-radio-size-base: 1.2857142857142858em;
                --x-pp-radio-size-large: 1.5714285714285714em;
                --x-pp-checkbox-size: 1.2857142857142858em;
                --x-pp-icon-size-small: 0.7142857142857143em;
                --x-pp-icon-size-default: 1em;
                --x-pp-icon-size-large: 1.2857142857142858em;
                --x-pp-thumbnail-aspect-ratio: 1;
                --x-pp-link-transition-duration: var(--x-pp-duration-base);
                --x-pp-modal-max-width: 84rem;
                --x-pp-modal-iframe-default-height: 40rem;
            }

            *,
            :after,
            :before {
                box-sizing: border-box;
            }

            body,
            html {
                margin: 0;
                width: 100%;
                height: 100%;
            }

            html {
                font-size: 62.5%;
                -webkit-text-size-adjust: 100%;
                text-size-adjust: 100%;
            }

            body {
                overflow-y: scroll;
                overflow-x: hidden;
                -webkit-font-smoothing: subpixel-antialiased;
                overflow-wrap: break-word;
            }

            h1,
            h2,
            h3,
            h4,
            h5,
            h6,
            p {
                margin: 0;
            }

            em,
            i {
                font-style: inherit;
            }

            b,
            strong {
                font-weight: inherit;
            }

            small {
                font-size: var(--x-pp-typography-size-small);
            }

            address {
                font-style: normal;
            }

            table {
                border-collapse: collapse;
                border-spacing: 0;
            }

            td,
            th {
                padding: 0;
                font-weight: 400;
            }

            img {
                border-style: none;
            }

            figure {
                margin: 0;
            }

            fieldset {
                margin: 0;
            }

            fieldset,
            legend {
                padding: 0;
                border: 0;
            }

            button,
            input,
            optgroup,
            select,
            textarea {
                -webkit-appearance: none;
                appearance: none;
                border: 0;
                background: transparent;
                color: inherit;
                font: inherit;
                line-height: normal;
                margin: 0;
                padding: 0;
                -webkit-font-smoothing: inherit;
            }

            button,
            input {
                overflow: visible;
            }

            button,
            select {
                text-transform: none;
            }

            [type="button"],
            [type="reset"],
            [type="submit"],
            button {
                -webkit-appearance: button;
                appearance: button;
                cursor: pointer;
            }

            [type="checkbox"],
            [type="radio"] {
                padding: 0;
            }

            [hidden],
            template {
                display: none;
            }

            iframe {
                margin: 0;
                padding: 0;
                border: 0;
            }

            ._3j0kx {
                position: relative;
                border-radius: var(
                    --x-pp-banner-border-radius,
                    var(--x-pp-global-border-radius)
                );
                border-width: var(
                    --x-pp-banner-border,
                    var(--x-pp-border-full)
                );
                border-style: solid;
                padding: var(--x-pp-spacing-loose);
            }

            .wgtSu {
                margin: -0.25em 0;
                max-width: 1.7142857142857142em;
                max-height: 1.7142857142857142em;
            }

            ._1d0rJ {
                --x-pp-default-color-border: var(--x-pp-color-info-border);
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-info-border-emphasized
                );
                --x-pp-default-color-text: var(--x-pp-color-info-text);
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-info-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-info-text-emphasized
                );
                color: var(--x-pp-color-info-text);
                background-color: var(--x-pp-color-info);
                border-color: var(--x-pp-color-info-border);
            }

            ._1d0rJ .wgtSu {
                color: var(--x-pp-color-info-accent);
            }

            ._2j-TB {
                --x-pp-default-color-border: var(--x-pp-color-success-border);
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-success-border-emphasized
                );
                --x-pp-default-color-text: var(--x-pp-color-success-text);
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-success-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-success-text-emphasized
                );
                color: var(--x-pp-color-success-text);
                background-color: var(--x-pp-color-success);
                border-color: var(--x-pp-color-success-border);
            }

            ._2j-TB .wgtSu {
                color: var(--x-pp-color-success-accent);
            }

            ._1aOW7 {
                --x-pp-default-color-border: var(--x-pp-color-warning-border);
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-warning-border-emphasized
                );
                --x-pp-default-color-text: var(--x-pp-color-warning-text);
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-warning-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-warning-text-emphasized
                );
                color: var(--x-pp-color-warning-text);
                background-color: var(--x-pp-color-warning);
                border-color: var(--x-pp-color-warning-border);
            }

            ._1aOW7 .wgtSu {
                color: var(--x-pp-color-warning-accent);
            }

            ._2Zo57 {
                --x-pp-default-color-border: var(--x-pp-color-critical-border);
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-critical-border-emphasized
                );
                --x-pp-default-color-text: var(--x-pp-color-critical-text);
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-critical-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-critical-text-emphasized
                );
                color: var(--x-pp-color-critical-text);
                background-color: var(--x-pp-color-critical);
                border-color: var(--x-pp-color-critical-border);
            }

            ._2Zo57 .wgtSu {
                color: var(--x-pp-color-critical-accent);
            }

            .CVUXi {
                -webkit-tap-highlight-color: transparent;
                padding: var(--x-pp-spacing-tight);
                margin: calc(-1 * var(--x-pp-spacing-tight));
                color: var(--banner-icon-color);
            }

            ._32qEx {
                display: flex;
            }

            [dir="ltr"] ._32qEx > * {
                margin-left: var(--x-pp-spacing-base);
            }

            ._32qEx > :dir(ltr) {
                margin-left: var(--x-pp-spacing-base);
            }

            [dir="rtl"] ._32qEx > * {
                margin-right: var(--x-pp-spacing-base);
            }

            ._32qEx > :dir(rtl) {
                margin-right: var(--x-pp-spacing-base);
            }

            ._32qEx > * {
                flex-grow: 1;
                margin-inline-start: var(--x-pp-spacing-base);
            }

            [dir="ltr"] ._32qEx > :first-child {
                margin-left: 0;
            }

            ._32qEx > :first-child:dir(ltr) {
                margin-left: 0;
            }

            [dir="rtl"] ._32qEx > :first-child {
                margin-right: 0;
            }

            ._32qEx > :first-child:dir(rtl) {
                margin-right: 0;
            }

            ._32qEx > :first-child {
                margin-inline-start: 0;
            }

            ._36Fil {
                align-items: flex-start;
            }

            ._1PFsb {
                align-items: center;
            }

            .HFLM9 {
                align-items: flex-end;
            }

            ._2Bp0t {
                align-items: baseline;
            }

            [dir="ltr"] .xNiUo > * {
                margin-left: var(--x-pp-spacing-tight4x);
            }

            .xNiUo > :dir(ltr) {
                margin-left: var(--x-pp-spacing-tight4x);
            }

            [dir="rtl"] .xNiUo > * {
                margin-right: var(--x-pp-spacing-tight4x);
            }

            .xNiUo > :dir(rtl) {
                margin-right: var(--x-pp-spacing-tight4x);
            }

            .xNiUo > * {
                margin-inline-start: var(--x-pp-spacing-tight4x);
            }

            [dir="ltr"] .b085l > * {
                margin-left: var(--x-pp-spacing-tight1x);
            }

            .b085l > :dir(ltr) {
                margin-left: var(--x-pp-spacing-tight1x);
            }

            [dir="rtl"] .b085l > * {
                margin-right: var(--x-pp-spacing-tight1x);
            }

            .b085l > :dir(rtl) {
                margin-right: var(--x-pp-spacing-tight1x);
            }

            .b085l > * {
                margin-inline-start: var(--x-pp-spacing-tight1x);
            }

            [dir="ltr"] ._3HKp- > * {
                margin-left: var(--x-pp-spacing-loose1x);
            }

            ._3HKp- > :dir(ltr) {
                margin-left: var(--x-pp-spacing-loose1x);
            }

            [dir="rtl"] ._3HKp- > * {
                margin-right: var(--x-pp-spacing-loose1x);
            }

            ._3HKp- > :dir(rtl) {
                margin-right: var(--x-pp-spacing-loose1x);
            }

            ._3HKp- > * {
                margin-inline-start: var(--x-pp-spacing-loose1x);
            }

            [dir="ltr"] ._3Mtkf > * {
                margin-left: var(--x-pp-spacing-loose4x);
            }

            ._3Mtkf > :dir(ltr) {
                margin-left: var(--x-pp-spacing-loose4x);
            }

            [dir="rtl"] ._3Mtkf > * {
                margin-right: var(--x-pp-spacing-loose4x);
            }

            ._3Mtkf > :dir(rtl) {
                margin-right: var(--x-pp-spacing-loose4x);
            }

            ._3Mtkf > * {
                margin-inline-start: var(--x-pp-spacing-loose4x);
            }

            ._1IgVl > :last-child,
            ._2kZQ5 > :first-child {
                flex-grow: 0;
                flex-shrink: 0;
            }

            .zIGP7 {
                display: block;
                max-height: 100%;
                max-width: 100%;
                fill: currentColor;
            }

            ._3CyM9 {
                width: var(--x-pp-icon-size-default);
                height: var(--x-pp-icon-size-default);
            }

            ._1Pbnx {
                width: var(--x-pp-icon-size-small);
                height: var(--x-pp-icon-size-small);
            }

            ._2YfC2 {
                width: var(--x-pp-icon-size-large);
                height: var(--x-pp-icon-size-large);
            }

            ._2jlI_ {
                color: var(--x-pp-default-color-accent);
            }

            ._2yyV6 {
                color: var(--x-pp-color-interactive-text);
            }

            ._2LLuu {
                color: var(
                    --x-pp-default-color-text-subdued,
                    var(--x-pp-default-color-text, inherit)
                );
            }

            ._2uVWL {
                color: var(--x-pp-color-info-accent);
            }

            ._1KyZQ {
                color: var(--x-pp-color-success-accent);
            }

            ._2Ggdg {
                color: var(--x-pp-color-critical-accent);
            }

            .swyaV {
                color: var(--x-pp-color-warning-accent);
            }

            ._2rMyT,
            ._3eqwU {
                position: relative;
                display: block;
                width: 100%;
                max-width: 100%;
                max-height: 100%;
            }

            .y62dN {
                padding-bottom: 100%;
            }

            ._2eybg > * + * {
                margin-top: var(--x-pp-spacing-base);
            }

            ._1h1N3 > * + * {
                margin-top: 0;
            }

            ._1iKs5 > * + * {
                margin-top: var(--x-pp-spacing-tight2x);
            }

            ._13Nm7 > * + * {
                margin-top: var(--x-pp-spacing-loose2x);
            }

            [dir="ltr"] ._1GKtd {
                text-align: left;
            }

            ._1GKtd:dir(ltr) {
                text-align: left;
            }

            [dir="rtl"] ._1GKtd {
                text-align: right;
            }

            ._1GKtd:dir(rtl) {
                text-align: right;
            }

            ._1GKtd {
                text-align: start;
            }

            .SsbUH {
                text-align: center;
            }

            [dir="ltr"] .T8_jN {
                text-align: right;
            }

            .T8_jN:dir(ltr) {
                text-align: right;
            }

            [dir="rtl"] .T8_jN {
                text-align: left;
            }

            .T8_jN:dir(rtl) {
                text-align: left;
            }

            .T8_jN {
                text-align: end;
            }

            [class]._1ThhK,
            [class]._2vecA::placeholder {
                font-size: var(
                    --x-pp-style1-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style1-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style1-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style1-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style1-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style1-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class]._1v9j_::placeholder,
            [class]._2xqx1 {
                font-size: var(
                    --x-pp-style2-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style2-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style2-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style2-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style2-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style2-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class].dyIAS::placeholder,
            [class].R8KcS {
                font-size: var(
                    --x-pp-style3-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style3-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style3-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style3-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style3-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style3-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class]._2U6CR::placeholder,
            [class].r73aY {
                font-size: var(
                    --x-pp-style4-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style4-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style4-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style4-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style4-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style4-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class]._2r9ts::placeholder,
            [class]._2ypLc {
                font-size: var(
                    --x-pp-style5-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style5-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style5-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style5-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style5-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style5-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class]._1u3od,
            [class]._2kcX8::placeholder {
                font-size: var(
                    --x-pp-style6-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style6-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style6-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style6-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style6-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style6-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class]._9TrPd,
            [class].F77fu::placeholder {
                font-size: var(
                    --x-pp-style7-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style7-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style7-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style7-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style7-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style7-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class]._1zpGS,
            [class]._33tWP::placeholder {
                font-size: var(
                    --x-pp-style8-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style8-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style8-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style8-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style8-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style8-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            [class]._3EwVe::placeholder,
            [class].uEcSY {
                font-size: var(
                    --x-pp-style9-typography-size,
                    var(--this-font-size)
                );
                text-transform: var(
                    --x-pp-style9-typography-case,
                    var(--this-text-transform)
                );
                font-family: var(
                    --x-pp-style9-typography-fonts,
                    var(--this-font-family)
                );
                font-weight: var(
                    --x-pp-style9-typography-weight,
                    var(--this-font-weight)
                );
                line-height: var(
                    --x-pp-style9-typography-line-size,
                    var(--this-line-height)
                );
                letter-spacing: var(
                    --x-pp-style9-typography-kerning,
                    var(--this-letter-spacing)
                );
            }

            .yBcib {
                --this-font-family: var(--x-pp-typography-secondary-fonts);
                --this-line-height: var(
                    --x-pp-global-typography-line-size-default
                );
                color: inherit;
                font-family: var(--this-font-family);
                line-height: var(--this-line-height);
                text-transform: var(--x-pp-global-typography-letter-case);
                letter-spacing: var(--x-pp-global-typography-kerning);
                font-weight: var(--x-pp-typography-secondary-weight-base);
            }

            ._1Puel {
                --this-font-size: var(--x-pp-typography-size-xxlarge);
            }

            .-rdRp,
            ._1Puel {
                --this-font-weight: var(
                    --x-pp-typography-secondary-weight-base
                );
                font-size: var(--this-font-size);
                font-weight: var(--this-font-weight);
            }

            .-rdRp {
                --this-font-size: var(--x-pp-typography-size-large);
                color: var(
                    --x-pp-default-color-text-emphasized,
                    var(--x-pp-default-color-text, inherit)
                );
            }

            ._2dRVl {
                --this-font-weight: var(
                    --x-pp-typography-secondary-weight-bold
                );
            }

            ._1NBdA,
            ._2dRVl,
            ._2sK-P,
            ._3BMfp {
                --this-font-size: var(--x-pp-typography-size-default);
                font-size: var(--this-font-size);
                font-weight: var(--this-font-weight);
                color: var(
                    --x-pp-default-color-text-emphasized,
                    var(--x-pp-default-color-text, inherit)
                );
            }

            ._1NBdA,
            ._2sK-P,
            ._3BMfp {
                --this-font-weight: var(
                    --x-pp-typography-secondary-weight-base
                );
            }

            [dir="ltr"] .S8nbj {
                padding-left: var(--x-pp-spacing-tight4x);
            }

            .S8nbj:dir(ltr) {
                padding-left: var(--x-pp-spacing-tight4x);
            }

            [dir="rtl"] .S8nbj {
                padding-right: var(--x-pp-spacing-tight4x);
            }

            .S8nbj:dir(rtl) {
                padding-right: var(--x-pp-spacing-tight4x);
            }

            .S8nbj {
                padding-inline-start: var(--x-pp-spacing-tight4x);
            }

            [dir="ltr"] ._2ka9y {
                padding-left: var(--x-pp-spacing-tight1x);
            }

            ._2ka9y:dir(ltr) {
                padding-left: var(--x-pp-spacing-tight1x);
            }

            [dir="rtl"] ._2ka9y {
                padding-right: var(--x-pp-spacing-tight1x);
            }

            ._2ka9y:dir(rtl) {
                padding-right: var(--x-pp-spacing-tight1x);
            }

            ._2ka9y {
                padding-inline-start: var(--x-pp-spacing-tight1x);
            }

            [dir="ltr"] ._2a1GU {
                padding-left: var(--x-pp-spacing-base);
            }

            ._2a1GU:dir(ltr) {
                padding-left: var(--x-pp-spacing-base);
            }

            [dir="rtl"] ._2a1GU {
                padding-right: var(--x-pp-spacing-base);
            }

            ._2a1GU:dir(rtl) {
                padding-right: var(--x-pp-spacing-base);
            }

            ._2a1GU {
                padding-inline-start: var(--x-pp-spacing-base);
            }

            [dir="ltr"] ._7dBz4 {
                padding-left: var(--x-pp-spacing-loose1x);
            }

            ._7dBz4:dir(ltr) {
                padding-left: var(--x-pp-spacing-loose1x);
            }

            [dir="rtl"] ._7dBz4 {
                padding-right: var(--x-pp-spacing-loose1x);
            }

            ._7dBz4:dir(rtl) {
                padding-right: var(--x-pp-spacing-loose1x);
            }

            ._7dBz4 {
                padding-inline-start: var(--x-pp-spacing-loose1x);
            }

            [dir="ltr"] .yb4su {
                padding-left: var(--x-pp-spacing-loose4x);
            }

            .yb4su:dir(ltr) {
                padding-left: var(--x-pp-spacing-loose4x);
            }

            [dir="rtl"] .yb4su {
                padding-right: var(--x-pp-spacing-loose4x);
            }

            .yb4su:dir(rtl) {
                padding-right: var(--x-pp-spacing-loose4x);
            }

            .yb4su {
                padding-inline-start: var(--x-pp-spacing-loose4x);
            }

            [dir="ltr"] ._1hIzZ {
                padding-right: var(--x-pp-spacing-tight4x);
            }

            ._1hIzZ:dir(ltr) {
                padding-right: var(--x-pp-spacing-tight4x);
            }

            [dir="rtl"] ._1hIzZ {
                padding-left: var(--x-pp-spacing-tight4x);
            }

            ._1hIzZ:dir(rtl) {
                padding-left: var(--x-pp-spacing-tight4x);
            }

            ._1hIzZ {
                padding-inline-end: var(--x-pp-spacing-tight4x);
            }

            [dir="ltr"] ._1IlT5 {
                padding-right: var(--x-pp-spacing-tight1x);
            }

            ._1IlT5:dir(ltr) {
                padding-right: var(--x-pp-spacing-tight1x);
            }

            [dir="rtl"] ._1IlT5 {
                padding-left: var(--x-pp-spacing-tight1x);
            }

            ._1IlT5:dir(rtl) {
                padding-left: var(--x-pp-spacing-tight1x);
            }

            ._1IlT5 {
                padding-inline-end: var(--x-pp-spacing-tight1x);
            }

            [dir="ltr"] ._1pVg2 {
                padding-right: var(--x-pp-spacing-base);
            }

            ._1pVg2:dir(ltr) {
                padding-right: var(--x-pp-spacing-base);
            }

            [dir="rtl"] ._1pVg2 {
                padding-left: var(--x-pp-spacing-base);
            }

            ._1pVg2:dir(rtl) {
                padding-left: var(--x-pp-spacing-base);
            }

            ._1pVg2 {
                padding-inline-end: var(--x-pp-spacing-base);
            }

            [dir="ltr"] ._1GOIJ {
                padding-right: var(--x-pp-spacing-loose1x);
            }

            ._1GOIJ:dir(ltr) {
                padding-right: var(--x-pp-spacing-loose1x);
            }

            [dir="rtl"] ._1GOIJ {
                padding-left: var(--x-pp-spacing-loose1x);
            }

            ._1GOIJ:dir(rtl) {
                padding-left: var(--x-pp-spacing-loose1x);
            }

            ._1GOIJ {
                padding-inline-end: var(--x-pp-spacing-loose1x);
            }

            [dir="ltr"] ._3eSiZ {
                padding-right: var(--x-pp-spacing-loose4x);
            }

            ._3eSiZ:dir(ltr) {
                padding-right: var(--x-pp-spacing-loose4x);
            }

            [dir="rtl"] ._3eSiZ {
                padding-left: var(--x-pp-spacing-loose4x);
            }

            ._3eSiZ:dir(rtl) {
                padding-left: var(--x-pp-spacing-loose4x);
            }

            ._3eSiZ {
                padding-inline-end: var(--x-pp-spacing-loose4x);
            }

            ._2KoLb {
                padding-top: var(--x-pp-spacing-tight4x);
            }

            ._1_-tJ {
                padding-top: var(--x-pp-spacing-tight1x);
            }

            ._2HKJe {
                padding-top: var(--x-pp-spacing-base);
            }

            .EAwaN {
                padding-top: var(--x-pp-spacing-loose1x);
            }

            ._2GkoP {
                padding-top: var(--x-pp-spacing-loose4x);
            }

            ._3g0oA {
                padding-bottom: var(--x-pp-spacing-tight4x);
            }

            ._3Bb4R {
                padding-bottom: var(--x-pp-spacing-tight1x);
            }

            .P2adR {
                padding-bottom: var(--x-pp-spacing-base);
            }

            .Sru2A {
                padding-bottom: var(--x-pp-spacing-loose1x);
            }

            ._3_IZJ {
                padding-bottom: var(--x-pp-spacing-loose4x);
            }

            ._21fE7 {
                --x-pp-default-color-subdued: var(
                    --x-pp-color-surface-primary-subdued
                );
                --x-pp-default-color-text: var(
                    --x-pp-color-surface-primary-text
                );
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-primary-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-surface-primary-text-emphasized
                );
                --x-pp-default-color-border: var(
                    --x-pp-color-surface-primary-border
                );
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-surface-primary-border-emphasized
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-primary-accent
                );
                background-color: var(--x-pp-color-surface-primary);
            }

            ._21fE7,
            .FCc6V {
                color: var(--x-pp-default-color-text);
            }

            .FCc6V {
                --x-pp-default-color-subdued: var(
                    --x-pp-color-surface-secondary-subdued
                );
                --x-pp-default-color-text: var(
                    --x-pp-color-surface-secondary-text
                );
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-secondary-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-surface-secondary-text-emphasized
                );
                --x-pp-default-color-border: var(
                    --x-pp-color-surface-secondary-border
                );
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-surface-secondary-border-emphasized
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-secondary-accent
                );
                background-color: var(--x-pp-color-surface-secondary);
            }

            ._3niT0 {
                --x-pp-default-color-subdued: var(
                    --x-pp-color-surface-tertiary-subdued
                );
                --x-pp-default-color-text: var(
                    --x-pp-color-surface-tertiary-text
                );
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-tertiary-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-surface-tertiary-text-emphasized
                );
                --x-pp-default-color-border: var(
                    --x-pp-color-surface-tertiary-border
                );
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-surface-tertiary-border-emphasized
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-tertiary-accent
                );
                background-color: var(--x-pp-color-surface-tertiary);
                color: var(--x-pp-default-color-text);
            }

            [dir="ltr"] .xAyPy {
                border-left: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            .xAyPy:dir(ltr) {
                border-left: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            [dir="rtl"] .xAyPy {
                border-right: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            .xAyPy:dir(rtl) {
                border-right: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            .xAyPy {
                border-inline-start: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            [dir="ltr"] ._1Pm5N {
                border-left: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            ._1Pm5N:dir(ltr) {
                border-left: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            [dir="rtl"] ._1Pm5N {
                border-right: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            ._1Pm5N:dir(rtl) {
                border-right: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            ._1Pm5N {
                border-inline-start: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            [dir="ltr"] ._23lvM {
                border-right: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            ._23lvM:dir(ltr) {
                border-right: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            [dir="rtl"] ._23lvM {
                border-left: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            ._23lvM:dir(rtl) {
                border-left: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            ._23lvM {
                border-inline-end: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            [dir="ltr"] ._3MqlX {
                border-right: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            ._3MqlX:dir(ltr) {
                border-right: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            [dir="rtl"] ._3MqlX {
                border-left: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            ._3MqlX:dir(rtl) {
                border-left: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            ._3MqlX {
                border-inline-end: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            ._2hDfr {
                border-top: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            .RAcGj {
                border-top: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            .eDVmp {
                border-bottom: var(--x-pp-border-width-base) solid
                    var(--x-pp-default-color-border);
            }

            ._2WSCq {
                border-bottom: var(--x-pp-border-width-base) dotted
                    var(--x-pp-default-color-border);
            }

            [dir="ltr"] ._1jRIH {
                border-left-width: var(--x-pp-border-width-base);
            }

            ._1jRIH:dir(ltr) {
                border-left-width: var(--x-pp-border-width-base);
            }

            [dir="rtl"] ._1jRIH {
                border-right-width: var(--x-pp-border-width-base);
            }

            ._1jRIH:dir(rtl) {
                border-right-width: var(--x-pp-border-width-base);
            }

            ._1jRIH {
                border-inline-start-width: var(--x-pp-border-width-base);
            }

            [dir="ltr"] ._3XOtv {
                border-left-width: var(--x-pp-border-width-thick);
            }

            ._3XOtv:dir(ltr) {
                border-left-width: var(--x-pp-border-width-thick);
            }

            [dir="rtl"] ._3XOtv {
                border-right-width: var(--x-pp-border-width-thick);
            }

            ._3XOtv:dir(rtl) {
                border-right-width: var(--x-pp-border-width-thick);
            }

            ._3XOtv {
                border-inline-start-width: var(--x-pp-border-width-thick);
            }

            [dir="ltr"] ._2Y3EQ {
                border-right-width: var(--x-pp-border-width-base);
            }

            ._2Y3EQ:dir(ltr) {
                border-right-width: var(--x-pp-border-width-base);
            }

            [dir="rtl"] ._2Y3EQ {
                border-left-width: var(--x-pp-border-width-base);
            }

            ._2Y3EQ:dir(rtl) {
                border-left-width: var(--x-pp-border-width-base);
            }

            ._2Y3EQ {
                border-inline-end-width: var(--x-pp-border-width-base);
            }

            [dir="ltr"] ._1HtFF {
                border-right-width: var(--x-pp-border-width-thick);
            }

            ._1HtFF:dir(ltr) {
                border-right-width: var(--x-pp-border-width-thick);
            }

            [dir="rtl"] ._1HtFF {
                border-left-width: var(--x-pp-border-width-thick);
            }

            ._1HtFF:dir(rtl) {
                border-left-width: var(--x-pp-border-width-thick);
            }

            ._1HtFF {
                border-inline-end-width: var(--x-pp-border-width-thick);
            }

            .iJEDO {
                border-top-width: var(--x-pp-border-width-base);
            }

            ._31Kov {
                border-top-width: var(--x-pp-border-width-thick);
            }

            ._2ZT8z {
                border-bottom-width: var(--x-pp-border-width-base);
            }

            ._3S6rZ {
                border-bottom-width: var(--x-pp-border-width-thick);
            }

            [dir="ltr"] .K43kx {
                border-left-color: var(--x-pp-default-color-border);
            }

            .K43kx:dir(ltr) {
                border-left-color: var(--x-pp-default-color-border);
            }

            [dir="rtl"] .K43kx {
                border-right-color: var(--x-pp-default-color-border);
            }

            .K43kx:dir(rtl) {
                border-right-color: var(--x-pp-default-color-border);
            }

            .K43kx {
                border-inline-start-color: var(--x-pp-default-color-border);
            }

            [dir="ltr"] ._3XWmm {
                border-left-color: var(--x-pp-default-color-border-emphasized);
            }

            ._3XWmm:dir(ltr) {
                border-left-color: var(--x-pp-default-color-border-emphasized);
            }

            [dir="rtl"] ._3XWmm {
                border-right-color: var(--x-pp-default-color-border-emphasized);
            }

            ._3XWmm:dir(rtl) {
                border-right-color: var(--x-pp-default-color-border-emphasized);
            }

            ._3XWmm {
                border-inline-start-color: var(
                    --x-pp-default-color-border-emphasized
                );
            }

            [dir="ltr"] ._2nYUS {
                border-right-color: var(--x-pp-default-color-border);
            }

            ._2nYUS:dir(ltr) {
                border-right-color: var(--x-pp-default-color-border);
            }

            [dir="rtl"] ._2nYUS {
                border-left-color: var(--x-pp-default-color-border);
            }

            ._2nYUS:dir(rtl) {
                border-left-color: var(--x-pp-default-color-border);
            }

            ._2nYUS {
                border-inline-end-color: var(--x-pp-default-color-border);
            }

            [dir="ltr"] ._1265U {
                border-right-color: var(--x-pp-default-color-border-emphasized);
            }

            ._1265U:dir(ltr) {
                border-right-color: var(--x-pp-default-color-border-emphasized);
            }

            [dir="rtl"] ._1265U {
                border-left-color: var(--x-pp-default-color-border-emphasized);
            }

            ._1265U:dir(rtl) {
                border-left-color: var(--x-pp-default-color-border-emphasized);
            }

            ._1265U {
                border-inline-end-color: var(
                    --x-pp-default-color-border-emphasized
                );
            }

            .qFPZr {
                border-top-color: var(--x-pp-default-color-border);
            }

            .onei6 {
                border-top-color: var(--x-pp-default-color-border-emphasized);
            }

            .GeGcD {
                border-bottom-color: var(--x-pp-default-color-border);
            }

            ._2NCzR {
                border-bottom-color: var(
                    --x-pp-default-color-border-emphasized
                );
            }

            [dir="ltr"] .Sjdmp {
                border-top-left-radius: var(--x-pp-border-radius-tight);
            }

            .Sjdmp:dir(ltr) {
                border-top-left-radius: var(--x-pp-border-radius-tight);
            }

            [dir="rtl"] .Sjdmp {
                border-top-right-radius: var(--x-pp-border-radius-tight);
            }

            .Sjdmp:dir(rtl) {
                border-top-right-radius: var(--x-pp-border-radius-tight);
            }

            .Sjdmp {
                border-start-start-radius: var(--x-pp-border-radius-tight);
            }

            [dir="ltr"] ._2OYEW {
                border-top-left-radius: var(--x-pp-border-radius-base);
            }

            ._2OYEW:dir(ltr) {
                border-top-left-radius: var(--x-pp-border-radius-base);
            }

            [dir="rtl"] ._2OYEW {
                border-top-right-radius: var(--x-pp-border-radius-base);
            }

            ._2OYEW:dir(rtl) {
                border-top-right-radius: var(--x-pp-border-radius-base);
            }

            ._2OYEW {
                border-start-start-radius: var(--x-pp-border-radius-base);
            }

            [dir="ltr"] ._1YvDO {
                border-bottom-left-radius: var(--x-pp-border-radius-tight);
            }

            ._1YvDO:dir(ltr) {
                border-bottom-left-radius: var(--x-pp-border-radius-tight);
            }

            [dir="rtl"] ._1YvDO {
                border-bottom-right-radius: var(--x-pp-border-radius-tight);
            }

            ._1YvDO:dir(rtl) {
                border-bottom-right-radius: var(--x-pp-border-radius-tight);
            }

            ._1YvDO {
                border-end-start-radius: var(--x-pp-border-radius-tight);
            }

            [dir="ltr"] .gZ-j- {
                border-bottom-left-radius: var(--x-pp-border-radius-base);
            }

            .gZ-j-:dir(ltr) {
                border-bottom-left-radius: var(--x-pp-border-radius-base);
            }

            [dir="rtl"] .gZ-j- {
                border-bottom-right-radius: var(--x-pp-border-radius-base);
            }

            .gZ-j-:dir(rtl) {
                border-bottom-right-radius: var(--x-pp-border-radius-base);
            }

            .gZ-j- {
                border-end-start-radius: var(--x-pp-border-radius-base);
            }

            [dir="ltr"] ._34HaS {
                border-top-right-radius: var(--x-pp-border-radius-tight);
            }

            ._34HaS:dir(ltr) {
                border-top-right-radius: var(--x-pp-border-radius-tight);
            }

            [dir="rtl"] ._34HaS {
                border-top-left-radius: var(--x-pp-border-radius-tight);
            }

            ._34HaS:dir(rtl) {
                border-top-left-radius: var(--x-pp-border-radius-tight);
            }

            ._34HaS {
                border-start-end-radius: var(--x-pp-border-radius-tight);
            }

            [dir="ltr"] ._3mCex {
                border-top-right-radius: var(--x-pp-border-radius-base);
            }

            ._3mCex:dir(ltr) {
                border-top-right-radius: var(--x-pp-border-radius-base);
            }

            [dir="rtl"] ._3mCex {
                border-top-left-radius: var(--x-pp-border-radius-base);
            }

            ._3mCex:dir(rtl) {
                border-top-left-radius: var(--x-pp-border-radius-base);
            }

            ._3mCex {
                border-start-end-radius: var(--x-pp-border-radius-base);
            }

            [dir="ltr"] ._3C8nK {
                border-bottom-right-radius: var(--x-pp-border-radius-tight);
            }

            ._3C8nK:dir(ltr) {
                border-bottom-right-radius: var(--x-pp-border-radius-tight);
            }

            [dir="rtl"] ._3C8nK {
                border-bottom-left-radius: var(--x-pp-border-radius-tight);
            }

            ._3C8nK:dir(rtl) {
                border-bottom-left-radius: var(--x-pp-border-radius-tight);
            }

            ._3C8nK {
                border-end-end-radius: var(--x-pp-border-radius-tight);
            }

            [dir="ltr"] ._2WDTK {
                border-bottom-right-radius: var(--x-pp-border-radius-base);
            }

            ._2WDTK:dir(ltr) {
                border-bottom-right-radius: var(--x-pp-border-radius-base);
            }

            [dir="rtl"] ._2WDTK {
                border-bottom-left-radius: var(--x-pp-border-radius-base);
            }

            ._2WDTK:dir(rtl) {
                border-bottom-left-radius: var(--x-pp-border-radius-base);
            }

            ._2WDTK {
                border-end-end-radius: var(--x-pp-border-radius-base);
            }

            @media screen and (min-width: 750px) {
                [dir="ltr"] .fqv-X {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                .fqv-X:dir(ltr) {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                [dir="rtl"] .fqv-X {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                .fqv-X:dir(rtl) {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                .fqv-X {
                    padding-inline-start: var(--x-pp-spacing-tight4x);
                }

                [dir="ltr"] ._1AZAC {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                ._1AZAC:dir(ltr) {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                [dir="rtl"] ._1AZAC {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._1AZAC:dir(rtl) {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._1AZAC {
                    padding-inline-start: var(--x-pp-spacing-tight1x);
                }

                [dir="ltr"] ._3Bhm5 {
                    padding-left: var(--x-pp-spacing-base);
                }

                ._3Bhm5:dir(ltr) {
                    padding-left: var(--x-pp-spacing-base);
                }

                [dir="rtl"] ._3Bhm5 {
                    padding-right: var(--x-pp-spacing-base);
                }

                ._3Bhm5:dir(rtl) {
                    padding-right: var(--x-pp-spacing-base);
                }

                ._3Bhm5 {
                    padding-inline-start: var(--x-pp-spacing-base);
                }

                [dir="ltr"] ._2I-n- {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                ._2I-n-:dir(ltr) {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                [dir="rtl"] ._2I-n- {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._2I-n-:dir(rtl) {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._2I-n- {
                    padding-inline-start: var(--x-pp-spacing-loose1x);
                }

                [dir="ltr"] ._3nHiJ {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._3nHiJ:dir(ltr) {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                [dir="rtl"] ._3nHiJ {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._3nHiJ:dir(rtl) {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._3nHiJ {
                    padding-inline-start: var(--x-pp-spacing-loose4x);
                }

                [dir="ltr"] .JOuYF {
                    padding-left: 0;
                }

                .JOuYF:dir(ltr) {
                    padding-left: 0;
                }

                [dir="rtl"] .JOuYF {
                    padding-right: 0;
                }

                .JOuYF:dir(rtl) {
                    padding-right: 0;
                }

                .JOuYF {
                    padding-inline-start: 0;
                }

                [dir="ltr"] ._1zdlS {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                ._1zdlS:dir(ltr) {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                [dir="rtl"] ._1zdlS {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                ._1zdlS:dir(rtl) {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                ._1zdlS {
                    padding-inline-end: var(--x-pp-spacing-tight4x);
                }

                [dir="ltr"] .AAMsD {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                .AAMsD:dir(ltr) {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                [dir="rtl"] .AAMsD {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                .AAMsD:dir(rtl) {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                .AAMsD {
                    padding-inline-end: var(--x-pp-spacing-tight1x);
                }

                [dir="ltr"] .-xyEc {
                    padding-right: var(--x-pp-spacing-base);
                }

                .-xyEc:dir(ltr) {
                    padding-right: var(--x-pp-spacing-base);
                }

                [dir="rtl"] .-xyEc {
                    padding-left: var(--x-pp-spacing-base);
                }

                .-xyEc:dir(rtl) {
                    padding-left: var(--x-pp-spacing-base);
                }

                .-xyEc {
                    padding-inline-end: var(--x-pp-spacing-base);
                }

                [dir="ltr"] ._1i_3m {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._1i_3m:dir(ltr) {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                [dir="rtl"] ._1i_3m {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                ._1i_3m:dir(rtl) {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                ._1i_3m {
                    padding-inline-end: var(--x-pp-spacing-loose1x);
                }

                [dir="ltr"] ._2LV8J {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._2LV8J:dir(ltr) {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                [dir="rtl"] ._2LV8J {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._2LV8J:dir(rtl) {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._2LV8J {
                    padding-inline-end: var(--x-pp-spacing-loose4x);
                }

                [dir="ltr"] .sSDYA {
                    padding-right: 0;
                }

                .sSDYA:dir(ltr) {
                    padding-right: 0;
                }

                [dir="rtl"] .sSDYA {
                    padding-left: 0;
                }

                .sSDYA:dir(rtl) {
                    padding-left: 0;
                }

                .sSDYA {
                    padding-inline-end: 0;
                }

                ._312WW {
                    padding-top: var(--x-pp-spacing-tight4x);
                }

                ._3kkZ0 {
                    padding-top: var(--x-pp-spacing-tight1x);
                }

                ._1vXmv {
                    padding-top: var(--x-pp-spacing-base);
                }

                ._2HOcX {
                    padding-top: var(--x-pp-spacing-loose1x);
                }

                ._3oiLW {
                    padding-top: var(--x-pp-spacing-loose4x);
                }

                ._28lMq {
                    padding-top: 0;
                }

                ._1utdI {
                    padding-bottom: var(--x-pp-spacing-tight4x);
                }

                ._4abcP {
                    padding-bottom: var(--x-pp-spacing-tight1x);
                }

                ._1mM1n {
                    padding-bottom: var(--x-pp-spacing-base);
                }

                ._17Itb {
                    padding-bottom: var(--x-pp-spacing-loose1x);
                }

                ._3leu7 {
                    padding-bottom: var(--x-pp-spacing-loose4x);
                }

                ._3tGOz {
                    padding-bottom: 0;
                }

                ._3GZyp {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-primary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-primary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-primary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-primary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-primary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-primary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-primary-accent
                    );
                    background-color: var(--x-pp-color-surface-primary);
                }

                ._3GZyp,
                ._3HBBp {
                    color: var(--x-pp-default-color-text);
                }

                ._3HBBp {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-secondary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-secondary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-secondary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-secondary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-secondary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-secondary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-secondary-accent
                    );
                    background-color: var(--x-pp-color-surface-secondary);
                }

                .nCXqJ {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-tertiary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-tertiary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-tertiary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-tertiary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-tertiary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-tertiary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-tertiary-accent
                    );
                    background-color: var(--x-pp-color-surface-tertiary);
                    color: var(--x-pp-default-color-text);
                }

                ._3akjl {
                    background-color: transparent;
                }

                [dir="ltr"] ._2-xnG {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2-xnG:dir(ltr) {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._2-xnG {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2-xnG:dir(rtl) {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2-xnG {
                    border-inline-start: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._3kc7u {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3kc7u:dir(ltr) {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3kc7u {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3kc7u:dir(rtl) {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3kc7u {
                    border-inline-start: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._1bCtw {
                    border-left: 0;
                }

                ._1bCtw:dir(ltr) {
                    border-left: 0;
                }

                [dir="rtl"] ._1bCtw {
                    border-right: 0;
                }

                ._1bCtw:dir(rtl) {
                    border-right: 0;
                }

                ._1bCtw {
                    border-inline-start: 0;
                }

                [dir="ltr"] ._2cxMf {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2cxMf:dir(ltr) {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._2cxMf {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2cxMf:dir(rtl) {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2cxMf {
                    border-inline-end: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._2AwrM {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._2AwrM:dir(ltr) {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._2AwrM {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._2AwrM:dir(rtl) {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._2AwrM {
                    border-inline-end: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._2H9aL {
                    border-right: 0;
                }

                ._2H9aL:dir(ltr) {
                    border-right: 0;
                }

                [dir="rtl"] ._2H9aL {
                    border-left: 0;
                }

                ._2H9aL:dir(rtl) {
                    border-left: 0;
                }

                ._2H9aL {
                    border-inline-end: 0;
                }

                .AanBd {
                    border-top: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2-N95 {
                    border-top: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._1Z3zQ {
                    border-top: 0;
                }

                ._3Jmu0 {
                    border-bottom: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                .IQOP- {
                    border-bottom: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._32KwE {
                    border-bottom: 0;
                }

                [dir="ltr"] ._3qcP4 {
                    border-left-width: var(--x-pp-border-width-base);
                }

                ._3qcP4:dir(ltr) {
                    border-left-width: var(--x-pp-border-width-base);
                }

                [dir="rtl"] ._3qcP4 {
                    border-right-width: var(--x-pp-border-width-base);
                }

                ._3qcP4:dir(rtl) {
                    border-right-width: var(--x-pp-border-width-base);
                }

                ._3qcP4 {
                    border-inline-start-width: var(--x-pp-border-width-base);
                }

                [dir="ltr"] ._24NTQ {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                ._24NTQ:dir(ltr) {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                [dir="rtl"] ._24NTQ {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._24NTQ:dir(rtl) {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._24NTQ {
                    border-inline-start-width: var(--x-pp-border-width-thick);
                }

                [dir="ltr"] .N9jyK {
                    border-right-width: var(--x-pp-border-width-base);
                }

                .N9jyK:dir(ltr) {
                    border-right-width: var(--x-pp-border-width-base);
                }

                [dir="rtl"] .N9jyK {
                    border-left-width: var(--x-pp-border-width-base);
                }

                .N9jyK:dir(rtl) {
                    border-left-width: var(--x-pp-border-width-base);
                }

                .N9jyK {
                    border-inline-end-width: var(--x-pp-border-width-base);
                }

                [dir="ltr"] .vNGST {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                .vNGST:dir(ltr) {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                [dir="rtl"] .vNGST {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                .vNGST:dir(rtl) {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                .vNGST {
                    border-inline-end-width: var(--x-pp-border-width-thick);
                }

                ._1VCXR {
                    border-top-width: var(--x-pp-border-width-base);
                }

                ._1-VLC {
                    border-top-width: var(--x-pp-border-width-thick);
                }

                ._1mroW {
                    border-bottom-width: var(--x-pp-border-width-base);
                }

                ._1O_ez {
                    border-bottom-width: var(--x-pp-border-width-thick);
                }

                [dir="ltr"] ._2l9sN {
                    border-left-color: var(--x-pp-default-color-border);
                }

                ._2l9sN:dir(ltr) {
                    border-left-color: var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._2l9sN {
                    border-right-color: var(--x-pp-default-color-border);
                }

                ._2l9sN:dir(rtl) {
                    border-right-color: var(--x-pp-default-color-border);
                }

                ._2l9sN {
                    border-inline-start-color: var(--x-pp-default-color-border);
                }

                [dir="ltr"] .iJPlF {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .iJPlF:dir(ltr) {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="rtl"] .iJPlF {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .iJPlF:dir(rtl) {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .iJPlF {
                    border-inline-start-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="ltr"] ._3kRTl {
                    border-right-color: var(--x-pp-default-color-border);
                }

                ._3kRTl:dir(ltr) {
                    border-right-color: var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3kRTl {
                    border-left-color: var(--x-pp-default-color-border);
                }

                ._3kRTl:dir(rtl) {
                    border-left-color: var(--x-pp-default-color-border);
                }

                ._3kRTl {
                    border-inline-end-color: var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._3rvSU {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3rvSU:dir(ltr) {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="rtl"] ._3rvSU {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3rvSU:dir(rtl) {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3rvSU {
                    border-inline-end-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._1uSpC {
                    border-top-color: var(--x-pp-default-color-border);
                }

                ._7ehfG {
                    border-top-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .fYFIN {
                    border-bottom-color: var(--x-pp-default-color-border);
                }

                ._2kGKA {
                    border-bottom-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="ltr"] ._3dOc_ {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                ._3dOc_:dir(ltr) {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._3dOc_ {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._3dOc_:dir(rtl) {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._3dOc_ {
                    border-start-start-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._1oahn {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                ._1oahn:dir(ltr) {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._1oahn {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                ._1oahn:dir(rtl) {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                ._1oahn {
                    border-start-start-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._2AR-3 {
                    border-top-left-radius: 0;
                }

                ._2AR-3:dir(ltr) {
                    border-top-left-radius: 0;
                }

                [dir="rtl"] ._2AR-3 {
                    border-top-right-radius: 0;
                }

                ._2AR-3:dir(rtl) {
                    border-top-right-radius: 0;
                }

                ._2AR-3 {
                    border-start-start-radius: 0;
                }

                [dir="ltr"] .F7MHw {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                .F7MHw:dir(ltr) {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] .F7MHw {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                .F7MHw:dir(rtl) {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                .F7MHw {
                    border-end-start-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._15IwB {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                ._15IwB:dir(ltr) {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._15IwB {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._15IwB:dir(rtl) {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._15IwB {
                    border-end-start-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._3bz8z {
                    border-bottom-left-radius: 0;
                }

                ._3bz8z:dir(ltr) {
                    border-bottom-left-radius: 0;
                }

                [dir="rtl"] ._3bz8z {
                    border-bottom-right-radius: 0;
                }

                ._3bz8z:dir(rtl) {
                    border-bottom-right-radius: 0;
                }

                ._3bz8z {
                    border-end-start-radius: 0;
                }

                [dir="ltr"] ._1qYe7 {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._1qYe7:dir(ltr) {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._1qYe7 {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                ._1qYe7:dir(rtl) {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                ._1qYe7 {
                    border-start-end-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._1wAl_ {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                ._1wAl_:dir(ltr) {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._1wAl_ {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                ._1wAl_:dir(rtl) {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                ._1wAl_ {
                    border-start-end-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._2tYBM {
                    border-top-right-radius: 0;
                }

                ._2tYBM:dir(ltr) {
                    border-top-right-radius: 0;
                }

                [dir="rtl"] ._2tYBM {
                    border-top-left-radius: 0;
                }

                ._2tYBM:dir(rtl) {
                    border-top-left-radius: 0;
                }

                ._2tYBM {
                    border-start-end-radius: 0;
                }

                [dir="ltr"] ._2_VQw {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                ._2_VQw:dir(ltr) {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._2_VQw {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                ._2_VQw:dir(rtl) {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                ._2_VQw {
                    border-end-end-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._2pzxD {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._2pzxD:dir(ltr) {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._2pzxD {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                ._2pzxD:dir(rtl) {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                ._2pzxD {
                    border-end-end-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._1JHmC {
                    border-bottom-right-radius: 0;
                }

                ._1JHmC:dir(ltr) {
                    border-bottom-right-radius: 0;
                }

                [dir="rtl"] ._1JHmC {
                    border-bottom-left-radius: 0;
                }

                ._1JHmC:dir(rtl) {
                    border-bottom-left-radius: 0;
                }

                ._1JHmC {
                    border-end-end-radius: 0;
                }
            }

            @media screen and (min-width: 1000px) {
                [dir="ltr"] ._3tW60 {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                ._3tW60:dir(ltr) {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                [dir="rtl"] ._3tW60 {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                ._3tW60:dir(rtl) {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                ._3tW60 {
                    padding-inline-start: var(--x-pp-spacing-tight4x);
                }

                [dir="ltr"] ._2at2g {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                ._2at2g:dir(ltr) {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                [dir="rtl"] ._2at2g {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._2at2g:dir(rtl) {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._2at2g {
                    padding-inline-start: var(--x-pp-spacing-tight1x);
                }

                [dir="ltr"] ._2dBko {
                    padding-left: var(--x-pp-spacing-base);
                }

                ._2dBko:dir(ltr) {
                    padding-left: var(--x-pp-spacing-base);
                }

                [dir="rtl"] ._2dBko {
                    padding-right: var(--x-pp-spacing-base);
                }

                ._2dBko:dir(rtl) {
                    padding-right: var(--x-pp-spacing-base);
                }

                ._2dBko {
                    padding-inline-start: var(--x-pp-spacing-base);
                }

                [dir="ltr"] ._1YqfH {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                ._1YqfH:dir(ltr) {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                [dir="rtl"] ._1YqfH {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._1YqfH:dir(rtl) {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._1YqfH {
                    padding-inline-start: var(--x-pp-spacing-loose1x);
                }

                [dir="ltr"] ._16-t7 {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._16-t7:dir(ltr) {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                [dir="rtl"] ._16-t7 {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._16-t7:dir(rtl) {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._16-t7 {
                    padding-inline-start: var(--x-pp-spacing-loose4x);
                }

                [dir="ltr"] ._2QrX9 {
                    padding-left: 0;
                }

                ._2QrX9:dir(ltr) {
                    padding-left: 0;
                }

                [dir="rtl"] ._2QrX9 {
                    padding-right: 0;
                }

                ._2QrX9:dir(rtl) {
                    padding-right: 0;
                }

                ._2QrX9 {
                    padding-inline-start: 0;
                }

                [dir="ltr"] ._2XhXZ {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                ._2XhXZ:dir(ltr) {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                [dir="rtl"] ._2XhXZ {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                ._2XhXZ:dir(rtl) {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                ._2XhXZ {
                    padding-inline-end: var(--x-pp-spacing-tight4x);
                }

                [dir="ltr"] ._3ssdE {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._3ssdE:dir(ltr) {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                [dir="rtl"] ._3ssdE {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                ._3ssdE:dir(rtl) {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                ._3ssdE {
                    padding-inline-end: var(--x-pp-spacing-tight1x);
                }

                [dir="ltr"] ._1-Btl {
                    padding-right: var(--x-pp-spacing-base);
                }

                ._1-Btl:dir(ltr) {
                    padding-right: var(--x-pp-spacing-base);
                }

                [dir="rtl"] ._1-Btl {
                    padding-left: var(--x-pp-spacing-base);
                }

                ._1-Btl:dir(rtl) {
                    padding-left: var(--x-pp-spacing-base);
                }

                ._1-Btl {
                    padding-inline-end: var(--x-pp-spacing-base);
                }

                [dir="ltr"] .zgXPM {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                .zgXPM:dir(ltr) {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                [dir="rtl"] .zgXPM {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                .zgXPM:dir(rtl) {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                .zgXPM {
                    padding-inline-end: var(--x-pp-spacing-loose1x);
                }

                [dir="ltr"] ._1tRbL {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._1tRbL:dir(ltr) {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                [dir="rtl"] ._1tRbL {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._1tRbL:dir(rtl) {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._1tRbL {
                    padding-inline-end: var(--x-pp-spacing-loose4x);
                }

                [dir="ltr"] .UUwBf {
                    padding-right: 0;
                }

                .UUwBf:dir(ltr) {
                    padding-right: 0;
                }

                [dir="rtl"] .UUwBf {
                    padding-left: 0;
                }

                .UUwBf:dir(rtl) {
                    padding-left: 0;
                }

                .UUwBf {
                    padding-inline-end: 0;
                }

                ._3281i {
                    padding-top: var(--x-pp-spacing-tight4x);
                }

                ._2YbxR {
                    padding-top: var(--x-pp-spacing-tight1x);
                }

                ._24q5R {
                    padding-top: var(--x-pp-spacing-base);
                }

                ._28urC {
                    padding-top: var(--x-pp-spacing-loose1x);
                }

                ._1jvNn {
                    padding-top: var(--x-pp-spacing-loose4x);
                }

                ._3Hwf3 {
                    padding-top: 0;
                }

                ._3K5EC {
                    padding-bottom: var(--x-pp-spacing-tight4x);
                }

                ._23laN {
                    padding-bottom: var(--x-pp-spacing-tight1x);
                }

                ._1eiU5 {
                    padding-bottom: var(--x-pp-spacing-base);
                }

                .BsWYB {
                    padding-bottom: var(--x-pp-spacing-loose1x);
                }

                ._2R6Dh {
                    padding-bottom: var(--x-pp-spacing-loose4x);
                }

                ._2UXp2 {
                    padding-bottom: 0;
                }

                ._2Jvjw {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-primary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-primary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-primary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-primary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-primary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-primary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-primary-accent
                    );
                    background-color: var(--x-pp-color-surface-primary);
                }

                ._1h3t2,
                ._2Jvjw {
                    color: var(--x-pp-default-color-text);
                }

                ._1h3t2 {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-secondary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-secondary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-secondary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-secondary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-secondary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-secondary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-secondary-accent
                    );
                    background-color: var(--x-pp-color-surface-secondary);
                }

                .VGXpl {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-tertiary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-tertiary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-tertiary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-tertiary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-tertiary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-tertiary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-tertiary-accent
                    );
                    background-color: var(--x-pp-color-surface-tertiary);
                    color: var(--x-pp-default-color-text);
                }

                ._3ETVw {
                    background-color: transparent;
                }

                [dir="ltr"] ._3w-UV {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._3w-UV:dir(ltr) {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3w-UV {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._3w-UV:dir(rtl) {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._3w-UV {
                    border-inline-start: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] .bqmKm {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                .bqmKm:dir(ltr) {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] .bqmKm {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                .bqmKm:dir(rtl) {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                .bqmKm {
                    border-inline-start: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._3LHPN {
                    border-left: 0;
                }

                ._3LHPN:dir(ltr) {
                    border-left: 0;
                }

                [dir="rtl"] ._3LHPN {
                    border-right: 0;
                }

                ._3LHPN:dir(rtl) {
                    border-right: 0;
                }

                ._3LHPN {
                    border-inline-start: 0;
                }

                [dir="ltr"] ._3O267 {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._3O267:dir(ltr) {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3O267 {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._3O267:dir(rtl) {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._3O267 {
                    border-inline-end: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._3-gK- {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3-gK-:dir(ltr) {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3-gK- {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3-gK-:dir(rtl) {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3-gK- {
                    border-inline-end: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._1iUOB {
                    border-right: 0;
                }

                ._1iUOB:dir(ltr) {
                    border-right: 0;
                }

                [dir="rtl"] ._1iUOB {
                    border-left: 0;
                }

                ._1iUOB:dir(rtl) {
                    border-left: 0;
                }

                ._1iUOB {
                    border-inline-end: 0;
                }

                ._1RXrd {
                    border-top: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                .PoMNT {
                    border-top: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                .JMUmd {
                    border-top: 0;
                }

                .uFCKS {
                    border-bottom: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._iEgy {
                    border-bottom: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._1lZcQ {
                    border-bottom: 0;
                }

                [dir="ltr"] ._16u2p {
                    border-left-width: var(--x-pp-border-width-base);
                }

                ._16u2p:dir(ltr) {
                    border-left-width: var(--x-pp-border-width-base);
                }

                [dir="rtl"] ._16u2p {
                    border-right-width: var(--x-pp-border-width-base);
                }

                ._16u2p:dir(rtl) {
                    border-right-width: var(--x-pp-border-width-base);
                }

                ._16u2p {
                    border-inline-start-width: var(--x-pp-border-width-base);
                }

                [dir="ltr"] ._3YcCj {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                ._3YcCj:dir(ltr) {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                [dir="rtl"] ._3YcCj {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._3YcCj:dir(rtl) {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._3YcCj {
                    border-inline-start-width: var(--x-pp-border-width-thick);
                }

                [dir="ltr"] ._2qHFH {
                    border-right-width: var(--x-pp-border-width-base);
                }

                ._2qHFH:dir(ltr) {
                    border-right-width: var(--x-pp-border-width-base);
                }

                [dir="rtl"] ._2qHFH {
                    border-left-width: var(--x-pp-border-width-base);
                }

                ._2qHFH:dir(rtl) {
                    border-left-width: var(--x-pp-border-width-base);
                }

                ._2qHFH {
                    border-inline-end-width: var(--x-pp-border-width-base);
                }

                [dir="ltr"] ._1eCGA {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._1eCGA:dir(ltr) {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                [dir="rtl"] ._1eCGA {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                ._1eCGA:dir(rtl) {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                ._1eCGA {
                    border-inline-end-width: var(--x-pp-border-width-thick);
                }

                ._2NIhm {
                    border-top-width: var(--x-pp-border-width-base);
                }

                .y3pCd {
                    border-top-width: var(--x-pp-border-width-thick);
                }

                ._3SmpU {
                    border-bottom-width: var(--x-pp-border-width-base);
                }

                ._2n9BQ {
                    border-bottom-width: var(--x-pp-border-width-thick);
                }

                [dir="ltr"] .oV8R_ {
                    border-left-color: var(--x-pp-default-color-border);
                }

                .oV8R_:dir(ltr) {
                    border-left-color: var(--x-pp-default-color-border);
                }

                [dir="rtl"] .oV8R_ {
                    border-right-color: var(--x-pp-default-color-border);
                }

                .oV8R_:dir(rtl) {
                    border-right-color: var(--x-pp-default-color-border);
                }

                .oV8R_ {
                    border-inline-start-color: var(--x-pp-default-color-border);
                }

                [dir="ltr"] .PKcRA {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .PKcRA:dir(ltr) {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="rtl"] .PKcRA {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .PKcRA:dir(rtl) {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .PKcRA {
                    border-inline-start-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="ltr"] .cn2iG {
                    border-right-color: var(--x-pp-default-color-border);
                }

                .cn2iG:dir(ltr) {
                    border-right-color: var(--x-pp-default-color-border);
                }

                [dir="rtl"] .cn2iG {
                    border-left-color: var(--x-pp-default-color-border);
                }

                .cn2iG:dir(rtl) {
                    border-left-color: var(--x-pp-default-color-border);
                }

                .cn2iG {
                    border-inline-end-color: var(--x-pp-default-color-border);
                }

                [dir="ltr"] .Bzzma {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .Bzzma:dir(ltr) {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="rtl"] .Bzzma {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .Bzzma:dir(rtl) {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .Bzzma {
                    border-inline-end-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3Eif8 {
                    border-top-color: var(--x-pp-default-color-border);
                }

                ._1gbPu {
                    border-top-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._2466t {
                    border-bottom-color: var(--x-pp-default-color-border);
                }

                ._1dB9D {
                    border-bottom-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="ltr"] ._3v_eh {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                ._3v_eh:dir(ltr) {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._3v_eh {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._3v_eh:dir(rtl) {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._3v_eh {
                    border-start-start-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] .tgind {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                .tgind:dir(ltr) {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] .tgind {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                .tgind:dir(rtl) {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                .tgind {
                    border-start-start-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._1HaGX {
                    border-top-left-radius: 0;
                }

                ._1HaGX:dir(ltr) {
                    border-top-left-radius: 0;
                }

                [dir="rtl"] ._1HaGX {
                    border-top-right-radius: 0;
                }

                ._1HaGX:dir(rtl) {
                    border-top-right-radius: 0;
                }

                ._1HaGX {
                    border-start-start-radius: 0;
                }

                [dir="ltr"] ._2qxCm {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                ._2qxCm:dir(ltr) {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._2qxCm {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                ._2qxCm:dir(rtl) {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                ._2qxCm {
                    border-end-start-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._1ujGp {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                ._1ujGp:dir(ltr) {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._1ujGp {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._1ujGp:dir(rtl) {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._1ujGp {
                    border-end-start-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] .xelNG {
                    border-bottom-left-radius: 0;
                }

                .xelNG:dir(ltr) {
                    border-bottom-left-radius: 0;
                }

                [dir="rtl"] .xelNG {
                    border-bottom-right-radius: 0;
                }

                .xelNG:dir(rtl) {
                    border-bottom-right-radius: 0;
                }

                .xelNG {
                    border-end-start-radius: 0;
                }

                [dir="ltr"] .mvmU2 {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                .mvmU2:dir(ltr) {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] .mvmU2 {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                .mvmU2:dir(rtl) {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                .mvmU2 {
                    border-start-end-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] .-Ialb {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                .-Ialb:dir(ltr) {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] .-Ialb {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                .-Ialb:dir(rtl) {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                .-Ialb {
                    border-start-end-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._2uymI {
                    border-top-right-radius: 0;
                }

                ._2uymI:dir(ltr) {
                    border-top-right-radius: 0;
                }

                [dir="rtl"] ._2uymI {
                    border-top-left-radius: 0;
                }

                ._2uymI:dir(rtl) {
                    border-top-left-radius: 0;
                }

                ._2uymI {
                    border-start-end-radius: 0;
                }

                [dir="ltr"] ._2eKjz {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                ._2eKjz:dir(ltr) {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._2eKjz {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                ._2eKjz:dir(rtl) {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                ._2eKjz {
                    border-end-end-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._318CP {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._318CP:dir(ltr) {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._318CP {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                ._318CP:dir(rtl) {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                ._318CP {
                    border-end-end-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._1yI7H {
                    border-bottom-right-radius: 0;
                }

                ._1yI7H:dir(ltr) {
                    border-bottom-right-radius: 0;
                }

                [dir="rtl"] ._1yI7H {
                    border-bottom-left-radius: 0;
                }

                ._1yI7H:dir(rtl) {
                    border-bottom-left-radius: 0;
                }

                ._1yI7H {
                    border-end-end-radius: 0;
                }
            }

            @media screen and (min-width: 1200px) {
                [dir="ltr"] .I_FZf {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                .I_FZf:dir(ltr) {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                [dir="rtl"] .I_FZf {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                .I_FZf:dir(rtl) {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                .I_FZf {
                    padding-inline-start: var(--x-pp-spacing-tight4x);
                }

                [dir="ltr"] ._2ioHY {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                ._2ioHY:dir(ltr) {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                [dir="rtl"] ._2ioHY {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._2ioHY:dir(rtl) {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._2ioHY {
                    padding-inline-start: var(--x-pp-spacing-tight1x);
                }

                [dir="ltr"] .rbs1C {
                    padding-left: var(--x-pp-spacing-base);
                }

                .rbs1C:dir(ltr) {
                    padding-left: var(--x-pp-spacing-base);
                }

                [dir="rtl"] .rbs1C {
                    padding-right: var(--x-pp-spacing-base);
                }

                .rbs1C:dir(rtl) {
                    padding-right: var(--x-pp-spacing-base);
                }

                .rbs1C {
                    padding-inline-start: var(--x-pp-spacing-base);
                }

                [dir="ltr"] ._3OKa8 {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                ._3OKa8:dir(ltr) {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                [dir="rtl"] ._3OKa8 {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._3OKa8:dir(rtl) {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._3OKa8 {
                    padding-inline-start: var(--x-pp-spacing-loose1x);
                }

                [dir="ltr"] ._2G7Wz {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._2G7Wz:dir(ltr) {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                [dir="rtl"] ._2G7Wz {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._2G7Wz:dir(rtl) {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._2G7Wz {
                    padding-inline-start: var(--x-pp-spacing-loose4x);
                }

                [dir="ltr"] ._3RRum {
                    padding-left: 0;
                }

                ._3RRum:dir(ltr) {
                    padding-left: 0;
                }

                [dir="rtl"] ._3RRum {
                    padding-right: 0;
                }

                ._3RRum:dir(rtl) {
                    padding-right: 0;
                }

                ._3RRum {
                    padding-inline-start: 0;
                }

                [dir="ltr"] ._84d0N {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                ._84d0N:dir(ltr) {
                    padding-right: var(--x-pp-spacing-tight4x);
                }

                [dir="rtl"] ._84d0N {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                ._84d0N:dir(rtl) {
                    padding-left: var(--x-pp-spacing-tight4x);
                }

                ._84d0N {
                    padding-inline-end: var(--x-pp-spacing-tight4x);
                }

                [dir="ltr"] ._3BJDx {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                ._3BJDx:dir(ltr) {
                    padding-right: var(--x-pp-spacing-tight1x);
                }

                [dir="rtl"] ._3BJDx {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                ._3BJDx:dir(rtl) {
                    padding-left: var(--x-pp-spacing-tight1x);
                }

                ._3BJDx {
                    padding-inline-end: var(--x-pp-spacing-tight1x);
                }

                [dir="ltr"] ._3xUnO {
                    padding-right: var(--x-pp-spacing-base);
                }

                ._3xUnO:dir(ltr) {
                    padding-right: var(--x-pp-spacing-base);
                }

                [dir="rtl"] ._3xUnO {
                    padding-left: var(--x-pp-spacing-base);
                }

                ._3xUnO:dir(rtl) {
                    padding-left: var(--x-pp-spacing-base);
                }

                ._3xUnO {
                    padding-inline-end: var(--x-pp-spacing-base);
                }

                [dir="ltr"] ._1veLO {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                ._1veLO:dir(ltr) {
                    padding-right: var(--x-pp-spacing-loose1x);
                }

                [dir="rtl"] ._1veLO {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                ._1veLO:dir(rtl) {
                    padding-left: var(--x-pp-spacing-loose1x);
                }

                ._1veLO {
                    padding-inline-end: var(--x-pp-spacing-loose1x);
                }

                [dir="ltr"] ._3A981 {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                ._3A981:dir(ltr) {
                    padding-right: var(--x-pp-spacing-loose4x);
                }

                [dir="rtl"] ._3A981 {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._3A981:dir(rtl) {
                    padding-left: var(--x-pp-spacing-loose4x);
                }

                ._3A981 {
                    padding-inline-end: var(--x-pp-spacing-loose4x);
                }

                [dir="ltr"] .BwpuP {
                    padding-right: 0;
                }

                .BwpuP:dir(ltr) {
                    padding-right: 0;
                }

                [dir="rtl"] .BwpuP {
                    padding-left: 0;
                }

                .BwpuP:dir(rtl) {
                    padding-left: 0;
                }

                .BwpuP {
                    padding-inline-end: 0;
                }

                ._3m4Pd {
                    padding-top: var(--x-pp-spacing-tight4x);
                }

                ._3ZdSL {
                    padding-top: var(--x-pp-spacing-tight1x);
                }

                ._2NOhT {
                    padding-top: var(--x-pp-spacing-base);
                }

                ._26yzn {
                    padding-top: var(--x-pp-spacing-loose1x);
                }

                ._1_Sg1 {
                    padding-top: var(--x-pp-spacing-loose4x);
                }

                ._3Nt8C {
                    padding-top: 0;
                }

                ._3rjPC {
                    padding-bottom: var(--x-pp-spacing-tight4x);
                }

                .FlNcg {
                    padding-bottom: var(--x-pp-spacing-tight1x);
                }

                ._1BNFm {
                    padding-bottom: var(--x-pp-spacing-base);
                }

                ._3-zDQ {
                    padding-bottom: var(--x-pp-spacing-loose1x);
                }

                ._1PbA8 {
                    padding-bottom: var(--x-pp-spacing-loose4x);
                }

                ._3Qm89 {
                    padding-bottom: 0;
                }

                ._18cCX {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-primary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-primary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-primary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-primary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-primary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-primary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-primary-accent
                    );
                    background-color: var(--x-pp-color-surface-primary);
                }

                ._2GfX9,
                ._18cCX {
                    color: var(--x-pp-default-color-text);
                }

                ._2GfX9 {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-secondary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-secondary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-secondary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-secondary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-secondary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-secondary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-secondary-accent
                    );
                    background-color: var(--x-pp-color-surface-secondary);
                }

                ._4-Zxx {
                    --x-pp-default-color-subdued: var(
                        --x-pp-color-surface-tertiary-subdued
                    );
                    --x-pp-default-color-text: var(
                        --x-pp-color-surface-tertiary-text
                    );
                    --x-pp-default-color-text-subdued: var(
                        --x-pp-color-surface-tertiary-text-subdued
                    );
                    --x-pp-default-color-text-emphasized: var(
                        --x-pp-color-surface-tertiary-text-emphasized
                    );
                    --x-pp-default-color-border: var(
                        --x-pp-color-surface-tertiary-border
                    );
                    --x-pp-default-color-border-emphasized: var(
                        --x-pp-color-surface-tertiary-border-emphasized
                    );
                    --x-pp-default-color-accent: var(
                        --x-pp-color-surface-tertiary-accent
                    );
                    background-color: var(--x-pp-color-surface-tertiary);
                    color: var(--x-pp-default-color-text);
                }

                ._1zhCy {
                    background-color: transparent;
                }

                [dir="ltr"] ._2U9Ah {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2U9Ah:dir(ltr) {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._2U9Ah {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2U9Ah:dir(rtl) {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._2U9Ah {
                    border-inline-start: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._1tY1s {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._1tY1s:dir(ltr) {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._1tY1s {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._1tY1s:dir(rtl) {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._1tY1s {
                    border-inline-start: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._1LGoH {
                    border-left: 0;
                }

                ._1LGoH:dir(ltr) {
                    border-left: 0;
                }

                [dir="rtl"] ._1LGoH {
                    border-right: 0;
                }

                ._1LGoH:dir(rtl) {
                    border-right: 0;
                }

                ._1LGoH {
                    border-inline-start: 0;
                }

                [dir="ltr"] ._16UWK {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._16UWK:dir(ltr) {
                    border-right: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._16UWK {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._16UWK:dir(rtl) {
                    border-left: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._16UWK {
                    border-inline-end: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._3fT9O {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3fT9O:dir(ltr) {
                    border-right: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3fT9O {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3fT9O:dir(rtl) {
                    border-left: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._3fT9O {
                    border-inline-end: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._3wyjp {
                    border-right: 0;
                }

                ._3wyjp:dir(ltr) {
                    border-right: 0;
                }

                [dir="rtl"] ._3wyjp {
                    border-left: 0;
                }

                ._3wyjp:dir(rtl) {
                    border-left: 0;
                }

                ._3wyjp {
                    border-inline-end: 0;
                }

                ._3t70n {
                    border-top: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._3GAlB {
                    border-top: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._2RDFV {
                    border-top: 0;
                }

                ._3eTzM {
                    border-bottom: var(--x-pp-border-width-base) solid
                        var(--x-pp-default-color-border);
                }

                ._1ePw4 {
                    border-bottom: var(--x-pp-border-width-base) dotted
                        var(--x-pp-default-color-border);
                }

                ._2ckFA {
                    border-bottom: 0;
                }

                [dir="ltr"] .NgJbR {
                    border-left-width: var(--x-pp-border-width-base);
                }

                .NgJbR:dir(ltr) {
                    border-left-width: var(--x-pp-border-width-base);
                }

                [dir="rtl"] .NgJbR {
                    border-right-width: var(--x-pp-border-width-base);
                }

                .NgJbR:dir(rtl) {
                    border-right-width: var(--x-pp-border-width-base);
                }

                .NgJbR {
                    border-inline-start-width: var(--x-pp-border-width-base);
                }

                [dir="ltr"] ._2DLtY {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                ._2DLtY:dir(ltr) {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                [dir="rtl"] ._2DLtY {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._2DLtY:dir(rtl) {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._2DLtY {
                    border-inline-start-width: var(--x-pp-border-width-thick);
                }

                [dir="ltr"] ._2r7hT {
                    border-right-width: var(--x-pp-border-width-base);
                }

                ._2r7hT:dir(ltr) {
                    border-right-width: var(--x-pp-border-width-base);
                }

                [dir="rtl"] ._2r7hT {
                    border-left-width: var(--x-pp-border-width-base);
                }

                ._2r7hT:dir(rtl) {
                    border-left-width: var(--x-pp-border-width-base);
                }

                ._2r7hT {
                    border-inline-end-width: var(--x-pp-border-width-base);
                }

                [dir="ltr"] ._3C_NR {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                ._3C_NR:dir(ltr) {
                    border-right-width: var(--x-pp-border-width-thick);
                }

                [dir="rtl"] ._3C_NR {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                ._3C_NR:dir(rtl) {
                    border-left-width: var(--x-pp-border-width-thick);
                }

                ._3C_NR {
                    border-inline-end-width: var(--x-pp-border-width-thick);
                }

                .AW2nQ {
                    border-top-width: var(--x-pp-border-width-base);
                }

                ._2tWXC {
                    border-top-width: var(--x-pp-border-width-thick);
                }

                ._13qLQ {
                    border-bottom-width: var(--x-pp-border-width-base);
                }

                .tX2Oz {
                    border-bottom-width: var(--x-pp-border-width-thick);
                }

                [dir="ltr"] ._3iITt {
                    border-left-color: var(--x-pp-default-color-border);
                }

                ._3iITt:dir(ltr) {
                    border-left-color: var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3iITt {
                    border-right-color: var(--x-pp-default-color-border);
                }

                ._3iITt:dir(rtl) {
                    border-right-color: var(--x-pp-default-color-border);
                }

                ._3iITt {
                    border-inline-start-color: var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._1L5B3 {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._1L5B3:dir(ltr) {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="rtl"] ._1L5B3 {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._1L5B3:dir(rtl) {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._1L5B3 {
                    border-inline-start-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="ltr"] ._3vIko {
                    border-right-color: var(--x-pp-default-color-border);
                }

                ._3vIko:dir(ltr) {
                    border-right-color: var(--x-pp-default-color-border);
                }

                [dir="rtl"] ._3vIko {
                    border-left-color: var(--x-pp-default-color-border);
                }

                ._3vIko:dir(rtl) {
                    border-left-color: var(--x-pp-default-color-border);
                }

                ._3vIko {
                    border-inline-end-color: var(--x-pp-default-color-border);
                }

                [dir="ltr"] ._3Zot9 {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3Zot9:dir(ltr) {
                    border-right-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="rtl"] ._3Zot9 {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3Zot9:dir(rtl) {
                    border-left-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3Zot9 {
                    border-inline-end-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                ._3VnrC {
                    border-top-color: var(--x-pp-default-color-border);
                }

                ._1Dbv3 {
                    border-top-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                .kH0JU {
                    border-bottom-color: var(--x-pp-default-color-border);
                }

                ._5ysJM {
                    border-bottom-color: var(
                        --x-pp-default-color-border-emphasized
                    );
                }

                [dir="ltr"] ._1dn5s {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                ._1dn5s:dir(ltr) {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._1dn5s {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._1dn5s:dir(rtl) {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._1dn5s {
                    border-start-start-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] .cEHI4 {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                .cEHI4:dir(ltr) {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] .cEHI4 {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                .cEHI4:dir(rtl) {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                .cEHI4 {
                    border-start-start-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._1Sf8o {
                    border-top-left-radius: 0;
                }

                ._1Sf8o:dir(ltr) {
                    border-top-left-radius: 0;
                }

                [dir="rtl"] ._1Sf8o {
                    border-top-right-radius: 0;
                }

                ._1Sf8o:dir(rtl) {
                    border-top-right-radius: 0;
                }

                ._1Sf8o {
                    border-start-start-radius: 0;
                }

                [dir="ltr"] .iiVoJ {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                .iiVoJ:dir(ltr) {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] .iiVoJ {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                .iiVoJ:dir(rtl) {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                .iiVoJ {
                    border-end-start-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._1xvG2 {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                ._1xvG2:dir(ltr) {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._1xvG2 {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._1xvG2:dir(rtl) {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                ._1xvG2 {
                    border-end-start-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._2TeYn {
                    border-bottom-left-radius: 0;
                }

                ._2TeYn:dir(ltr) {
                    border-bottom-left-radius: 0;
                }

                [dir="rtl"] ._2TeYn {
                    border-bottom-right-radius: 0;
                }

                ._2TeYn:dir(rtl) {
                    border-bottom-right-radius: 0;
                }

                ._2TeYn {
                    border-end-start-radius: 0;
                }

                [dir="ltr"] ._1IGpY {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                ._1IGpY:dir(ltr) {
                    border-top-right-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._1IGpY {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                ._1IGpY:dir(rtl) {
                    border-top-left-radius: var(--x-pp-border-radius-tight);
                }

                ._1IGpY {
                    border-start-end-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] ._3w-YW {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                ._3w-YW:dir(ltr) {
                    border-top-right-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] ._3w-YW {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                ._3w-YW:dir(rtl) {
                    border-top-left-radius: var(--x-pp-border-radius-base);
                }

                ._3w-YW {
                    border-start-end-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] .AtnDH {
                    border-top-right-radius: 0;
                }

                .AtnDH:dir(ltr) {
                    border-top-right-radius: 0;
                }

                [dir="rtl"] .AtnDH {
                    border-top-left-radius: 0;
                }

                .AtnDH:dir(rtl) {
                    border-top-left-radius: 0;
                }

                .AtnDH {
                    border-start-end-radius: 0;
                }

                [dir="ltr"] ._2S_56 {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                ._2S_56:dir(ltr) {
                    border-bottom-right-radius: var(--x-pp-border-radius-tight);
                }

                [dir="rtl"] ._2S_56 {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                ._2S_56:dir(rtl) {
                    border-bottom-left-radius: var(--x-pp-border-radius-tight);
                }

                ._2S_56 {
                    border-end-end-radius: var(--x-pp-border-radius-tight);
                }

                [dir="ltr"] .aVE3r {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                .aVE3r:dir(ltr) {
                    border-bottom-right-radius: var(--x-pp-border-radius-base);
                }

                [dir="rtl"] .aVE3r {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                .aVE3r:dir(rtl) {
                    border-bottom-left-radius: var(--x-pp-border-radius-base);
                }

                .aVE3r {
                    border-end-end-radius: var(--x-pp-border-radius-base);
                }

                [dir="ltr"] ._3Gy8T {
                    border-bottom-right-radius: 0;
                }

                ._3Gy8T:dir(ltr) {
                    border-bottom-right-radius: 0;
                }

                [dir="rtl"] ._3Gy8T {
                    border-bottom-left-radius: 0;
                }

                ._3Gy8T:dir(rtl) {
                    border-bottom-left-radius: 0;
                }

                ._3Gy8T {
                    border-end-end-radius: 0;
                }
            }

            ._3wX9T {
                display: flex;
                flex-direction: column;
            }

            ._3wX9T > * + * {
                margin-top: var(--x-pp-spacing-base);
            }

            ._3wX9T ._3wX9T {
                min-width: 0;
            }

            @supports (display: grid) {
                ._3wX9T {
                    display: grid;
                    grid-row-gap: var(--x-pp-spacing-base);
                }

                ._3wX9T > * + * {
                    margin-top: 0 !important;
                }
            }

            ._2FBZd > * + * {
                margin-top: 0;
            }

            @supports (display: grid) {
                ._2FBZd {
                    grid-row-gap: 0;
                }
            }

            ._3DN_h > * + * {
                margin-top: var(--x-pp-spacing-tight4x);
            }

            @supports (display: grid) {
                ._3DN_h {
                    grid-row-gap: var(--x-pp-spacing-tight4x);
                }
            }

            ._1FdNY > * + * {
                margin-top: var(--x-pp-spacing-tight1x);
            }

            @supports (display: grid) {
                ._1FdNY {
                    grid-row-gap: var(--x-pp-spacing-tight1x);
                }
            }

            ._3PLpD > * + * {
                margin-top: var(--x-pp-spacing-loose1x);
            }

            @supports (display: grid) {
                ._3PLpD {
                    grid-row-gap: var(--x-pp-spacing-loose1x);
                }
            }

            ._1T-Tv > * + * {
                margin-top: var(--x-pp-spacing-loose4x);
            }

            @supports (display: grid) {
                ._1T-Tv {
                    grid-row-gap: var(--x-pp-spacing-loose4x);
                }
            }

            ._38sPw {
                align-items: flex-start;
            }

            @supports (display: grid) {
                ._38sPw {
                    justify-items: start;
                }
            }

            ._9vfrD {
                align-items: center;
            }

            @supports (display: grid) {
                ._9vfrD {
                    justify-items: center;
                }
            }

            ._3HT-s {
                align-items: flex-end;
            }

            @supports (display: grid) {
                ._3HT-s {
                    justify-items: end;
                }
            }

            ._27XPT {
                -webkit-tap-highlight-color: transparent;
                -webkit-touch-callout: none;
                position: relative;
                cursor: pointer;
                background-color: var(--x-pp-color-primary-action);
                border-radius: var(
                    --x-pp-control-border-radius,
                    var(--x-pp-global-border-radius)
                );
                color: var(--x-pp-color-primary-action-text);
                display: inline-block;
                font-weight: var(--x-pp-typography-primary-weight-bold);
                padding: var(--x-pp-primary-button-block-padding)
                    var(--x-pp-primary-button-inline-padding);
                text-align: center;
                text-decoration: none;
                text-transform: var(--x-pp-global-typography-letter-case);
                transition: background-color var(--x-pp-duration-base)
                        var(--x-pp-timing-base),
                    color var(--x-pp-duration-base) var(--x-pp-timing-base);
            }

            ._27XPT:hover {
                background-color: var(--x-pp-color-primary-action-hovered);
            }

            ._27XPT:active {
                background-color: var(--x-pp-color-primary-action-pressed);
                outline: none;
            }

            @media (-ms-high-contrast: active) {
                ._27XPT {
                    border: 1px solid transparent;
                }
            }

            ._1nMwn {
                --this-line-height: 1.5rem;
                display: block;
                line-height: var(--this-line-height);
            }

            ._1nMwn,
            ._3HPXu {
                transition: opacity var(--x-pp-duration-slow)
                    var(--x-pp-timing-base);
            }

            .QH6Al {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }

            ._1eo9I,
            ._1NG2H {
                background-color: transparent;
                color: var(--x-pp-color-primary-action);
            }

            ._1eo9I:hover,
            ._1NG2H:hover {
                background-color: transparent;
                color: var(--x-pp-color-primary-action-hovered);
            }

            ._1eo9I:active,
            ._1NG2H:active {
                background-color: transparent;
                color: var(--x-pp-color-primary-action-pressed);
            }

            ._1NG2H {
                font-weight: var(--x-pp-typography-primary-weight-base);
                padding: 0;
                border-radius: var(--x-pp-border-radius-none);
                background-color: var(--x-pp-color-interactive);
                color: var(--x-pp-color-interactive-text);
                transition: background-color var(--x-pp-duration-base)
                        var(--x-pp-timing-base),
                    color var(--x-pp-duration-base) var(--x-pp-timing-base);
            }

            ._1NG2H:hover {
                --this-background-color: var(--x-pp-color-interactive-hovered);
                --this-color: var(--x-pp-color-interactive-text-hovered);
            }

            ._1NG2H:active,
            ._1NG2H:hover {
                background-color: var(--this-background-color);
                color: var(--this-color);
            }

            ._1NG2H:active {
                --this-background-color: var(--x-pp-color-interactive-pressed);
                --this-color: var(--x-pp-color-interactive-text-pressed);
            }

            ._1NG2H:before {
                content: "";
                position: absolute;
                top: -0.35714285714285715em;
                right: -0.35714285714285715em;
                bottom: -0.35714285714285715em;
                left: -0.35714285714285715em;
                inset: -0.35714285714285715em;
                z-index: 0;
            }

            @media (any-hover: none) {
                ._1NG2H:before {
                    top: -1.4285714285714286em;
                    right: -1.7142857142857142em;
                    bottom: -1.4285714285714286em;
                    left: -1.7142857142857142em;
                    inset: -1.4285714285714286em -1.7142857142857142em;
                }
            }

            ._1NG2H ._1nMwn {
                z-index: 1;
                position: relative;
            }

            .YX2nA {
                text-decoration: underline;
            }

            ._1CTFL {
                display: flex;
                justify-content: center;
                min-width: 100%;
            }

            ._1CTFL._1NG2H {
                margin: 0;
                padding: 0;
            }

            ._1eo9I {
                box-shadow: inset 0 0 0 1px var(--x-pp-default-color-border);
            }

            ._8QxH9,
            ._37HTG {
                pointer-events: none;
                cursor: default;
            }

            ._8QxH9 {
                background-color: #d9d9d9;
                color: #fff;
            }

            ._8QxH9._1NG2H {
                margin: 0;
                padding: 0;
                background-color: transparent;
                color: var(--x-pp-color-interactive-text);
                opacity: 0.5;
            }

            ._139fW ._3HPXu {
                opacity: 0;
            }

            @media screen and (prefers-reduced-motion: reduce) {
                ._139fW ._1nMwn {
                    display: none;
                }
            }

            ._2j3Jd ._3HPXu,
            ._3TbcB ._3HPXu {
                opacity: 1;
            }

            ._2j3Jd ._1nMwn,
            ._3TbcB ._1nMwn {
                opacity: 0;
            }

            @media screen and (prefers-reduced-motion: reduce) {
                ._2j3Jd ._1nMwn,
                ._3TbcB ._1nMwn {
                    display: none;
                }
            }

            .uL_xf {
                background-color: var(--x-pp-color-secondary-action);
                color: var(--x-pp-color-secondary-action-text);
                padding: var(--x-pp-secondary-button-block-padding)
                    var(--x-pp-secondary-button-inline-padding);
            }

            .uL_xf:hover {
                background-color: var(--x-pp-color-secondary-action-hovered);
            }

            .uL_xf:active {
                background-color: var(--x-pp-color-secondary-action-pressed);
                outline: none;
            }

            ._1LoTz {
                background-color: var(--x-pp-color-tertiary-action);
                color: var(--x-pp-color-tertiary-action-text);
                padding: var(--x-pp-tertiary-button-block-padding)
                    var(--x-pp-tertiary-button-inline-padding);
            }

            ._3Xw_I {
                padding-bottom: 0;
                padding-top: 0;
                height: 3.357142857142857em;
            }

            ._3puka {
                pointer-events: none;
                cursor: default;
                background-color: var(--x-pp-color-primary-action-pressed);
                position: relative;
                overflow: hidden;
            }

            ._3puka ._1nMwn {
                position: relative;
                z-index: 1;
            }

            ._3puka:before {
                content: "";
                position: absolute;
                background-color: var(--x-pp-color-primary-action);
                z-index: 0;
                left: 0;
                top: 0;
                bottom: 0;
                width: 100%;
                transform: scaleX(0);
                transform-origin: left;
                animation-name: o2n7_;
                animation-duration: 20s;
                animation-iteration-count: infinite;
                animation-timing-function: cubic-bezier(0, 1, 0.5, 1);
                animation-delay: var(--x-pp-duration-base);
            }

            ._3puka.uL_xf {
                background-color: var(--x-pp-color-secondary-action-pressed);
            }

            ._3puka.uL_xf:before {
                background-color: var(--x-pp-color-secondary-action);
            }

            ._3puka._8QxH9 {
                background-color: #d9d9d9;
            }

            ._3puka._8QxH9:before {
                background-color: #bfbfbf;
            }

            ._3puka._1eo9I,
            ._3puka._1NG2H {
                background-color: transparent;
            }

            ._3puka._1eo9I:before,
            ._3puka._1NG2H:before {
                background-color: var(--x-pp-color-primary-action);
                top: calc(100% - 0.2rem);
            }

            @media screen and (prefers-reduced-motion: reduce) {
                ._3puka:before {
                    animation: none;
                }
            }

            @keyframes o2n7_ {
                0% {
                    transform: scaleX(0);
                }

                5% {
                    transform: scaleX(0.2);
                }

                10% {
                    transform: scaleX(0.25);
                }

                15% {
                    transform: scaleX(0.3);
                }

                20% {
                    transform: scaleX(0.35);
                }

                25% {
                    transform: scaleX(0.45);
                }

                30% {
                    transform: scaleX(0.5);
                }

                35% {
                    transform: scaleX(0.55);
                }

                40% {
                    transform: scaleX(0.6);
                }

                45% {
                    transform: scaleX(0.7);
                }

                50% {
                    transform: scaleX(0.8);
                }

                55% {
                    transform: scaleX(0.82);
                }

                60% {
                    transform: scaleX(0.84);
                }

                65% {
                    transform: scaleX(0.86);
                }

                70% {
                    transform: scaleX(0.88);
                }

                75% {
                    transform: scaleX(0.9);
                }

                80% {
                    transform: scaleX(0.92);
                }

                85% {
                    transform: scaleX(0.94);
                }

                90% {
                    transform: scaleX(0.96);
                }

                95% {
                    transform: scaleX(0.98);
                }

                to {
                    transform: scaleX(1);
                }
            }

            ._1X_K7:hover {
                background-color: var(
                    --x-pp-color1,
                    var(--this-background-color)
                );
                color: var(--x-pp-color1-text, var(--this-color));
            }

            .QNlYK:hover {
                background-color: var(
                    --x-pp-color2,
                    var(--this-background-color)
                );
                color: var(--x-pp-color2-text, var(--this-color));
            }

            .YJ3-H:active {
                background-color: var(
                    --x-pp-color1,
                    var(--this-background-color)
                );
                color: var(--x-pp-color1-text, var(--this-color));
            }

            .smLej:active {
                background-color: var(
                    --x-pp-color2,
                    var(--this-background-color)
                );
                color: var(--x-pp-color2-text, var(--this-color));
            }

            ._1NwhN {
                width: 2.2857142857142856em;
                height: 2.2857142857142856em;
                animation: _2S4vy 0.5s var(--x-pp-timing-base),
                    GNaLB 0.5s linear infinite;
            }

            ._3m9hD {
                width: 4.571428571428571em;
                height: 4.571428571428571em;
            }

            ._17-Jx {
                width: 1.4285714285714286em;
                height: 1.4285714285714286em;
            }

            @keyframes GNaLB {
                0% {
                    transform: rotate(0);
                }

                to {
                    transform: rotate(1turn);
                }
            }

            @keyframes _2S4vy {
                0% {
                    opacity: 0;
                }

                to {
                    opacity: 1;
                }
            }

            ._3qJyW {
                display: flex;
            }

            [dir="ltr"] ._3qJyW > * + * {
                margin-left: var(--x-pp-spacing-base);
            }

            ._3qJyW > * + :dir(ltr) {
                margin-left: var(--x-pp-spacing-base);
            }

            [dir="rtl"] ._3qJyW > * + * {
                margin-right: var(--x-pp-spacing-base);
            }

            ._3qJyW > * + :dir(rtl) {
                margin-right: var(--x-pp-spacing-base);
            }

            ._3qJyW > * + * {
                margin-inline-start: var(--x-pp-spacing-base);
            }

            @supports (display: grid) {
                ._3qJyW {
                    display: grid;
                    grid-auto-flow: column;
                    grid-auto-columns: auto;
                    grid-column-gap: var(--x-pp-spacing-base);
                    justify-content: start;
                }

                [dir="ltr"] ._3qJyW > * + * {
                    margin-left: 0 !important;
                }

                ._3qJyW > * + :dir(ltr) {
                    margin-left: 0 !important;
                }

                [dir="rtl"] ._3qJyW > * + * {
                    margin-right: 0 !important;
                }

                ._3qJyW > * + :dir(rtl) {
                    margin-right: 0 !important;
                }

                ._3qJyW > * + * {
                    margin-inline-start: 0 !important;
                }
            }

            [dir="ltr"] ._3XTCL > * + * {
                margin-left: var(--x-pp-spacing-tight4x);
            }

            ._3XTCL > * + :dir(ltr) {
                margin-left: var(--x-pp-spacing-tight4x);
            }

            [dir="rtl"] ._3XTCL > * + * {
                margin-right: var(--x-pp-spacing-tight4x);
            }

            ._3XTCL > * + :dir(rtl) {
                margin-right: var(--x-pp-spacing-tight4x);
            }

            ._3XTCL > * + * {
                margin-inline-start: var(--x-pp-spacing-tight4x);
            }

            @supports (display: grid) {
                ._3XTCL {
                    grid-column-gap: var(--x-pp-spacing-tight4x);
                }
            }

            [dir="ltr"] ._1ZZld > * + * {
                margin-left: var(--x-pp-spacing-tight1x);
            }

            ._1ZZld > * + :dir(ltr) {
                margin-left: var(--x-pp-spacing-tight1x);
            }

            [dir="rtl"] ._1ZZld > * + * {
                margin-right: var(--x-pp-spacing-tight1x);
            }

            ._1ZZld > * + :dir(rtl) {
                margin-right: var(--x-pp-spacing-tight1x);
            }

            ._1ZZld > * + * {
                margin-inline-start: var(--x-pp-spacing-tight1x);
            }

            @supports (display: grid) {
                ._1ZZld {
                    grid-column-gap: var(--x-pp-spacing-tight1x);
                }
            }

            [dir="ltr"] ._1MnBk > * + * {
                margin-left: var(--x-pp-spacing-loose1x);
            }

            ._1MnBk > * + :dir(ltr) {
                margin-left: var(--x-pp-spacing-loose1x);
            }

            [dir="rtl"] ._1MnBk > * + * {
                margin-right: var(--x-pp-spacing-loose1x);
            }

            ._1MnBk > * + :dir(rtl) {
                margin-right: var(--x-pp-spacing-loose1x);
            }

            ._1MnBk > * + * {
                margin-inline-start: var(--x-pp-spacing-loose1x);
            }

            @supports (display: grid) {
                ._1MnBk {
                    grid-column-gap: var(--x-pp-spacing-loose1x);
                }
            }

            [dir="ltr"] ._3tobL > * + * {
                margin-left: var(--x-pp-spacing-loose4x);
            }

            ._3tobL > * + :dir(ltr) {
                margin-left: var(--x-pp-spacing-loose4x);
            }

            [dir="rtl"] ._3tobL > * + * {
                margin-right: var(--x-pp-spacing-loose4x);
            }

            ._3tobL > * + :dir(rtl) {
                margin-right: var(--x-pp-spacing-loose4x);
            }

            ._3tobL > * + * {
                margin-inline-start: var(--x-pp-spacing-loose4x);
            }

            @supports (display: grid) {
                ._3tobL {
                    grid-column-gap: var(--x-pp-spacing-loose4x);
                }
            }

            .-ropj {
                align-items: flex-start;
            }

            @supports (display: grid) {
                .-ropj {
                    align-items: start;
                }
            }

            ._1mnjF {
                align-items: center;
            }

            @supports (display: grid) {
                ._1mnjF {
                    align-items: center;
                }
            }

            ._1jTYS {
                align-items: flex-end;
            }

            @supports (display: grid) {
                ._1jTYS {
                    align-items: end;
                }
            }

            .sxT8J {
                align-items: baseline;
            }

            @supports (display: grid) {
                .sxT8J {
                    align-items: baseline;
                }
            }

            .nYAgh {
                -webkit-tap-highlight-color: transparent;
                -webkit-touch-callout: none;
                text-decoration: none;
                background-color: var(--x-pp-color-interactive);
                color: var(--x-pp-color-interactive-text);
                transition: color var(--x-pp-link-transition-duration)
                        var(--x-pp-timing-base),
                    background-color var(--x-pp-link-transition-duration)
                        var(--x-pp-timing-base);
            }

            .nYAgh:hover {
                --this-background-color: var(--x-pp-color-interactive-hovered);
                --this-color: var(--x-pp-color-interactive-text-hovered);
            }

            .nYAgh:active,
            .nYAgh:hover {
                background-color: var(--this-background-color);
                color: var(--this-color);
            }

            .nYAgh:active {
                --this-background-color: var(--x-pp-color-interactive-pressed);
                --this-color: var(--x-pp-color-interactive-text-pressed);
            }

            .QFLC8 {
                text-decoration: underline;
            }

            .GwgnG:hover {
                background-color: var(
                    --x-pp-color1,
                    var(--this-background-color)
                );
                color: var(--x-pp-color1-text, var(--this-color));
            }

            ._1hRZ-:hover {
                background-color: var(
                    --x-pp-color2,
                    var(--this-background-color)
                );
                color: var(--x-pp-color2-text, var(--this-color));
            }

            .FUFD5:active {
                background-color: var(
                    --x-pp-color1,
                    var(--this-background-color)
                );
                color: var(--x-pp-color1-text, var(--this-color));
            }

            ._2t6Uu:active {
                background-color: var(
                    --x-pp-color2,
                    var(--this-background-color)
                );
                color: var(--x-pp-color2-text, var(--this-color));
            }

            ._1fSPJ {
                display: grid;
                justify-content: start;
                align-items: start;
                grid-template:
                    "checkbox gap label" auto/auto var(--x-pp-spacing-tight1x)
                    auto;
            }

            ._2rttc {
                grid-template:
                    "checkbox gap label" auto "row-gap row-gap row-gap" var(
                        --x-pp-spacing-tight1x
                    )
                    "error error error" auto/auto var(--x-pp-spacing-tight1x)
                    auto;
            }

            ._2rttc.DBosH {
                grid-template:
                    "checkbox gap label" auto "row-gap row-gap row-gap" var(
                        --x-pp-spacing-tight1x
                    )
                    "error-gap error-gap error" auto/auto var(
                        --x-pp-spacing-tight1x
                    )
                    auto;
            }

            .fLJIa {
                position: relative;
                margin-top: -1px;
                grid-area: checkbox;
                width: var(--x-pp-checkbox-size);
                height: var(--x-pp-checkbox-size);
            }

            ._2rttc.DBosH > .fLJIa,
            ._2rttc > .fLJIa,
            .fLJIa {
                -ms-grid-row: 1;
                -ms-grid-column: 1;
            }

            ._3tLN9 {
                --input-border-color: var(--x-pp-default-color-border);
                --input-border-radius: var(
                    --x-pp-checkbox-border-radius,
                    var(
                        --x-pp-control-border-radius,
                        var(--x-pp-global-border-radius)
                    )
                );
                background-clip: padding-box;
                border: 1px solid transparent;
                border-radius: var(--input-border-radius);
                box-sizing: content-box;
                cursor: pointer;
                box-shadow: 0 0 0 1px var(--input-border-color) inset;
                outline: none;
            }

            ._3tLN9,
            ._3tLN9:before {
                display: block;
                width: 100%;
                height: 100%;
                transition: box-shadow var(--x-pp-duration-base)
                    var(--x-pp-timing-ease-out);
            }

            ._3tLN9:before {
                content: "";
                border-radius: calc(var(--input-border-radius) / 2);
                pointer-events: none;
                box-shadow: 0 0 0 0 var(--x-pp-color-interactive-text) inset,
                    0 0 0 0 var(--x-pp-color-interactive-text);
                opacity: 0.3;
            }

            ._3tLN9:active,
            ._3tLN9:focus {
                box-shadow: 0 0 0 1px var(--x-pp-color-interactive-text) inset;
            }

            ._3tLN9:active:before,
            ._3tLN9:focus:before {
                box-shadow: 0 0 0 0.07142857142857142em
                        var(--x-pp-color-interactive-text) inset,
                    0 0 0 0.21428571428571427em
                        var(--x-pp-color-interactive-text);
            }

            ._3tLN9:checked {
                box-shadow: 0 0 0 0.7142857142857143em
                    var(--x-pp-color-interactive-text) inset;
            }

            ._3tLN9:checked + ._1rnqy {
                opacity: 1;
            }

            ._3tLN9.q92OK:not(:checked) {
                box-shadow: 0 0 0 0.14285714285714285em
                    var(--x-pp-color-critical-accent) inset;
            }

            ._3tLN9.q92OK:not(:checked):active:before,
            ._3tLN9.q92OK:not(:checked):focus:before {
                box-shadow: 0 0 0 0.07142857142857142em
                        var(--x-pp-color-critical-accent) inset,
                    0 0 0 0.21428571428571427em
                        var(--x-pp-color-critical-accent);
            }

            ._3_LmF {
                background-color: transparent;
            }

            ._3PQKg {
                background-color: var(--x-pp-color-surface-primary);
            }

            ._2JcaY,
            ._3PQKg {
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-secondary-accent
                );
            }

            ._2JcaY {
                background-color: var(--x-pp-color-surface-secondary);
            }

            ._1Eren {
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-tertiary-accent
                );
                background-color: var(--x-pp-color-surface-tertiary);
            }

            ._1YdKD {
                --input-border-color: var(
                    --x-pp-default-color-border-emphasized
                );
            }

            ._3Up4g {
                opacity: 0.7;
                cursor: default;
            }

            ._3Up4g:before {
                display: none;
            }

            ._3Up4g._3PQKg {
                background-color: var(--x-pp-color-surface-primary-disabled);
            }

            ._3Up4g._2JcaY {
                background-color: var(--x-pp-color-surface-secondary-disabled);
            }

            ._3Up4g._1Eren {
                background-color: var(--x-pp-color-surface-tertiary-disabled);
            }

            ._1QVwD {
                display: block;
                max-width: 100%;
                cursor: pointer;
                grid-area: label;
            }

            ._1QVwD,
            ._2rttc.DBosH > ._1QVwD,
            ._2rttc > ._1QVwD {
                -ms-grid-row: 1;
                -ms-grid-column: 3;
            }

            ._3MFyE {
                cursor: default;
            }

            ._7RhSW {
                -ms-grid-row: 3;
                -ms-grid-column: 1;
                -ms-grid-column-span: 3;
                grid-area: error;
            }

            ._2rttc.DBosH > ._7RhSW {
                -ms-grid-row: 3;
                -ms-grid-column: 3;
                -ms-grid-column-span: 1;
            }

            ._1rnqy {
                color: var(--x-pp-color-interactive-icon);
                pointer-events: none;
                opacity: 0;
                transform-origin: center;
                transform: translate(-50%, -50%);
                position: absolute;
                top: calc(50% + 1px);
                left: calc(50% + 1px);
                transition: all var(--x-pp-duration-base)
                    var(--x-pp-timing-base) 0.1s;
            }

            ._3h-M4 {
                color: var(--x-pp-color-critical-accent);
            }

            .N0j18 {
                position: absolute !important;
                top: 0;
                clip: rect(1px, 1px, 1px, 1px) !important;
                overflow: hidden !important;
                height: 1px !important;
                width: 1px !important;
                padding: 0 !important;
                border: 0 !important;
            }

            ._1hhfW {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                inset: 0;
                background-color: rgba(0, 0, 0, 0.6);
                -webkit-backdrop-filter: blur(6px);
                backdrop-filter: blur(6px);
            }

            ._1F5Ss,
            ._1hhfW {
                opacity: 0;
                transition: opacity var(--x-pp-duration-slow)
                    var(--x-pp-timing-base);
            }

            ._1F5Ss._1f8VE,
            ._1hhfW._1f8VE {
                opacity: 1;
            }

            ._1UXPx {
                position: fixed;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                inset: 0;
                z-index: 1001;
                display: flex;
                overflow: auto;
                padding: var(--x-pp-spacing-loose4x);
            }

            @media screen and (max-width: 1000px) {
                ._1UXPx {
                    padding: 0;
                }
            }

            ._1F5Ss {
                --x-pp-default-color: var(--x-pp-color-surface-primary);
                --x-pp-default-color-subdued: var(
                    --x-pp-color-surface-primary-subdued
                );
                --x-pp-default-color-border: var(
                    --x-pp-color-surface-primary-border
                );
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-surface-primary-border-emphasized
                );
                --x-pp-default-color-text: var(
                    --x-pp-color-surface-primary-text
                );
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-primary-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-surface-primary-text-emphasized
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-primary-accent
                );
                position: relative;
                display: flex;
                flex-direction: column;
                width: 100%;
                max-width: var(--x-pp-modal-max-width);
                margin: auto;
                border-radius: var(--x-pp-border-radius-base);
                overflow: hidden;
                box-shadow: 0 5px 30px rgba(0, 0, 0, 0.2);
                background-color: var(--x-pp-color-surface-primary);
                color: var(--x-pp-color-surface-primary-text);
            }

            @media screen and (max-width: 1000px) {
                ._1F5Ss {
                    max-width: 100% !important;
                    height: 100%;
                    border-radius: 0;
                }

                ._1F5Ss .P9T92 {
                    flex: 1;
                    -webkit-overflow-scrolling: touch;
                }
            }

            .PQhtQ {
                height: 100%;
            }

            .PQhtQ ._3nZnh {
                flex: 1;
            }

            ._3nZnh {
                display: block;
                border: none;
                margin: var(--x-pp-spacing-base);
            }

            @media screen and (max-width: 1000px) {
                ._3nZnh {
                    margin: var(--x-pp-spacing-base) var(--x-pp-spacing-loose2x);
                }
            }

            ._3swGq {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: var(--x-pp-spacing-base);
                border-bottom: 1px solid var(--x-pp-default-color-border);
            }

            @media screen and (max-width: 1000px) {
                ._3swGq {
                    padding: var(--x-pp-spacing-base)
                        var(--x-pp-spacing-loose2x);
                }
            }

            .P9T92 {
                padding: var(--x-pp-spacing-base);
                overflow: auto;
            }

            @media screen and (max-width: 1000px) {
                .P9T92 {
                    padding: var(--x-pp-spacing-loose2x);
                }
            }

            ._3y2iy {
                display: block;
                padding: var(--x-pp-spacing-tight1x);
                margin: calc(var(--x-pp-spacing-tight1x) * -1);
            }

            ._3H-DD {
                color: var(--x-pp-default-color-text);
            }

            ._1pJNB {
                position: fixed;
                pointer-events: none;
                opacity: 0;
            }

            ._1UO-b {
                padding: var(--x-pp-spacing-loose);
            }

            ._38OUb {
                border-top: 1px solid var(--x-pp-default-color-border);
                border-bottom: 1px solid var(--x-pp-default-color-border);
            }

            ._25qVr {
                --x-pp-default-color-border: var(
                    --x-pp-color-surface-secondary-border
                );
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-surface-secondary-border-emphasized
                );
                --x-pp-default-color-text: var(
                    --x-pp-color-surface-secondary-text
                );
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-secondary-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-surface-secondary-text-emphasized
                );
                background-color: var(--x-pp-color-surface-secondary);
                color: var(--x-pp-default-color-text, inherit);
            }

            .IRTXs {
                background-color: transparent;
            }

            ._3M6fc {
                display: contents;
            }

            .LeGJ9 {
                --form-layout-group-spacing: var(--x-pp-spacing-base);
                display: flex;
            }

            @media (min-width: 750px) {
                .LeGJ9 > * {
                    flex: 1 1 0;
                }

                [dir="ltr"] .LeGJ9 > * + * {
                    margin-left: var(--form-layout-group-spacing);
                }

                .LeGJ9 > * + :dir(ltr) {
                    margin-left: var(--form-layout-group-spacing);
                }

                [dir="rtl"] .LeGJ9 > * + * {
                    margin-right: var(--form-layout-group-spacing);
                }

                .LeGJ9 > * + :dir(rtl) {
                    margin-right: var(--form-layout-group-spacing);
                }

                .LeGJ9 > * + * {
                    margin-inline-start: var(--form-layout-group-spacing);
                }
            }

            @media (max-width: 749px) {
                .LeGJ9 {
                    flex-direction: column;
                }

                .LeGJ9 > * + * {
                    margin-top: var(--form-layout-group-spacing);
                }
            }

            ._18ZVi {
                --form-layout-group-spacing: var(--x-pp-spacing-tight1x);
            }

            ._2Tcm5 {
                max-width: 100%;
            }

            ._2yVre {
                border: 1px solid var(--x-pp-default-color-border);
            }

            .k6vSC {
                position: relative;
            }

            .k6vSC ._2Tcm5 {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
            }

            @supports (object-fit: cover) {
                ._1h6pI {
                    object-fit: contain;
                }

                ._4xYGh {
                    object-fit: cover;
                }
            }

            ._11iiE {
                display: flex;
                height: 100%;
                align-items: flex-start;
                justify-content: center;
            }

            ._1CYnU {
                align-items: flex-end;
            }

            ._2l8fS {
                align-items: center;
            }

            .KwTs0 {
                justify-content: flex-start;
            }

            .yxH-U {
                justify-content: flex-end;
            }

            ._2Q-zx {
                display: flex;
                align-items: flex-start;
                justify-content: center;
                width: 100%;
            }

            ._2Q-zx > * {
                flex: 0 1 auto;
            }

            .AqUP3 {
                justify-content: flex-start;
            }

            .oygx- {
                justify-content: flex-end;
            }

            .xOx3E {
                display: grid;
                justify-content: start;
                grid-template:
                    "radio gap label" auto/auto var(--x-pp-spacing-tight1x)
                    auto;
            }

            ._2R2IZ {
                -ms-grid-row: 1;
                -ms-grid-column: 1;
                grid-area: radio;
                position: relative;
            }

            .f47SL {
                --input-border-color: var(--x-pp-default-color-border);
                background-clip: padding-box;
                border: 1px var(--input-border-color) solid;
                border-radius: 50%;
                box-sizing: border-box;
                cursor: pointer;
                display: block;
                outline: none;
                transition: all var(--x-pp-duration-fast)
                    var(--x-pp-timing-ease-out);
            }

            .f47SL:before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                border-radius: 50%;
                display: block;
                pointer-events: none;
                box-shadow: 0 0 0 0 var(--input-checked-color);
                opacity: 0.3;
                transition: box-shadow var(--x-pp-duration-fast)
                    var(--x-pp-timing-ease-out);
            }

            .f47SL:active,
            .f47SL:focus {
                border-color: var(--input-checked-color);
            }

            .f47SL:active:before,
            .f47SL:focus:before {
                box-shadow: 0 0 0 0.21428571428571427em
                    var(--input-checked-color);
            }

            ._2dPVE,
            ._2dPVE:after,
            ._2dPVE:before {
                width: var(--x-pp-radio-size-base);
                height: var(--x-pp-radio-size-base);
            }

            ._2c6zX,
            ._2c6zX:after,
            ._2c6zX:before {
                margin-top: -2px;
                margin-bottom: -2px;
                margin-block: -2px;
                width: var(--x-pp-radio-size-large);
                height: var(--x-pp-radio-size-large);
            }

            ._203j-:checked {
                border: 0.42857142857142855em var(--input-checked-color) solid;
            }

            .rESQH:after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                border-radius: 50%;
                display: block;
                pointer-events: none;
                background-clip: padding-box;
                border: 0.2857142857142857em solid transparent;
                background-color: var(--input-checked-color);
                transform: scale(0);
                transition: transform var(--x-pp-duration-fast)
                    var(--x-pp-timing-ease-out);
            }

            .rESQH:checked:after {
                transform: scale(1);
            }

            .pgbpS {
                --input-checked-color: var(--x-pp-color-interactive-text);
            }

            ._14V8P {
                --input-checked-color: var(--x-pp-color-primary-action);
            }

            ._1Uuv0 {
                opacity: 0.7;
                cursor: default;
            }

            ._1Uuv0:before {
                display: none;
            }

            ._1Uuv0.cikI_ {
                background-color: var(--x-pp-color-surface-primary-disabled);
            }

            ._1Uuv0._3t0Do {
                background-color: var(--x-pp-color-surface-secondary-disabled);
            }

            ._1Uuv0._3qaGi {
                background-color: var(--x-pp-color-surface-tertiary-disabled);
            }

            ._1L2sz {
                background-color: transparent;
            }

            .cikI_ {
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-primary-accent
                );
                background-color: var(--x-pp-color-surface-primary);
            }

            ._3t0Do {
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-secondary-accent
                );
                background-color: var(--x-pp-color-surface-secondary);
            }

            ._3qaGi {
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-tertiary-accent
                );
                background-color: var(--x-pp-color-surface-tertiary);
            }

            .vm4j6 {
                --input-border-color: var(
                    --x-pp-default-color-border-emphasized
                );
            }

            .qETLw {
                -ms-grid-row: 1;
                -ms-grid-column: 3;
                display: block;
                grid-area: label;
                cursor: pointer;
            }

            ._18GtY {
                cursor: default;
            }

            ._3AzXF {
                --selector-width: 2.857142857142857em;
                position: relative;
            }

            ._2zgRv {
                transition: top var(--x-pp-duration-base)
                    var(--x-pp-timing-base);
            }

            [dir="ltr"] ._1Wz50 {
                left: 0.8571428571428571em;
            }

            ._1Wz50:dir(ltr) {
                left: 0.8571428571428571em;
            }

            [dir="rtl"] ._1Wz50 {
                right: 0.8571428571428571em;
            }

            ._1Wz50:dir(rtl) {
                right: 0.8571428571428571em;
            }

            ._1Wz50 {
                position: absolute;
                pointer-events: none;
                top: 0.39999999999999997em;
                inset-inline-start: 0.8571428571428571em;
                -webkit-user-select: none;
                user-select: none;
                max-width: calc(
                    100% - 1.85714em -
                        var(--selector-width, 2.857142857142857em)
                );
            }

            ._1Wz50._3JwxB {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-primary-text-subdued
                );
            }

            ._1Wz50.n5CW- {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-secondary-text-subdued
                );
            }

            ._1Wz50._1IK-E {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-tertiary-text-subdued
                );
            }

            ._12SON {
                display: block;
                margin-bottom: var(--x-pp-spacing-tight4x);
            }

            ._3xNc7 {
                top: 1.0714285714285714em;
            }

            [dir="ltr"] ._3P_az {
                padding-left: 0.8571428571428571em;
                padding-right: var(--selector-width, 2.857142857142857em);
            }

            ._3P_az:dir(ltr) {
                padding-left: 0.8571428571428571em;
                padding-right: var(--selector-width, 2.857142857142857em);
            }

            [dir="rtl"] ._3P_az {
                padding-right: 0.8571428571428571em;
                padding-left: var(--selector-width, 2.857142857142857em);
            }

            ._3P_az:dir(rtl) {
                padding-right: 0.8571428571428571em;
                padding-left: var(--selector-width, 2.857142857142857em);
            }

            ._3P_az {
                -webkit-tap-highlight-color: transparent;
                border: 0 solid transparent;
                border-radius: var(
                    --x-pp-select-border-radius,
                    var(
                        --x-pp-control-border-radius,
                        var(--x-pp-global-border-radius)
                    )
                );
                font-size: var(--x-pp-typography-size-default);
                line-height: inherit;
                outline: none;
                padding-top: 1.5em;
                padding-bottom: 0.42857142857142855em;
                padding-block: 1.5em 0.42857142857142855em;
                padding-inline: 0.8571428571428571em
                    var(--selector-width, 2.857142857142857em);
                min-height: 3.357142857142857em;
                transition: box-shadow var(--x-pp-duration-base)
                        var(--x-pp-timing-base),
                    border var(--x-pp-duration-base) var(--x-pp-timing-base);
                text-transform: var(--x-pp-global-typography-letter-case);
                letter-spacing: var(--x-pp-global-typography-kerning);
                width: 100%;
                white-space: nowrap;
            }

            ._3P_az::-ms-expand {
                display: none;
            }

            ._3P_az:-moz-focusring {
                color: transparent;
                text-shadow: 0 0 0 var(--moz-focusring-color);
            }

            @supports (-moz-appearance: meterbar) {
                ._3P_az {
                    text-indent: -2px;
                }
            }

            ._1G7-0 {
                padding-top: 1em;
                padding-bottom: 0.9285714285714286em;
            }

            ._1VzHv {
                min-height: auto;
                padding-top: 0;
                padding-bottom: 0;
            }

            ._29PLd {
                --moz-focusring-color: var(
                    --x-pp-default-color-text-emphasized
                );
                background-color: transparent;
            }

            ._2efuY {
                --moz-focusring-color: var(
                    --x-pp-color-surface-primary-text-emphasized
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-primary-accent
                );
                color: var(--x-pp-color-surface-primary-text-emphasized);
                background-color: var(--x-pp-color-surface-primary);
            }

            ._2efuY + ._2weOU {
                border-color: var(--x-pp-color-surface-primary-border);
                color: var(--x-pp-color-surface-primary-text-subdued);
            }

            ._2efuY + ._2weOU.g-jbP {
                border-color: var(
                    --x-pp-color-surface-primary-border-emphasized
                );
            }

            ._3nYYs {
                --moz-focusring-color: var(
                    --x-pp-color-surface-secondary-text-emphasized
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-secondary-accent
                );
                color: var(--x-pp-color-surface-secondary-text-emphasized);
                background-color: var(--x-pp-color-surface-secondary);
            }

            ._3nYYs + ._2weOU {
                border-color: var(--x-pp-color-surface-secondary-border);
                color: var(--x-pp-color-surface-secondary-text-subdued);
            }

            ._3nYYs + ._2weOU.g-jbP {
                border-color: var(
                    --x-pp-color-surface-secondary-border-emphasized
                );
            }

            ._1Nagt {
                --moz-focusring-color: var(
                    --x-pp-color-surface-tertiary-text-emphasized
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-tertiary-accent
                );
                color: var(--x-pp-color-surface-tertiary-text-emphasized);
                background-color: var(--x-pp-color-surface-tertiary);
            }

            ._1Nagt + ._2weOU {
                border-color: var(--x-pp-color-surface-tertiary-border);
                color: var(--x-pp-color-surface-tertiary-text-subdued);
            }

            ._1Nagt + ._2weOU.g-jbP {
                border-color: var(
                    --x-pp-color-surface-tertiary-border-emphasized
                );
            }

            ._25FDt._2jofo:focus {
                box-shadow: 0 0 0 2px var(--x-pp-color-interactive-text);
            }

            ._25FDt._2jofo.ITjta,
            ._25FDt._2jofo.ITjta:focus {
                box-shadow: 0 0 0 2px var(--x-pp-color-critical-accent);
            }

            ._25FDt._1dfOg:focus {
                box-shadow: 0 2px 0 0 var(--x-pp-color-interactive-text);
            }

            ._25FDt._1dfOg.ITjta,
            ._25FDt._1dfOg.ITjta:focus {
                box-shadow: 0 2px 0 0 var(--x-pp-color-critical-accent);
            }

            [dir="ltr"] ._1BCLF {
                padding-left: 0.7857142857142857em;
            }

            ._1BCLF:dir(ltr) {
                padding-left: 0.7857142857142857em;
            }

            [dir="rtl"] ._1BCLF {
                padding-right: 0.7857142857142857em;
            }

            ._1BCLF:dir(rtl) {
                padding-right: 0.7857142857142857em;
            }

            ._1BCLF {
                border-width: 1px;
                border-color: var(--x-pp-default-color-border);
                padding-inline-start: 0.7857142857142857em;
            }

            ._1BCLF._2jofo:focus {
                border-color: var(--x-pp-color-interactive-text);
                box-shadow: 0 0 0 1px var(--x-pp-color-interactive-text);
            }

            ._1BCLF._2jofo.ITjta,
            ._1BCLF._2jofo.ITjta:focus {
                border-color: var(--x-pp-color-critical-accent);
                box-shadow: 0 0 0 1px var(--x-pp-color-critical-accent);
            }

            ._1BCLF._1dfOg:focus {
                border-bottom-color: var(--x-pp-color-interactive-text);
                box-shadow: 0 1px 0 0 var(--x-pp-color-interactive-text);
            }

            ._1BCLF._1dfOg.ITjta,
            ._1BCLF._1dfOg.ITjta:focus {
                border-bottom-color: var(--x-pp-color-critical-accent);
                box-shadow: 0 1px 0 0 var(--x-pp-color-critical-accent);
            }

            ._3DSNW {
                border-width: 0 0 1px;
                border-color: var(--x-pp-default-color-border);
            }

            ._3DSNW._2jofo:focus {
                border-color: var(--x-pp-color-interactive-text);
                box-shadow: 1px 0 0 1px var(--x-pp-color-interactive-text),
                    -1px 0 0 1px var(--x-pp-color-interactive-text),
                    1px -1px 0 1px var(--x-pp-color-interactive-text),
                    -1px -1px 0 1px var(--x-pp-color-interactive-text);
            }

            ._3DSNW._2jofo.ITjta,
            ._3DSNW._2jofo.ITjta:focus {
                border-color: var(--x-pp-color-critical-accent);
                box-shadow: 1px 0 0 1px var(--x-pp-color-critical-accent),
                    -1px 0 0 1px var(--x-pp-color-critical-accent),
                    1px -1px 0 1px var(--x-pp-color-critical-accent),
                    -1px -1px 0 1px var(--x-pp-color-critical-accent);
            }

            ._3DSNW._1dfOg:focus {
                border-color: var(--x-pp-color-interactive-text);
                box-shadow: 0 1px 0 0 var(--x-pp-color-interactive-text);
            }

            ._3DSNW._1dfOg.ITjta,
            ._3DSNW._1dfOg.ITjta:focus {
                border-color: var(--x-pp-color-critical-accent);
                box-shadow: 0 1px 0 0 var(--x-pp-color-critical-accent);
            }

            ._3pgo0 {
                border-color: var(--x-pp-default-color-border-emphasized);
            }

            .prff4,
            .prff4 + ._2weOU {
                opacity: 0.7;
            }

            .prff4._2efuY {
                background-color: var(--x-pp-color-surface-primary-disabled);
            }

            .prff4._3nYYs {
                background-color: var(--x-pp-color-surface-secondary-disabled);
            }

            .prff4._1Nagt {
                background-color: var(--x-pp-color-surface-tertiary-disabled);
            }

            ._2qu2j,
            ._2qu2j + ._2weOU {
                opacity: 0.7;
            }

            ._2qu2j._2efuY {
                background-color: var(--x-pp-color-surface-primary-disabled);
            }

            ._2qu2j._3nYYs {
                background-color: var(--x-pp-color-surface-secondary-disabled);
            }

            ._2qu2j._1Nagt {
                background-color: var(--x-pp-color-surface-tertiary-disabled);
            }

            [dir="ltr"] ._2weOU {
                right: 1px;
            }

            ._2weOU:dir(ltr) {
                right: 1px;
            }

            [dir="rtl"] ._2weOU {
                left: 1px;
            }

            ._2weOU:dir(rtl) {
                left: 1px;
            }

            ._2weOU {
                position: absolute;
                top: 50%;
                inset-inline-end: 1px;
                display: flex;
                align-items: center;
                justify-content: center;
                pointer-events: none;
                width: var(--selector-width, 2.857142857142857em);
                height: 43%;
                transform: translateY(-50%);
            }

            [dir="ltr"] ._3m3mt {
                border-left-width: 0.1rem;
            }

            ._3m3mt:dir(ltr) {
                border-left-width: 0.1rem;
            }

            [dir="rtl"] ._3m3mt {
                border-right-width: 0.1rem;
            }

            ._3m3mt:dir(rtl) {
                border-right-width: 0.1rem;
            }

            [dir="ltr"] ._3m3mt {
                border-left-style: solid;
            }

            ._3m3mt:dir(ltr) {
                border-left-style: solid;
            }

            [dir="rtl"] ._3m3mt {
                border-right-style: solid;
            }

            ._3m3mt:dir(rtl) {
                border-right-style: solid;
            }

            ._3m3mt {
                border-inline-start-width: 0.1rem;
                border-inline-start-style: solid;
            }

            ._1bM0q {
                padding: 0 0.8571428571428571em;
            }

            ._2YaAO {
                font-size: var(--x-pp-typography-size-default);
                text-transform: var(--x-pp-global-typography-letter-case);
                letter-spacing: var(--x-pp-global-typography-kerning);
            }

            ._1Tomy {
                color: var(
                    --x-pp-default-color-text-subdued,
                    var(--x-pp-default-color-text, inherit)
                );
            }

            ._35JM8 {
                --this-font-weight: var(--x-pp-typography-primary-weight-bold);
                font-weight: var(--this-font-weight);
                color: var(
                    --x-pp-default-color-text-emphasized,
                    var(--x-pp-default-color-text, inherit)
                );
            }

            .AhUCt {
                color: var(--x-pp-default-color-accent);
            }

            ._21oEg {
                color: var(--x-pp-color-success-accent);
            }

            .ejXgY {
                color: var(--x-pp-color-warning-accent);
            }

            ._3q5hY {
                color: var(--x-pp-color-critical-accent);
            }

            ._3JRQX {
                --this-font-size: var(--x-pp-typography-size-xsmall);
            }

            ._3JRQX,
            ._5Ye68 {
                font-size: var(--this-font-size);
            }

            ._5Ye68 {
                --this-font-size: var(--x-pp-typography-size-small);
            }

            .xq3CF {
                --this-font-size: var(--x-pp-typography-size-medium);
            }

            .bwSls,
            .xq3CF {
                font-size: var(--this-font-size);
            }

            .bwSls {
                --this-font-size: var(--x-pp-typography-size-large);
            }

            ._2_NS0 {
                --this-font-size: var(--x-pp-typography-size-xlarge);
                font-size: var(--this-font-size);
            }

            ._1Dr6s {
                font-feature-settings: "kern" off;
                font-variant: none;
                text-decoration: none;
            }

            ._37dyE {
                display: block;
            }

            .PSpG1 {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .M6x6M {
                border: 0 solid var(--x-pp-default-color-border);
            }

            ._24GPq {
                height: 0;
                width: 100%;
            }

            ._24nLC {
                height: 100%;
                width: 0;
            }

            .-mqht {
                font-size: var(--x-pp-typography-size-default);
                line-height: var(--x-pp-global-typography-line-size-large);
                text-transform: var(--x-pp-global-typography-letter-case);
                letter-spacing: var(--x-pp-global-typography-kerning);
            }

            ._1SQTD {
                color: var(
                    --x-pp-default-color-text-subdued,
                    var(--x-pp-default-color-text, inherit)
                );
            }

            ._3dJen {
                --this-font-weight: var(--x-pp-typography-primary-weight-bold);
                font-weight: var(--this-font-weight);
                color: var(
                    --x-pp-default-color-text-emphasized,
                    var(--x-pp-default-color-text, inherit)
                );
            }

            ._29wEH {
                color: var(--x-pp-default-color-accent);
            }

            ._18pYO {
                color: var(--x-pp-color-success-accent);
            }

            .rJoht {
                color: var(--x-pp-color-warning-accent);
            }

            ._2rHoO {
                color: var(--x-pp-color-critical-accent);
            }

            .Lh5oQ {
                --this-font-size: var(--x-pp-typography-size-small);
            }

            ._3-vb1,
            .Lh5oQ {
                font-size: var(--this-font-size);
            }

            ._3-vb1 {
                --this-font-size: var(--x-pp-typography-size-medium);
            }

            ._2ciCG {
                --this-font-size: var(--x-pp-typography-size-large);
            }

            ._2ciCG,
            ._20BMk {
                font-size: var(--this-font-size);
            }

            ._20BMk {
                --this-font-size: var(--x-pp-typography-size-xlarge);
            }

            .c-d77 {
                position: relative;
            }

            .uakij {
                -webkit-tap-highlight-color: transparent;
                border: 0 solid transparent;
                border-radius: var(
                    --x-pp-text-field-border-radius,
                    var(
                        --x-pp-control-border-radius,
                        var(--x-pp-global-border-radius)
                    )
                );
                font-size: var(--x-pp-typography-size-default);
                outline: none;
                padding-left: 0.8571428571428571em;
                padding-right: 0.8571428571428571em;
                padding-inline: 0.8571428571428571em;
                min-height: 3.357142857142857em;
                transition: box-shadow var(--x-pp-duration-base)
                        var(--x-pp-timing-base),
                    border var(--x-pp-duration-base) var(--x-pp-timing-base);
                text-transform: var(--x-pp-global-typography-letter-case);
                letter-spacing: var(--x-pp-global-typography-kerning);
                width: 100%;
            }

            .uakij::placeholder {
                color: var(--placeholder-color);
                opacity: 1;
            }

            .uakij:invalid {
                box-shadow: none;
            }

            ._1EaLT {
                transition: all var(--x-pp-duration-base)
                    var(--x-pp-timing-base);
                padding-top: 1em;
            }

            [dir="ltr"] .o8JGk {
                padding-right: 3.142857142857143em;
            }

            .o8JGk:dir(ltr) {
                padding-right: 3.142857142857143em;
            }

            [dir="rtl"] .o8JGk {
                padding-left: 3.142857142857143em;
            }

            .o8JGk:dir(rtl) {
                padding-left: 3.142857142857143em;
            }

            .o8JGk {
                padding-inline-end: 3.142857142857143em;
            }

            ._3_7t_ {
                --placeholder-color: var(--x-pp-default-color-text-subdued);
                background-color: transparent;
            }

            ._1I2Yf {
                --placeholder-color: var(
                    --x-pp-color-surface-primary-text-subdued
                );
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-primary-text-subdued
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-primary-accent
                );
                color: var(--x-pp-color-surface-primary-text-emphasized);
                background-color: var(--x-pp-color-surface-primary);
            }

            ._1I2Yf + ._1g3v0 {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-primary-text-subdued
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-secondary-accent
                );
            }

            ._1AQ-6 {
                --placeholder-color: var(
                    --x-pp-color-surface-secondary-text-subdued
                );
                color: var(--x-pp-color-surface-secondary-text-emphasized);
                background-color: var(--x-pp-color-surface-secondary);
            }

            ._1AQ-6,
            ._1AQ-6 + ._1g3v0 {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-secondary-text-subdued
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-secondary-accent
                );
            }

            ._2R3OA {
                --placeholder-color: var(
                    --x-pp-color-surface-tertiary-text-subdued
                );
                color: var(--x-pp-color-surface-tertiary-text-emphasized);
                background-color: var(--x-pp-color-surface-tertiary);
            }

            ._2R3OA,
            ._2R3OA + ._1g3v0 {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-tertiary-text-subdued
                );
                --x-pp-default-color-accent: var(
                    --x-pp-color-surface-tertiary-accent
                );
            }

            .eXKs2._1gwaL:focus {
                box-shadow: 0 0 0 2px var(--x-pp-color-interactive-text);
            }

            .eXKs2._1gwaL._2S_qx,
            .eXKs2._1gwaL._2S_qx:focus {
                box-shadow: 0 0 0 2px var(--x-pp-color-critical-accent);
            }

            .eXKs2.M36tB:focus {
                box-shadow: 0 2px 0 0 var(--x-pp-color-interactive-text);
            }

            .eXKs2.M36tB._2S_qx,
            .eXKs2.M36tB._2S_qx:focus {
                box-shadow: 0 2px 0 0 var(--x-pp-color-critical-accent);
            }

            [dir="ltr"] ._23Lxz {
                padding-left: 0.7857142857142857em;
            }

            ._23Lxz:dir(ltr) {
                padding-left: 0.7857142857142857em;
            }

            [dir="rtl"] ._23Lxz {
                padding-right: 0.7857142857142857em;
            }

            ._23Lxz:dir(rtl) {
                padding-right: 0.7857142857142857em;
            }

            ._23Lxz {
                border-width: 1px;
                border-color: var(--x-pp-default-color-border);
                padding-inline-start: 0.7857142857142857em;
            }

            ._23Lxz._1gwaL:focus {
                border-color: var(--x-pp-color-interactive-text);
                box-shadow: 0 0 0 1px var(--x-pp-color-interactive-text);
            }

            ._23Lxz._1gwaL._2S_qx,
            ._23Lxz._1gwaL._2S_qx:focus {
                border-color: var(--x-pp-color-critical-accent);
                box-shadow: 0 0 0 1px var(--x-pp-color-critical-accent);
            }

            ._23Lxz.M36tB:focus {
                border-bottom-color: var(--x-pp-color-interactive-text);
                box-shadow: 0 1px 0 0 var(--x-pp-color-interactive-text);
            }

            ._23Lxz.M36tB._2S_qx,
            ._23Lxz.M36tB._2S_qx:focus {
                border-bottom-color: var(--x-pp-color-critical-accent);
                box-shadow: 0 1px 0 0 var(--x-pp-color-critical-accent);
            }

            ._2Z1Ly {
                border-width: 0 0 1px;
                border-color: var(--x-pp-default-color-border);
            }

            ._2Z1Ly._1gwaL:focus {
                border-color: var(--x-pp-color-interactive-text);
                box-shadow: 1px 0 0 1px var(--x-pp-color-interactive-text),
                    -1px 0 0 1px var(--x-pp-color-interactive-text),
                    1px -1px 0 1px var(--x-pp-color-interactive-text),
                    -1px -1px 0 1px var(--x-pp-color-interactive-text);
            }

            ._2Z1Ly._1gwaL._2S_qx,
            ._2Z1Ly._1gwaL._2S_qx:focus {
                border-color: var(--x-pp-color-critical-accent);
                box-shadow: 1px 0 0 1px var(--x-pp-color-critical-accent),
                    -1px 0 0 1px var(--x-pp-color-critical-accent),
                    1px -1px 0 1px var(--x-pp-color-critical-accent),
                    -1px -1px 0 1px var(--x-pp-color-critical-accent);
            }

            ._2Z1Ly.M36tB:focus {
                border-color: var(--x-pp-color-interactive-text);
                box-shadow: 0 1px 0 0 var(--x-pp-color-interactive-text);
            }

            ._2Z1Ly.M36tB._2S_qx,
            ._2Z1Ly.M36tB._2S_qx:focus {
                border-color: var(--x-pp-color-critical-accent);
                box-shadow: 0 1px 0 0 var(--x-pp-color-critical-accent);
            }

            ._2IFaE {
                border-color: var(--x-pp-default-color-border-emphasized);
            }

            [dir="ltr"] ._1g3v0 {
                right: var(--x-pp-spacing-base);
            }

            ._1g3v0:dir(ltr) {
                right: var(--x-pp-spacing-base);
            }

            [dir="rtl"] ._1g3v0 {
                left: var(--x-pp-spacing-base);
            }

            ._1g3v0:dir(rtl) {
                left: var(--x-pp-spacing-base);
            }

            ._1g3v0 {
                position: absolute;
                top: 50%;
                inset-inline-end: var(--x-pp-spacing-base);
                transform: translateY(-50%);
                z-index: 1;
            }

            ._1iYSC {
                padding: 0 0.8571428571428571em;
            }

            ._1KhQu {
                opacity: 0.7;
            }

            ._1KhQu._1I2Yf {
                background-color: var(--x-pp-color-surface-primary-disabled);
            }

            ._1KhQu._1AQ-6 {
                background-color: var(--x-pp-color-surface-secondary-disabled);
            }

            ._1KhQu._2R3OA {
                background-color: var(--x-pp-color-surface-tertiary-disabled);
            }

            ._196m0 {
                opacity: 0.7;
            }

            ._196m0._1I2Yf {
                background-color: var(--x-pp-color-surface-primary-disabled);
            }

            ._196m0._1AQ-6 {
                background-color: var(--x-pp-color-surface-secondary-disabled);
            }

            ._196m0._2R3OA {
                background-color: var(--x-pp-color-surface-tertiary-disabled);
            }

            ._3Rqhu {
                position: relative;
            }

            ._2UUv7 {
                -webkit-tap-highlight-color: transparent;
                display: block;
                padding: 0.9285714285714286em 0.9285714285714286em;
                margin: -0.9285714285714286em -0.9285714285714286em;
            }

            ._1MTsE {
                transform: scale(0.8);
                transform-origin: center 120%;
                display: inline-block;
                color: var(--pp-color--white);
                max-width: 12.857142857142858em;
                padding: var(--x-pp-spacing-tight);
                opacity: 0;
                transition: transform var(--x-pp-duration-base)
                        var(--x-pp-timing-spring),
                    opacity var(--x-pp-duration-base) var(--x-pp-timing-spring);
            }

            ._1MTsE._2PXbr {
                transform: scale(1) perspective(1px);
                opacity: 1;
            }

            ._1MTsE._1HPcg,
            ._1MTsE._3Xjhr {
                pointer-events: none;
            }

            ._1MTsE:before {
                content: "";
                position: absolute;
                z-index: -1;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                display: block;
                background-color: #333;
            }

            ._3_I_b {
                position: absolute;
                top: 100%;
                left: 50%;
                right: 50%;
                width: 0;
                border: 0.42857142857142855em solid transparent;
                border-top-color: #333;
            }

            [dir="rtl"] ._3_I_b {
                transform: translate(50%);
            }

            ._3_I_b:dir(rtl) {
                transform: translate(50%);
            }

            [dir="ltr"] ._3_I_b {
                transform: translate(-50%);
            }

            ._3_I_b:dir(ltr) {
                transform: translate(-50%);
            }

            ._1e8tT {
                color: var(--x-pp-color-surface-primary-text);
            }

            ._1e8tT:before {
                background-color: var(--x-pp-color-surface-primary);
            }

            ._1e8tT ._3_I_b {
                border-top-color: var(--x-pp-color-surface-primary);
            }

            ._1WULY {
                color: var(--x-pp-color-surface-secondary-text);
            }

            ._1WULY:before {
                background-color: var(--x-pp-color-surface-secondary);
            }

            ._1WULY ._3_I_b {
                border-top-color: var(--x-pp-color-surface-secondary);
            }

            .RDaxq {
                color: var(--x-pp-color-surface-tertiary-text);
            }

            .RDaxq:before {
                background-color: var(--x-pp-color-surface-tertiary);
            }

            .RDaxq ._3_I_b {
                border-top-color: var(--x-pp-color-surface-tertiary);
            }

            ._1IXIn ._3_I_b,
            ._1IXIn:before {
                opacity: 0.9;
            }

            ._28ruO:before ._3_I_b,
            ._28ruO:before:before {
                opacity: 1;
            }

            ._1B8CA:before {
                border-radius: var(--x-pp-border-radius-none);
            }

            .O0yc_:before {
                border-radius: var(--x-pp-border-radius-tight);
            }

            ._1lTDj:before {
                border-radius: var(--x-pp-border-radius-base);
            }

            .ajbes:before {
                border-radius: var(--x-pp-border-radius-fully-rounded);
            }

            ._1tlS- {
                position: absolute;
                z-index: 1000;
                top: 0;
                left: 0;
            }

            ._3B8VV {
                position: relative;
            }

            [dir="ltr"] ._2I9qS {
                left: 0.8571428571428571em;
            }

            ._2I9qS:dir(ltr) {
                left: 0.8571428571428571em;
            }

            [dir="rtl"] ._2I9qS {
                right: 0.8571428571428571em;
            }

            ._2I9qS:dir(rtl) {
                right: 0.8571428571428571em;
            }

            ._2I9qS {
                position: absolute;
                pointer-events: none;
                top: 0.39999999999999997em;
                inset-inline-start: 0.8571428571428571em;
                transition: all var(--x-pp-duration-base)
                    var(--x-pp-timing-base);
                -webkit-user-select: none;
                user-select: none;
                opacity: 0;
                z-index: 1;
                max-width: calc(100% - 1.85714em);
            }

            ._2I9qS.ZQecr {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-primary-text-subdued
                );
            }

            ._2I9qS._3LiY6 {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-secondary-text-subdued
                );
            }

            ._2I9qS._2OzAD {
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-surface-tertiary-text-subdued
                );
            }

            ._1P0tw {
                z-index: inherit;
            }

            ._2LUgj {
                display: block;
                margin-bottom: var(--x-pp-spacing-tight4x);
            }

            ._34Rev ._2biHt {
                opacity: 1;
            }

            [dir="ltr"] ._19IUq {
                margin-left: calc(var(--x-pp-spacing-base) * -1);
            }

            ._19IUq:dir(ltr) {
                margin-left: calc(var(--x-pp-spacing-base) * -1);
            }

            [dir="rtl"] ._19IUq {
                margin-right: calc(var(--x-pp-spacing-base) * -1);
            }

            ._19IUq:dir(rtl) {
                margin-right: calc(var(--x-pp-spacing-base) * -1);
            }

            ._19IUq {
                display: flex;
                flex-wrap: wrap;
                margin-top: calc(var(--x-pp-spacing-base) * -1);
                margin-inline-start: calc(var(--x-pp-spacing-base) * -1);
            }

            [dir="ltr"] ._19IUq > * {
                padding-left: var(--x-pp-spacing-base);
            }

            ._19IUq > :dir(ltr) {
                padding-left: var(--x-pp-spacing-base);
            }

            [dir="rtl"] ._19IUq > * {
                padding-right: var(--x-pp-spacing-base);
            }

            ._19IUq > :dir(rtl) {
                padding-right: var(--x-pp-spacing-base);
            }

            ._19IUq > * {
                min-width: var(--tile-width, 0);
                max-width: 100%;
                padding-top: var(--x-pp-spacing-base);
                padding-inline-start: var(--x-pp-spacing-base);
                flex: 0 0
                    calc(
                        (
                                var(--tiles-breakpoint, 0) +
                                    var(--x-pp-spacing-base) - 100%
                            ) * 999
                    );
            }

            [dir="ltr"] ._3Kpce {
                margin-left: 0;
            }

            ._3Kpce:dir(ltr) {
                margin-left: 0;
            }

            [dir="rtl"] ._3Kpce {
                margin-right: 0;
            }

            ._3Kpce:dir(rtl) {
                margin-right: 0;
            }

            ._3Kpce {
                margin-top: 0;
                margin-inline-start: 0;
            }

            [dir="ltr"] ._3Kpce > * {
                padding-left: 0;
            }

            ._3Kpce > :dir(ltr) {
                padding-left: 0;
            }

            [dir="rtl"] ._3Kpce > * {
                padding-right: 0;
            }

            ._3Kpce > :dir(rtl) {
                padding-right: 0;
            }

            ._3Kpce > * {
                padding-top: 0;
                padding-inline-start: 0;
                flex-basis: calc((var(--tiles-breakpoint, 0) - 100%) * 999);
            }

            [dir="ltr"] ._2KxEZ {
                margin-left: calc(var(--x-pp-spacing-tight4x) * -1);
            }

            ._2KxEZ:dir(ltr) {
                margin-left: calc(var(--x-pp-spacing-tight4x) * -1);
            }

            [dir="rtl"] ._2KxEZ {
                margin-right: calc(var(--x-pp-spacing-tight4x) * -1);
            }

            ._2KxEZ:dir(rtl) {
                margin-right: calc(var(--x-pp-spacing-tight4x) * -1);
            }

            ._2KxEZ {
                margin-top: calc(var(--x-pp-spacing-tight4x) * -1);
                margin-inline-start: calc(var(--x-pp-spacing-tight4x) * -1);
            }

            [dir="ltr"] ._2KxEZ > * {
                padding-left: var(--x-pp-spacing-tight4x);
            }

            ._2KxEZ > :dir(ltr) {
                padding-left: var(--x-pp-spacing-tight4x);
            }

            [dir="rtl"] ._2KxEZ > * {
                padding-right: var(--x-pp-spacing-tight4x);
            }

            ._2KxEZ > :dir(rtl) {
                padding-right: var(--x-pp-spacing-tight4x);
            }

            ._2KxEZ > * {
                padding-top: var(--x-pp-spacing-tight4x);
                padding-inline-start: var(--x-pp-spacing-tight4x);
                flex-basis: calc(
                    (
                            var(--tiles-breakpoint, 0) +
                                var(--x-pp-spacing-tight4x) - 100%
                        ) * 999
                );
            }

            [dir="ltr"] .pIuQE {
                margin-left: calc(var(--x-pp-spacing-tight1x) * -1);
            }

            .pIuQE:dir(ltr) {
                margin-left: calc(var(--x-pp-spacing-tight1x) * -1);
            }

            [dir="rtl"] .pIuQE {
                margin-right: calc(var(--x-pp-spacing-tight1x) * -1);
            }

            .pIuQE:dir(rtl) {
                margin-right: calc(var(--x-pp-spacing-tight1x) * -1);
            }

            .pIuQE {
                margin-top: calc(var(--x-pp-spacing-tight1x) * -1);
                margin-inline-start: calc(var(--x-pp-spacing-tight1x) * -1);
            }

            [dir="ltr"] .pIuQE > * {
                padding-left: var(--x-pp-spacing-tight1x);
            }

            .pIuQE > :dir(ltr) {
                padding-left: var(--x-pp-spacing-tight1x);
            }

            [dir="rtl"] .pIuQE > * {
                padding-right: var(--x-pp-spacing-tight1x);
            }

            .pIuQE > :dir(rtl) {
                padding-right: var(--x-pp-spacing-tight1x);
            }

            .pIuQE > * {
                padding-top: var(--x-pp-spacing-tight1x);
                padding-inline-start: var(--x-pp-spacing-tight1x);
                flex-basis: calc(
                    (
                            var(--tiles-breakpoint, 0) +
                                var(--x-pp-spacing-tight1x) - 100%
                        ) * 999
                );
            }

            [dir="ltr"] ._8-5ou {
                margin-left: calc(var(--x-pp-spacing-loose1x) * -1);
            }

            ._8-5ou:dir(ltr) {
                margin-left: calc(var(--x-pp-spacing-loose1x) * -1);
            }

            [dir="rtl"] ._8-5ou {
                margin-right: calc(var(--x-pp-spacing-loose1x) * -1);
            }

            ._8-5ou:dir(rtl) {
                margin-right: calc(var(--x-pp-spacing-loose1x) * -1);
            }

            ._8-5ou {
                margin-top: calc(var(--x-pp-spacing-loose1x) * -1);
                margin-inline-start: calc(var(--x-pp-spacing-loose1x) * -1);
            }

            [dir="ltr"] ._8-5ou > * {
                padding-left: var(--x-pp-spacing-loose1x);
            }

            ._8-5ou > :dir(ltr) {
                padding-left: var(--x-pp-spacing-loose1x);
            }

            [dir="rtl"] ._8-5ou > * {
                padding-right: var(--x-pp-spacing-loose1x);
            }

            ._8-5ou > :dir(rtl) {
                padding-right: var(--x-pp-spacing-loose1x);
            }

            ._8-5ou > * {
                padding-top: var(--x-pp-spacing-loose1x);
                padding-inline-start: var(--x-pp-spacing-loose1x);
                flex-basis: calc(
                    (
                            var(--tiles-breakpoint, 0) +
                                var(--x-pp-spacing-loose1x) - 100%
                        ) * 999
                );
            }

            [dir="ltr"] .BidyZ {
                margin-left: calc(var(--x-pp-spacing-loose4x) * -1);
            }

            .BidyZ:dir(ltr) {
                margin-left: calc(var(--x-pp-spacing-loose4x) * -1);
            }

            [dir="rtl"] .BidyZ {
                margin-right: calc(var(--x-pp-spacing-loose4x) * -1);
            }

            .BidyZ:dir(rtl) {
                margin-right: calc(var(--x-pp-spacing-loose4x) * -1);
            }

            .BidyZ {
                margin-top: calc(var(--x-pp-spacing-loose4x) * -1);
                margin-inline-start: calc(var(--x-pp-spacing-loose4x) * -1);
            }

            [dir="ltr"] .BidyZ > * {
                padding-left: var(--x-pp-spacing-loose4x);
            }

            .BidyZ > :dir(ltr) {
                padding-left: var(--x-pp-spacing-loose4x);
            }

            [dir="rtl"] .BidyZ > * {
                padding-right: var(--x-pp-spacing-loose4x);
            }

            .BidyZ > :dir(rtl) {
                padding-right: var(--x-pp-spacing-loose4x);
            }

            .BidyZ > * {
                padding-top: var(--x-pp-spacing-loose4x);
                padding-inline-start: var(--x-pp-spacing-loose4x);
                flex-basis: calc(
                    (
                            var(--tiles-breakpoint, 0) +
                                var(--x-pp-spacing-loose4x) - 100%
                        ) * 999
                );
            }

            ._2nNgM {
                align-items: flex-start;
            }

            ._2sJYg {
                align-items: center;
            }

            ._2BpWu {
                align-items: flex-end;
            }

            .MQKyT {
                align-items: baseline;
            }

            ._22J8L > * {
                flex-grow: 1;
            }

            ._35F0d > * {
                flex-basis: 0;
            }

            ._1TiSn {
                --x-pp-default-color-subdued: var(--x-pp-color-canvas-subdued);
                --x-pp-default-color-text: var(--x-pp-color-canvas-text);
                --x-pp-default-color-text-subdued: var(
                    --x-pp-color-canvas-text-subdued
                );
                --x-pp-default-color-text-emphasized: var(
                    --x-pp-color-canvas-text-emphasized
                );
                --x-pp-default-color-border: var(--x-pp-color-canvas-border);
                --x-pp-default-color-border-emphasized: var(
                    --x-pp-color-canvas-border-emphasized
                );
                --x-pp-default-color-accent: var(--x-pp-color-canvas-accent);
                --x-pp-default-color-disabled: var(
                    --x-pp-color-canvas-disabled
                );
                background: var(--x-pp-color-canvas);
                color: var(--x-pp-default-color-text);
                font-size: var(--x-pp-typography-size-default);
                font-family: var(--x-pp-typography-primary-fonts);
                font-weight: var(--x-pp-typography-primary-weight-base);
                line-height: var(--x-pp-global-typography-line-size-default);
                text-transform: var(--x-pp-global-typography-letter-case);
                touch-action: manipulation;
            }
            ._coop-extension-dummy-block {
				display: flex;
				justify-content: flex-end;
			}
			._coop-extension-dummy-block > span,
			._coop-extension-dummy-block > strong {
				width: 50px !important;
				height: 12px;
				background-color: rgba(0, 0, 0, 0.2);
				border-radius: 10px;
				display: block;
				color: transparent;
			}
        </style>
        <!--[if gte IE 9]><!-->
        <link
            rel="stylesheet"
            href="//cdn.shopify.com/app/services/55359111341/assets/120794906797/post_purchase_stylesheet/v2-ltr-edge-6cf0d0393005086f864bba4ca9b8def6-21"
            media="all"
        />
    </head>
    <body>
        <div class="checkout-zero" style="height: 60px"></div>
        <div class="step" data-step="post_purchase">
            <div data-serialized-id="post-purchase-page-data"></div>
            <div data-id="post-purchase-page-root">
                `;
export const RENDER_EXTENSION_BASE_FOOTER = `
            </div>
        </div>
    </body>
</html>
`;
export const RENDER_EXTENSION_PREVIEW = (children) =>
    `${RENDER_EXTENSION_BASE_HEADER}${children}${RENDER_EXTENSION_BASE_FOOTER}`;
